/* three.js r147 examples (MIT): Pass, CopyShader, LuminosityHighPassShader, UnrealBloomPass. meshoptimizer decoder (MIT, Arseny Kapoulkine). */
( function () {

	class Pass {

		constructor() {

			// if set to true, the pass is processed by the composer
			this.enabled = true;

			// if set to true, the pass indicates to swap read and write buffer after rendering
			this.needsSwap = true;

			// if set to true, the pass clears its buffer before rendering
			this.clear = false;

			// if set to true, the result of the pass is rendered to screen. This is set automatically by EffectComposer.
			this.renderToScreen = false;

		}
		setSize() {}
		render() {

			console.error( 'THREE.Pass: .render() must be implemented in derived pass.' );

		}
		dispose() {}

	}

	// Helper for passes that need to fill the viewport with a single quad.

	const _camera = new THREE.OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );

	// https://github.com/mrdoob/three.js/pull/21358

	const _geometry = new THREE.BufferGeometry();
	_geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( [ - 1, 3, 0, - 1, - 1, 0, 3, - 1, 0 ], 3 ) );
	_geometry.setAttribute( 'uv', new THREE.Float32BufferAttribute( [ 0, 2, 0, 0, 2, 0 ], 2 ) );
	class FullScreenQuad {

		constructor( material ) {

			this._mesh = new THREE.Mesh( _geometry, material );

		}
		dispose() {

			this._mesh.geometry.dispose();

		}
		render( renderer ) {

			renderer.render( this._mesh, _camera );

		}
		get material() {

			return this._mesh.material;

		}
		set material( value ) {

			this._mesh.material = value;

		}

	}

	THREE.FullScreenQuad = FullScreenQuad;
	THREE.Pass = Pass;

} )();

;
( function () {

	/**
 * Full-screen textured quad shader
 */

	const CopyShader = {
		uniforms: {
			'tDiffuse': {
				value: null
			},
			'opacity': {
				value: 1.0
			}
		},
		vertexShader: /* glsl */`

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,
		fragmentShader: /* glsl */`

		uniform float opacity;

		uniform sampler2D tDiffuse;

		varying vec2 vUv;

		void main() {

			gl_FragColor = texture2D( tDiffuse, vUv );
			gl_FragColor.a *= opacity;


		}`
	};

	THREE.CopyShader = CopyShader;

} )();

;
( function () {

	/**
 * Luminosity
 * http://en.wikipedia.org/wiki/Luminosity
 */

	const LuminosityHighPassShader = {
		shaderID: 'luminosityHighPass',
		uniforms: {
			'tDiffuse': {
				value: null
			},
			'luminosityThreshold': {
				value: 1.0
			},
			'smoothWidth': {
				value: 1.0
			},
			'defaultColor': {
				value: new THREE.Color( 0x000000 )
			},
			'defaultOpacity': {
				value: 0.0
			}
		},
		vertexShader: /* glsl */`

		varying vec2 vUv;

		void main() {

			vUv = uv;

			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,
		fragmentShader: /* glsl */`

		uniform sampler2D tDiffuse;
		uniform vec3 defaultColor;
		uniform float defaultOpacity;
		uniform float luminosityThreshold;
		uniform float smoothWidth;

		varying vec2 vUv;

		void main() {

			vec4 texel = texture2D( tDiffuse, vUv );

			vec3 luma = vec3( 0.299, 0.587, 0.114 );

			float v = dot( texel.xyz, luma );

			vec4 outputColor = vec4( defaultColor.rgb, defaultOpacity );

			float alpha = smoothstep( luminosityThreshold, luminosityThreshold + smoothWidth, v );

			gl_FragColor = mix( outputColor, texel, alpha );

		}`
	};

	THREE.LuminosityHighPassShader = LuminosityHighPassShader;

} )();

;
( function () {

	/**
 * UnrealBloomPass is inspired by the bloom pass of Unreal Engine. It creates a
 * mip map chain of bloom textures and blurs them with different radii. Because
 * of the weighted combination of mips, and because larger blurs are done on
 * higher mips, this effect provides good quality and performance.
 *
 * Reference:
 * - https://docs.unrealengine.com/latest/INT/Engine/Rendering/PostProcessEffects/Bloom/
 */
	class UnrealBloomPass extends THREE.Pass {

		constructor( resolution, strength, radius, threshold ) {

			super();
			this.strength = strength !== undefined ? strength : 1;
			this.radius = radius;
			this.threshold = threshold;
			this.resolution = resolution !== undefined ? new THREE.Vector2( resolution.x, resolution.y ) : new THREE.Vector2( 256, 256 );

			// create color only once here, reuse it later inside the render function
			this.clearColor = new THREE.Color( 0, 0, 0 );

			// render targets
			this.renderTargetsHorizontal = [];
			this.renderTargetsVertical = [];
			this.nMips = 5;
			let resx = Math.round( this.resolution.x / 2 );
			let resy = Math.round( this.resolution.y / 2 );
			this.renderTargetBright = new THREE.WebGLRenderTarget( resx, resy );
			this.renderTargetBright.texture.name = 'UnrealBloomPass.bright';
			this.renderTargetBright.texture.generateMipmaps = false;
			for ( let i = 0; i < this.nMips; i ++ ) {

				const renderTargetHorizonal = new THREE.WebGLRenderTarget( resx, resy );
				renderTargetHorizonal.texture.name = 'UnrealBloomPass.h' + i;
				renderTargetHorizonal.texture.generateMipmaps = false;
				this.renderTargetsHorizontal.push( renderTargetHorizonal );
				const renderTargetVertical = new THREE.WebGLRenderTarget( resx, resy );
				renderTargetVertical.texture.name = 'UnrealBloomPass.v' + i;
				renderTargetVertical.texture.generateMipmaps = false;
				this.renderTargetsVertical.push( renderTargetVertical );
				resx = Math.round( resx / 2 );
				resy = Math.round( resy / 2 );

			}

			// luminosity high pass material

			if ( THREE.LuminosityHighPassShader === undefined ) console.error( 'THREE.UnrealBloomPass relies on THREE.LuminosityHighPassShader' );
			const highPassShader = THREE.LuminosityHighPassShader;
			this.highPassUniforms = THREE.UniformsUtils.clone( highPassShader.uniforms );
			this.highPassUniforms[ 'luminosityThreshold' ].value = threshold;
			this.highPassUniforms[ 'smoothWidth' ].value = 0.01;
			this.materialHighPassFilter = new THREE.ShaderMaterial( {
				uniforms: this.highPassUniforms,
				vertexShader: highPassShader.vertexShader,
				fragmentShader: highPassShader.fragmentShader,
				defines: {}
			} );

			// Gaussian Blur Materials
			this.separableBlurMaterials = [];
			const kernelSizeArray = [ 3, 5, 7, 9, 11 ];
			resx = Math.round( this.resolution.x / 2 );
			resy = Math.round( this.resolution.y / 2 );
			for ( let i = 0; i < this.nMips; i ++ ) {

				this.separableBlurMaterials.push( this.getSeperableBlurMaterial( kernelSizeArray[ i ] ) );
				this.separableBlurMaterials[ i ].uniforms[ 'texSize' ].value = new THREE.Vector2( resx, resy );
				resx = Math.round( resx / 2 );
				resy = Math.round( resy / 2 );

			}

			// Composite material
			this.compositeMaterial = this.getCompositeMaterial( this.nMips );
			this.compositeMaterial.uniforms[ 'blurTexture1' ].value = this.renderTargetsVertical[ 0 ].texture;
			this.compositeMaterial.uniforms[ 'blurTexture2' ].value = this.renderTargetsVertical[ 1 ].texture;
			this.compositeMaterial.uniforms[ 'blurTexture3' ].value = this.renderTargetsVertical[ 2 ].texture;
			this.compositeMaterial.uniforms[ 'blurTexture4' ].value = this.renderTargetsVertical[ 3 ].texture;
			this.compositeMaterial.uniforms[ 'blurTexture5' ].value = this.renderTargetsVertical[ 4 ].texture;
			this.compositeMaterial.uniforms[ 'bloomStrength' ].value = strength;
			this.compositeMaterial.uniforms[ 'bloomRadius' ].value = 0.1;
			this.compositeMaterial.needsUpdate = true;
			const bloomFactors = [ 1.0, 0.8, 0.6, 0.4, 0.2 ];
			this.compositeMaterial.uniforms[ 'bloomFactors' ].value = bloomFactors;
			this.bloomTintColors = [ new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 1, 1, 1 ) ];
			this.compositeMaterial.uniforms[ 'bloomTintColors' ].value = this.bloomTintColors;

			// copy material
			if ( THREE.CopyShader === undefined ) {

				console.error( 'THREE.UnrealBloomPass relies on THREE.CopyShader' );

			}

			const copyShader = THREE.CopyShader;
			this.copyUniforms = THREE.UniformsUtils.clone( copyShader.uniforms );
			this.copyUniforms[ 'opacity' ].value = 1.0;
			this.materialCopy = new THREE.ShaderMaterial( {
				uniforms: this.copyUniforms,
				vertexShader: copyShader.vertexShader,
				fragmentShader: copyShader.fragmentShader,
				blending: THREE.AdditiveBlending,
				depthTest: false,
				depthWrite: false,
				transparent: true
			} );
			this.enabled = true;
			this.needsSwap = false;
			this._oldClearColor = new THREE.Color();
			this.oldClearAlpha = 1;
			this.basic = new THREE.MeshBasicMaterial();
			this.fsQuad = new THREE.FullScreenQuad( null );

		}
		dispose() {

			for ( let i = 0; i < this.renderTargetsHorizontal.length; i ++ ) {

				this.renderTargetsHorizontal[ i ].dispose();

			}

			for ( let i = 0; i < this.renderTargetsVertical.length; i ++ ) {

				this.renderTargetsVertical[ i ].dispose();

			}

			this.renderTargetBright.dispose();

			//

			for ( let i = 0; i < this.separableBlurMaterials.length; i ++ ) {

				this.separableBlurMaterials[ i ].dispose();

			}

			this.compositeMaterial.dispose();
			this.materialCopy.dispose();
			this.basic.dispose();

			//

			this.fsQuad.dispose();

		}
		setSize( width, height ) {

			let resx = Math.round( width / 2 );
			let resy = Math.round( height / 2 );
			this.renderTargetBright.setSize( resx, resy );
			for ( let i = 0; i < this.nMips; i ++ ) {

				this.renderTargetsHorizontal[ i ].setSize( resx, resy );
				this.renderTargetsVertical[ i ].setSize( resx, resy );
				this.separableBlurMaterials[ i ].uniforms[ 'texSize' ].value = new THREE.Vector2( resx, resy );
				resx = Math.round( resx / 2 );
				resy = Math.round( resy / 2 );

			}

		}
		render( renderer, writeBuffer, readBuffer, deltaTime, maskActive ) {

			renderer.getClearColor( this._oldClearColor );
			this.oldClearAlpha = renderer.getClearAlpha();
			const oldAutoClear = renderer.autoClear;
			renderer.autoClear = false;
			renderer.setClearColor( this.clearColor, 0 );
			if ( maskActive ) renderer.state.buffers.stencil.setTest( false );

			// Render input to screen

			if ( this.renderToScreen ) {

				this.fsQuad.material = this.basic;
				this.basic.map = readBuffer.texture;
				renderer.setRenderTarget( null );
				renderer.clear();
				this.fsQuad.render( renderer );

			}

			// 1. Extract Bright Areas

			this.highPassUniforms[ 'tDiffuse' ].value = readBuffer.texture;
			this.highPassUniforms[ 'luminosityThreshold' ].value = this.threshold;
			this.fsQuad.material = this.materialHighPassFilter;
			renderer.setRenderTarget( this.renderTargetBright );
			renderer.clear();
			this.fsQuad.render( renderer );

			// 2. Blur All the mips progressively

			let inputRenderTarget = this.renderTargetBright;
			for ( let i = 0; i < this.nMips; i ++ ) {

				this.fsQuad.material = this.separableBlurMaterials[ i ];
				this.separableBlurMaterials[ i ].uniforms[ 'colorTexture' ].value = inputRenderTarget.texture;
				this.separableBlurMaterials[ i ].uniforms[ 'direction' ].value = UnrealBloomPass.BlurDirectionX;
				renderer.setRenderTarget( this.renderTargetsHorizontal[ i ] );
				renderer.clear();
				this.fsQuad.render( renderer );
				this.separableBlurMaterials[ i ].uniforms[ 'colorTexture' ].value = this.renderTargetsHorizontal[ i ].texture;
				this.separableBlurMaterials[ i ].uniforms[ 'direction' ].value = UnrealBloomPass.BlurDirectionY;
				renderer.setRenderTarget( this.renderTargetsVertical[ i ] );
				renderer.clear();
				this.fsQuad.render( renderer );
				inputRenderTarget = this.renderTargetsVertical[ i ];

			}

			// Composite All the mips

			this.fsQuad.material = this.compositeMaterial;
			this.compositeMaterial.uniforms[ 'bloomStrength' ].value = this.strength;
			this.compositeMaterial.uniforms[ 'bloomRadius' ].value = this.radius;
			this.compositeMaterial.uniforms[ 'bloomTintColors' ].value = this.bloomTintColors;
			renderer.setRenderTarget( this.renderTargetsHorizontal[ 0 ] );
			renderer.clear();
			this.fsQuad.render( renderer );

			// Blend it additively over the input texture

			this.fsQuad.material = this.materialCopy;
			this.copyUniforms[ 'tDiffuse' ].value = this.renderTargetsHorizontal[ 0 ].texture;
			if ( maskActive ) renderer.state.buffers.stencil.setTest( true );
			if ( this.renderToScreen ) {

				renderer.setRenderTarget( null );
				this.fsQuad.render( renderer );

			} else {

				renderer.setRenderTarget( readBuffer );
				this.fsQuad.render( renderer );

			}

			// Restore renderer settings

			renderer.setClearColor( this._oldClearColor, this.oldClearAlpha );
			renderer.autoClear = oldAutoClear;

		}
		getSeperableBlurMaterial( kernelRadius ) {

			return new THREE.ShaderMaterial( {
				defines: {
					'KERNEL_RADIUS': kernelRadius,
					'SIGMA': kernelRadius
				},
				uniforms: {
					'colorTexture': {
						value: null
					},
					'texSize': {
						value: new THREE.Vector2( 0.5, 0.5 )
					},
					'direction': {
						value: new THREE.Vector2( 0.5, 0.5 )
					}
				},
				vertexShader: `varying vec2 vUv;
				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
				fragmentShader: `#include <common>
				varying vec2 vUv;
				uniform sampler2D colorTexture;
				uniform vec2 texSize;
				uniform vec2 direction;

				float gaussianPdf(in float x, in float sigma) {
					return 0.39894 * exp( -0.5 * x * x/( sigma * sigma))/sigma;
				}
				void main() {
					vec2 invSize = 1.0 / texSize;
					float fSigma = float(SIGMA);
					float weightSum = gaussianPdf(0.0, fSigma);
					vec3 diffuseSum = texture2D( colorTexture, vUv).rgb * weightSum;
					for( int i = 1; i < KERNEL_RADIUS; i ++ ) {
						float x = float(i);
						float w = gaussianPdf(x, fSigma);
						vec2 uvOffset = direction * invSize * x;
						vec3 sample1 = texture2D( colorTexture, vUv + uvOffset).rgb;
						vec3 sample2 = texture2D( colorTexture, vUv - uvOffset).rgb;
						diffuseSum += (sample1 + sample2) * w;
						weightSum += 2.0 * w;
					}
					gl_FragColor = vec4(diffuseSum/weightSum, 1.0);
				}`
			} );

		}
		getCompositeMaterial( nMips ) {

			return new THREE.ShaderMaterial( {
				defines: {
					'NUM_MIPS': nMips
				},
				uniforms: {
					'blurTexture1': {
						value: null
					},
					'blurTexture2': {
						value: null
					},
					'blurTexture3': {
						value: null
					},
					'blurTexture4': {
						value: null
					},
					'blurTexture5': {
						value: null
					},
					'bloomStrength': {
						value: 1.0
					},
					'bloomFactors': {
						value: null
					},
					'bloomTintColors': {
						value: null
					},
					'bloomRadius': {
						value: 0.0
					}
				},
				vertexShader: `varying vec2 vUv;
				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
				fragmentShader: `varying vec2 vUv;
				uniform sampler2D blurTexture1;
				uniform sampler2D blurTexture2;
				uniform sampler2D blurTexture3;
				uniform sampler2D blurTexture4;
				uniform sampler2D blurTexture5;
				uniform float bloomStrength;
				uniform float bloomRadius;
				uniform float bloomFactors[NUM_MIPS];
				uniform vec3 bloomTintColors[NUM_MIPS];

				float lerpBloomFactor(const in float factor) {
					float mirrorFactor = 1.2 - factor;
					return mix(factor, mirrorFactor, bloomRadius);
				}

				void main() {
					gl_FragColor = bloomStrength * ( lerpBloomFactor(bloomFactors[0]) * vec4(bloomTintColors[0], 1.0) * texture2D(blurTexture1, vUv) +
						lerpBloomFactor(bloomFactors[1]) * vec4(bloomTintColors[1], 1.0) * texture2D(blurTexture2, vUv) +
						lerpBloomFactor(bloomFactors[2]) * vec4(bloomTintColors[2], 1.0) * texture2D(blurTexture3, vUv) +
						lerpBloomFactor(bloomFactors[3]) * vec4(bloomTintColors[3], 1.0) * texture2D(blurTexture4, vUv) +
						lerpBloomFactor(bloomFactors[4]) * vec4(bloomTintColors[4], 1.0) * texture2D(blurTexture5, vUv) );
				}`
			} );

		}

	}
	UnrealBloomPass.BlurDirectionX = new THREE.Vector2( 1.0, 0.0 );
	UnrealBloomPass.BlurDirectionY = new THREE.Vector2( 0.0, 1.0 );

	THREE.UnrealBloomPass = UnrealBloomPass;

} )();

;
// This file is part of meshoptimizer library and is distributed under the terms of MIT License.
// Copyright (C) 2016-2022, by Arseny Kapoulkine (arseny.kapoulkine@gmail.com)
var MeshoptDecoder = (function() {
	"use strict";

	// Built with clang version 14.0.4
	// Built from meshoptimizer 0.18
	var wasm_base = "b9H79Tebbbe8Fv9Gbb9Gvuuuuueu9Giuuub9Geueu9Giuuueuikqbeeedddillviebeoweuec:q;iekr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbeY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVbdE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbiL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtblK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbol79IV9Rbrq:P8Yqdbk;3sezu8Jjjjjbcj;eb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Radz1jjjbhwcj;abad9UhoaicefhldnadTmbaoc;WFbGgocjdaocjd6EhDcbhqinaqae9pmeaDaeaq9RaqaDfae6Egkcsfgocl4cifcd4hxdndndndnaoc9WGgmTmbcbhPcehsawcjdfhzalhHinaraH9Rax6midnaraHaxfgl9RcK6mbczhoinawcj;cbfaogifgoc9WfhOdndndndndnaHaic9WfgAco4fRbbaAci4coG4ciGPlbedibkaO9cb83ibaOcwf9cb83ibxikaOalRblalRbbgAco4gCaCciSgCE86bbaocGfalclfaCfgORbbaAcl4ciGgCaCciSgCE86bbaocVfaOaCfgORbbaAcd4ciGgCaCciSgCE86bbaoc7faOaCfgORbbaAciGgAaAciSgAE86bbaoctfaOaAfgARbbalRbegOco4gCaCciSgCE86bbaoc91faAaCfgARbbaOcl4ciGgCaCciSgCE86bbaoc4faAaCfgARbbaOcd4ciGgCaCciSgCE86bbaoc93faAaCfgARbbaOciGgOaOciSgOE86bbaoc94faAaOfgARbbalRbdgOco4gCaCciSgCE86bbaoc95faAaCfgARbbaOcl4ciGgCaCciSgCE86bbaoc96faAaCfgARbbaOcd4ciGgCaCciSgCE86bbaoc97faAaCfgARbbaOciGgOaOciSgOE86bbaoc98faAaOfgORbbalRbiglco4gAaAciSgAE86bbaoc99faOaAfgORbbalcl4ciGgAaAciSgAE86bbaoc9:faOaAfgORbbalcd4ciGgAaAciSgAE86bbaocufaOaAfgoRbbalciGglalciSglE86bbaoalfhlxdkaOalRbwalRbbgAcl4gCaCcsSgCE86bbaocGfalcwfaCfgORbbaAcsGgAaAcsSgAE86bbaocVfaOaAfgORbbalRbegAcl4gCaCcsSgCE86bbaoc7faOaCfgORbbaAcsGgAaAcsSgAE86bbaoctfaOaAfgORbbalRbdgAcl4gCaCcsSgCE86bbaoc91faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc4faOaAfgORbbalRbigAcl4gCaCcsSgCE86bbaoc93faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc94faOaAfgORbbalRblgAcl4gCaCcsSgCE86bbaoc95faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc96faOaAfgORbbalRbvgAcl4gCaCcsSgCE86bbaoc97faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc98faOaAfgORbbalRbogAcl4gCaCcsSgCE86bbaoc99faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc9:faOaAfgORbbalRbrglcl4gAaAcsSgAE86bbaocufaOaAfgoRbbalcsGglalcsSglE86bbaoalfhlxekaOal8Pbb83bbaOcwfalcwf8Pbb83bbalczfhlkdnaiam9pmbaiczfhoaral9RcL0mekkaiam6mialTmidnakTmbawaPfRbbhOcbhoazhiinaiawcj;cbfaofRbbgAce4cbaAceG9R7aOfgO86bbaiadfhiaocefgoak9hmbkkazcefhzaPcefgPad6hsalhHaPad9hmexvkkcbhlasceGmdxikalaxad2fhCdnakTmbcbhHcehsawcjdfhminaral9Rax6mialTmdalaxfhlawaHfRbbhOcbhoamhiinaiawcj;cbfaofRbbgAce4cbaAceG9R7aOfgO86bbaiadfhiaocefgoak9hmbkamcefhmaHcefgHad6hsaHad9hmbkaChlxikcbhocehsinaral9Rax6mdalTmealaxfhlaocefgoad6hsadao9hmbkaChlxdkcbhlasceGTmekc9:hoxikabaqad2fawcjdfakad2z1jjjb8Aawawcjdfakcufad2fadz1jjjb8Aakaqfhqalmbkc9:hoxekcbc99aral9Radcaadca0ESEhokavcj;ebf8Kjjjjbaok;yzeHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecjez:jjjjb8AavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhodnaeTmbcmcsaDceSEhkcbhxcbhmcbhDcbhicbhlindnaoaq9nmbc9:hoxikdndnawRbbgrc;Ve0mbavc;abfalarcl4cu7fcsGcitfgPydlhsaPydbhzdnarcsGgPak9pmbavaiarcu7fcsGcdtfydbaxaPEhraPThPdndnadcd9hmbabaDcetfgHaz87ebaHcdfas87ebaHclfar87ebxekabaDcdtfgHazBdbaHclfasBdbaHcwfarBdbkaxaPfhxavc;abfalcitfgHarBdbaHasBdlavaicdtfarBdbavc;abfalcefcsGglcitfgHazBdbaHarBdlaiaPfhialcefhlxdkdndnaPcsSmbamaPfaPc987fcefhmxekaocefhrao8SbbgPcFeGhHdndnaPcu9mmbarhoxekaocvfhoaHcFbGhHcrhPdninar8SbbgOcFbGaPtaHVhHaOcu9kmearcefhraPcrfgPc8J9hmbxdkkarcefhokaHce4cbaHceG9R7amfhmkdndnadcd9hmbabaDcetfgraz87ebarcdfas87ebarclfam87ebxekabaDcdtfgrazBdbarclfasBdbarcwfamBdbkavc;abfalcitfgramBdbarasBdlavaicdtfamBdbavc;abfalcefcsGglcitfgrazBdbaramBdlaicefhialcefhlxekdnarcpe0mbaxcefgOavaiaqarcsGfRbbgPcl49RcsGcdtfydbaPcz6gHEhravaiaP9RcsGcdtfydbaOaHfgsaPcsGgOEhPaOThOdndnadcd9hmbabaDcetfgzax87ebazcdfar87ebazclfaP87ebxekabaDcdtfgzaxBdbazclfarBdbazcwfaPBdbkavaicdtfaxBdbavc;abfalcitfgzarBdbazaxBdlavaicefgicsGcdtfarBdbavc;abfalcefcsGcitfgzaPBdbazarBdlavaiaHfcsGgicdtfaPBdbavc;abfalcdfcsGglcitfgraxBdbaraPBdlalcefhlaiaOfhiasaOfhxxekaxcbaoRbbgzEgAarc;:eSgrfhsazcsGhCazcl4hXdndnazcs0mbascefhOxekashOavaiaX9RcsGcdtfydbhskdndnaCmbaOcefhxxekaOhxavaiaz9RcsGcdtfydbhOkdndnarTmbaocefhrxekaocdfhrao8SbegHcFeGhPdnaHcu9kmbaocofhAaPcFbGhPcrhodninar8SbbgHcFbGaotaPVhPaHcu9kmearcefhraocrfgoc8J9hmbkaAhrxekarcefhrkaPce4cbaPceG9R7amfgmhAkdndnaXcsSmbarhPxekarcefhPar8SbbgocFeGhHdnaocu9kmbarcvfhsaHcFbGhHcrhodninaP8SbbgrcFbGaotaHVhHarcu9kmeaPcefhPaocrfgoc8J9hmbkashPxekaPcefhPkaHce4cbaHceG9R7amfgmhskdndnaCcsSmbaPhoxekaPcefhoaP8SbbgrcFeGhHdnarcu9kmbaPcvfhOaHcFbGhHcrhrdninao8SbbgPcFbGartaHVhHaPcu9kmeaocefhoarcrfgrc8J9hmbkaOhoxekaocefhokaHce4cbaHceG9R7amfgmhOkdndnadcd9hmbabaDcetfgraA87ebarcdfas87ebarclfaO87ebxekabaDcdtfgraABdbarclfasBdbarcwfaOBdbkavc;abfalcitfgrasBdbaraABdlavaicdtfaABdbavc;abfalcefcsGcitfgraOBdbarasBdlavaicefgicsGcdtfasBdbavc;abfalcdfcsGcitfgraABdbaraOBdlavaiazcz6aXcsSVfgicsGcdtfaOBdbaiaCTaCcsSVfhialcifhlkawcefhwalcsGhlaicsGhiaDcifgDae6mbkkcbc99aoaqSEhokavc;aef8Kjjjjbaok:llevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:Lvoeue99dud99eud99dndnadcl9hmbaeTmeindndnabcdfgd8Sbb:Yab8Sbbgi:Ygl:l:tabcefgv8Sbbgo:Ygr:l:tgwJbb;:9cawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai86bbdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad86bbdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad86bbabclfhbaecufgembxdkkaeTmbindndnabclfgd8Ueb:Yab8Uebgi:Ygl:l:tabcdfgv8Uebgo:Ygr:l:tgwJb;:FSawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai87ebdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad87ebdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad87ebabcwfhbaecufgembkkk;siliui99iue99dnaeTmbcbhiabhlindndnJ;Zl81Zalcof8UebgvciV:Y:vgoal8Ueb:YNgrJb;:FSNJbbbZJbbb:;arJbbbb9GEMgw:lJbbb9p9DTmbaw:OhDxekcjjjj94hDkalclf8Uebhqalcdf8UebhkabavcefciGaiVcetfaD87ebdndnaoak:YNgwJb;:FSNJbbbZJbbb:;awJbbbb9GEMgx:lJbbb9p9DTmbax:Ohkxekcjjjj94hkkabavcdfciGaiVcetfak87ebdndnaoaq:YNgoJb;:FSNJbbbZJbbb:;aoJbbbb9GEMgx:lJbbb9p9DTmbax:Ohqxekcjjjj94hqkabavcufciGaiVcetfaq87ebdndnJbbjZararN:tawawN:taoaoN:tgrJbbbbarJbbbb9GE:rJb;:FSNJbbbZMgr:lJbbb9p9DTmbar:Ohqxekcjjjj94hqkabavciGaiVcetfaq87ebalcwfhlaiclfhiaecufgembkkk9mbdnadcd4ae2geTmbinababydbgdcwtcw91:Yadce91cjjj;8ifcjjj98G::NUdbabclfhbaecufgembkkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaik;LeeeudndnaeabVciGTmbabhixekdndnadcz9pmbabhixekabhiinaiaeydbBdbaiclfaeclfydbBdbaicwfaecwfydbBdbaicxfaecxfydbBdbaiczfhiaeczfheadc9Wfgdcs0mbkkadcl6mbinaiaeydbBdbaeclfheaiclfhiadc98fgdci0mbkkdnadTmbinaiaeRbb86bbaicefhiaecefheadcufgdmbkkabk;aeedudndnabciGTmbabhixekaecFeGc:b:c:ew2hldndnadcz9pmbabhixekabhiinaialBdbaicxfalBdbaicwfalBdbaiclfalBdbaiczfhiadc9Wfgdcs0mbkkadcl6mbinaialBdbaiclfhiadc98fgdci0mbkkdnadTmbinaiae86bbaicefhiadcufgdmbkkabkkkebcjwklz9Kbb";
	var wasm_simd = "b9H79TebbbeKl9Gbb9Gvuuuuueu9Giuuub9Geueuikqbbebeedddilve9Weeeviebeoweuec:q;Aekr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbdY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVblE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtboK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbrL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbwl79IV9RbDq;t9tqlbzik9:evu8Jjjjjbcz9Rhbcbheincbhdcbhiinabcwfadfaicjuaead4ceGglE86bbaialfhiadcefgdcw9hmbkaec:q:yjjbfai86bbaecitc:q1jjbfab8Piw83ibaecefgecjd9hmbkk;h8JlHud97euo978Jjjjjbcj;kb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Rad;8qbbcj;abad9UhoaicefhldnadTmbaoc;WFbGgocjdaocjd6EhwcbhDinaDae9pmeawaeaD9RaDawfae6Egqcsfgoc9WGgkci2hxakcethmaocl4cifcd4hPabaDad2fhscbhzdnincehHalhOcbhAdninaraO9RaP6miavcj;cbfaAak2fhCaOaPfhlcbhidnakc;ab6mbaral9Rc;Gb6mbcbhoinaCaofhidndndndndnaOaoco4fRbbgXciGPlbedibkaipxbbbbbbbbbbbbbbbbpklbxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklbalczfhlkdndndndndnaXcd4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklzxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklzalczfhlkdndndndndnaXcl4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklaxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklaalczfhlkdndndndndnaXco4Plbedibkaipxbbbbbbbbbbbbbbbbpkl8WxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WalclfaYpQbfaXc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WalcwfaYpQbfaXc:q:yjjbfRbbfhlxekaialpbbbpkl8Walczfhlkaoc;abfhiaocjefak0meaihoaral9Rc;Fb0mbkkdndnaiak9pmbaici4hoinaral9RcK6mdaCaifhXdndndndndnaOaico4fRbbaocoG4ciGPlbedibkaXpxbbbbbbbbbbbbbbbbpklbxikaXalpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaXalpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaXalpbbbpklbalczfhlkaocdfhoaiczfgiak6mbkkalTmbaAci6hHalhOaAcefgohAaoclSmdxekkcbhlaHceGmdkdnakTmbavcjdfazfhiavazfpbdbhYcbhXinaiavcj;cbfaXfgopblbgLcep9TaLpxeeeeeeeeeeeeeeeegQp9op9Hp9rgLaoakfpblbg8Acep9Ta8AaQp9op9Hp9rg8ApmbzeHdOiAlCvXoQrLgEaoamfpblbg3cep9Ta3aQp9op9Hp9rg3aoaxfpblbg5cep9Ta5aQp9op9Hp9rg5pmbzeHdOiAlCvXoQrLg8EpmbezHdiOAlvCXorQLgQaQpmbedibedibedibediaYp9UgYp9AdbbaiadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaEa8EpmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaLa8ApmwKDYq8AkEx3m5P8Es8FgLa3a5pmwKDYq8AkEx3m5P8Es8Fg8ApmbezHdiOAlvCXorQLgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaLa8ApmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfhiaXczfgXak6mbkkazclfgzad6mbkasavcjdfaqad2;8qbbavavcjdfaqcufad2fad;8qbbaqaDfhDc9:hoalmexikkc9:hoxekcbc99aral9Radcaadca0ESEhokavcj;kbf8Kjjjjbaokwbz:bjjjbk;uzeHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecje;8kbavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhodnaeTmbcmcsaDceSEhkcbhxcbhmcbhDcbhicbhlindnaoaq9nmbc9:hoxikdndnawRbbgrc;Ve0mbavc;abfalarcl4cu7fcsGcitfgPydlhsaPydbhzdnarcsGgPak9pmbavaiarcu7fcsGcdtfydbaxaPEhraPThPdndnadcd9hmbabaDcetfgHaz87ebaHcdfas87ebaHclfar87ebxekabaDcdtfgHazBdbaHclfasBdbaHcwfarBdbkaxaPfhxavc;abfalcitfgHarBdbaHasBdlavaicdtfarBdbavc;abfalcefcsGglcitfgHazBdbaHarBdlaiaPfhialcefhlxdkdndnaPcsSmbamaPfaPc987fcefhmxekaocefhrao8SbbgPcFeGhHdndnaPcu9mmbarhoxekaocvfhoaHcFbGhHcrhPdninar8SbbgOcFbGaPtaHVhHaOcu9kmearcefhraPcrfgPc8J9hmbxdkkarcefhokaHce4cbaHceG9R7amfhmkdndnadcd9hmbabaDcetfgraz87ebarcdfas87ebarclfam87ebxekabaDcdtfgrazBdbarclfasBdbarcwfamBdbkavc;abfalcitfgramBdbarasBdlavaicdtfamBdbavc;abfalcefcsGglcitfgrazBdbaramBdlaicefhialcefhlxekdnarcpe0mbaxcefgOavaiaqarcsGfRbbgPcl49RcsGcdtfydbaPcz6gHEhravaiaP9RcsGcdtfydbaOaHfgsaPcsGgOEhPaOThOdndnadcd9hmbabaDcetfgzax87ebazcdfar87ebazclfaP87ebxekabaDcdtfgzaxBdbazclfarBdbazcwfaPBdbkavaicdtfaxBdbavc;abfalcitfgzarBdbazaxBdlavaicefgicsGcdtfarBdbavc;abfalcefcsGcitfgzaPBdbazarBdlavaiaHfcsGgicdtfaPBdbavc;abfalcdfcsGglcitfgraxBdbaraPBdlalcefhlaiaOfhiasaOfhxxekaxcbaoRbbgzEgAarc;:eSgrfhsazcsGhCazcl4hXdndnazcs0mbascefhOxekashOavaiaX9RcsGcdtfydbhskdndnaCmbaOcefhxxekaOhxavaiaz9RcsGcdtfydbhOkdndnarTmbaocefhrxekaocdfhrao8SbegHcFeGhPdnaHcu9kmbaocofhAaPcFbGhPcrhodninar8SbbgHcFbGaotaPVhPaHcu9kmearcefhraocrfgoc8J9hmbkaAhrxekarcefhrkaPce4cbaPceG9R7amfgmhAkdndnaXcsSmbarhPxekarcefhPar8SbbgocFeGhHdnaocu9kmbarcvfhsaHcFbGhHcrhodninaP8SbbgrcFbGaotaHVhHarcu9kmeaPcefhPaocrfgoc8J9hmbkashPxekaPcefhPkaHce4cbaHceG9R7amfgmhskdndnaCcsSmbaPhoxekaPcefhoaP8SbbgrcFeGhHdnarcu9kmbaPcvfhOaHcFbGhHcrhrdninao8SbbgPcFbGartaHVhHaPcu9kmeaocefhoarcrfgrc8J9hmbkaOhoxekaocefhokaHce4cbaHceG9R7amfgmhOkdndnadcd9hmbabaDcetfgraA87ebarcdfas87ebarclfaO87ebxekabaDcdtfgraABdbarclfasBdbarcwfaOBdbkavc;abfalcitfgrasBdbaraABdlavaicdtfaABdbavc;abfalcefcsGcitfgraOBdbarasBdlavaicefgicsGcdtfasBdbavc;abfalcdfcsGcitfgraABdbaraOBdlavaiazcz6aXcsSVfgicsGcdtfaOBdbaiaCTaCcsSVfhialcifhlkawcefhwalcsGhlaicsGhiaDcifgDae6mbkkcbc99aoaqSEhokavc;aef8Kjjjjbaok:llevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:EPliuo97eue978Jjjjjbca9Rhidndnadcl9hmbdnaec98GglTmbcbhvabhdinadadpbbbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpkbbadczfhdavclfgval6mbkkalae9pmeaiaeciGgvcdtgdVcbczad9R;8kbaiabalcdtfglad;8qbbdnavTmbaiaipblbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpklbkalaiad;8qbbskdnaec98GgxTmbcbhvabhdinadczfglalpbbbgopxbbbbbbFFbbbbbbFFgkp9oadpbbbgDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eaDaopmbediwDqkzHOAKY8AEgoczp:Sep;6egrp;Geaoczp:Reczp:Sep;6egwp;Gep;Kep;Legopxb;:FSb;:FSb;:FSb;:FSawaopxbbbbbbbbbbbbbbbbp:2egqawpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegwawp;Meaoaop;Mearaqaramp9op9rp;Kegoaop;Mep;Kep;Kep;Jep;Negrp;Mepxbbn0bbn0bbn0bbn0gqp;Keczp:Reawarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9op9qgwaoarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogopmwDKYqk8AExm35Ps8E8Fp9qpkbbadaDakp9oawaopmbezHdiOAlvCXorQLp9qpkbbadcafhdavclfgvax6mbkkaxae9pmbaiaeciGgvcitgdfcbcaad9R;8kbaiabaxcitfglad;8qbbdnavTmbaiaipblzgopxbbbbbbFFbbbbbbFFgkp9oaipblbgDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eaDaopmbediwDqkzHOAKY8AEgoczp:Sep;6egrp;Geaoczp:Reczp:Sep;6egwp;Gep;Kep;Legopxb;:FSb;:FSb;:FSb;:FSawaopxbbbbbbbbbbbbbbbbp:2egqawpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegwawp;Meaoaop;Mearaqaramp9op9rp;Kegoaop;Mep;Kep;Kep;Jep;Negrp;Mepxbbn0bbn0bbn0bbn0gqp;Keczp:Reawarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9op9qgwaoarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogopmwDKYqk8AExm35Ps8E8Fp9qpklzaiaDakp9oawaopmbezHdiOAlvCXorQLp9qpklbkalaiad;8qbbkk;4wllue97euv978Jjjjjbc8W9Rhidnaec98GglTmbcbhvabhoinaiaopbbbgraoczfgwpbbbgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklbaopxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaqakp;Mearp;Keczp:ReaDakp;Mearp;Keamp9op9qgkpmbezHdiOAlvCXorQLgrp5baipblbpEb:T:j83ibaocwfarp5eaipblbpEe:T:j83ibawaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblbpEd:T:j83ibaocKfakp5eaipblbpEi:T:j83ibaocafhoavclfgval6mbkkdnalae9pmbaiaeciGgvcitgofcbcaao9R;8kbaiabalcitfgwao;8qbbdnavTmbaiaipblbgraipblzgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklaaipxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaqakp;Mearp;Keczp:ReaDakp;Mearp;Keamp9op9qgkpmbezHdiOAlvCXorQLgrp5baipblapEb:T:j83ibaiarp5eaipblapEe:T:j83iwaiaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblapEd:T:j83izaiakp5eaipblapEi:T:j83iKkawaiao;8qbbkk:Pddiue978Jjjjjbc;ab9Rhidnadcd4ae2glc98GgvTmbcbhdabheinaeaepbbbgocwp:Recwp:Sep;6eaocep:SepxbbjZbbjZbbjZbbjZp:UepxbbjFbbjFbbjFbbjFp9op;Mepkbbaeczfheadclfgdav6mbkkdnaval9pmbaialciGgdcdtgeVcbc;abae9R;8kbaiabavcdtfgvae;8qbbdnadTmbaiaipblbgocwp:Recwp:Sep;6eaocep:SepxbbjZbbjZbbjZbbjZp:UepxbbjFbbjFbbjFbbjFp9op;Mepklbkavaiae;8qbbkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaikkkebcjwklz9Tbb";

	var detector = new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,3,2,0,0,5,3,1,0,1,12,1,0,10,22,2,12,0,65,0,65,0,65,0,252,10,0,0,11,7,0,65,0,253,15,26,11]);
	var wasmpack = new Uint8Array([32,0,65,2,1,106,34,33,3,128,11,4,13,64,6,253,10,7,15,116,127,5,8,12,40,16,19,54,20,9,27,255,113,17,42,67,24,23,146,148,18,14,22,45,70,69,56,114,101,21,25,63,75,136,108,28,118,29,73,115]);

	if (typeof WebAssembly !== 'object') {
		return {
			supported: false,
		};
	}

	var wasm = WebAssembly.validate(detector) ? wasm_simd : wasm_base;

	var instance;

	var ready =
		WebAssembly.instantiate(unpack(wasm), {})
		.then(function(result) {
			instance = result.instance;
			instance.exports.__wasm_call_ctors();
		});

	function unpack(data) {
		var result = new Uint8Array(data.length);
		for (var i = 0; i < data.length; ++i) {
			var ch = data.charCodeAt(i);
			result[i] = ch > 96 ? ch - 97 : ch > 64 ? ch - 39 : ch + 4;
		}
		var write = 0;
		for (var i = 0; i < data.length; ++i) {
			result[write++] = (result[i] < 60) ? wasmpack[result[i]] : (result[i] - 60) * 64 + result[++i];
		}
		return result.buffer.slice(0, write);
	}

	function decode(fun, target, count, size, source, filter) {
		var sbrk = instance.exports.sbrk;
		var count4 = (count + 3) & ~3;
		var tp = sbrk(count4 * size);
		var sp = sbrk(source.length);
		var heap = new Uint8Array(instance.exports.memory.buffer);
		heap.set(source, sp);
		var res = fun(tp, count, size, sp, source.length);
		if (res == 0 && filter) {
			filter(tp, count4, size);
		}
		target.set(heap.subarray(tp, tp + count * size));
		sbrk(tp - sbrk(0));
		if (res != 0) {
			throw new Error("Malformed buffer data: " + res);
		}
	}

	var filters = {
		NONE: "",
		OCTAHEDRAL: "meshopt_decodeFilterOct",
		QUATERNION: "meshopt_decodeFilterQuat",
		EXPONENTIAL: "meshopt_decodeFilterExp",
	};

	var decoders = {
		ATTRIBUTES: "meshopt_decodeVertexBuffer",
		TRIANGLES: "meshopt_decodeIndexBuffer",
		INDICES: "meshopt_decodeIndexSequence",
	};

	var workers = [];
	var requestId = 0;

	function createWorker(url) {
		var worker = {
			object: new Worker(url),
			pending: 0,
			requests: {}
		};

		worker.object.onmessage = function(event) {
			var data = event.data;

			worker.pending -= data.count;
			worker.requests[data.id][data.action](data.value);

			delete worker.requests[data.id];
		};

		return worker;
	}

	function initWorkers(count) {
		var source =
			"var instance; var ready = WebAssembly.instantiate(new Uint8Array([" + new Uint8Array(unpack(wasm)) + "]), {})" +
			".then(function(result) { instance = result.instance; instance.exports.__wasm_call_ctors(); });" +
			"self.onmessage = workerProcess;" +
			decode.toString() + workerProcess.toString();

		var blob = new Blob([source], {type: 'text/javascript'});
		var url = URL.createObjectURL(blob);

		for (var i = 0; i < count; ++i) {
			workers[i] = createWorker(url);
		}

		URL.revokeObjectURL(url);
	}

	function decodeWorker(count, size, source, mode, filter) {
		var worker = workers[0];

		for (var i = 1; i < workers.length; ++i) {
			if (workers[i].pending < worker.pending) {
				worker = workers[i];
			}
		}

		return new Promise(function (resolve, reject) {
			var data = new Uint8Array(source);
			var id = requestId++;

			worker.pending += count;
			worker.requests[id] = { resolve: resolve, reject: reject };
			worker.object.postMessage({ id: id, count: count, size: size, source: data, mode: mode, filter: filter }, [ data.buffer ]);
		});
	}

	function workerProcess(event) {
		ready.then(function() {
			var data = event.data;
			try {
				var target = new Uint8Array(data.count * data.size);
				decode(instance.exports[data.mode], target, data.count, data.size, data.source, instance.exports[data.filter]);
				self.postMessage({ id: data.id, count: data.count, action: "resolve", value: target }, [ target.buffer ]);
			} catch (error) {
				self.postMessage({ id: data.id, count: data.count, action: "reject", value: error });
			}
		});
	}

	return {
		ready: ready,
		supported: true,
		useWorkers: function(count) {
			initWorkers(count);
		},
		decodeVertexBuffer: function(target, count, size, source, filter) {
			decode(instance.exports.meshopt_decodeVertexBuffer, target, count, size, source, instance.exports[filters[filter]]);
		},
		decodeIndexBuffer: function(target, count, size, source) {
			decode(instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
		},
		decodeIndexSequence: function(target, count, size, source) {
			decode(instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
		},
		decodeGltfBuffer: function(target, count, size, source, mode, filter) {
			decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
		},
		decodeGltfBufferAsync: function(count, size, source, mode, filter) {
			if (workers.length > 0) {
				return decodeWorker(count, size, source, decoders[mode], filters[filter]);
			}

			return ready.then(function() {
				var target = new Uint8Array(count * size);
				decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
				return target;
			});
		}
	};
})();

// UMD-style export
if (typeof exports === 'object' && typeof module === 'object')
	module.exports = MeshoptDecoder;
else if (typeof define === 'function' && define['amd'])
	define([], function() {
		return MeshoptDecoder;
	});
else if (typeof exports === 'object')
	exports["MeshoptDecoder"] = MeshoptDecoder;
else
	(typeof self !== 'undefined' ? self : this).MeshoptDecoder = MeshoptDecoder;

window.MeshoptDecoder=MeshoptDecoder;

;
/* PSB Flagship 3D store. Built for powerfulsincebirth.com. three.js r147. Store model "Clothing Store" by lizhiqiang (CC BY 4.0). */
(() => {
/* =========================================================
   Catalog: live from Shopify (rendered by sections/psb-flagship.liquid)
   ========================================================= */
const CFG=JSON.parse(document.getElementById('psb-config').textContent);
const ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
const FL=['label','Neck label',0,.615,.34,1], FT=['tag','PSB LAB tag',.159,.067,.32,1];
const FD=[['graphic','Front graphic',-.02,.41,.62,1],FL,FT];
const DETAIL_PRESETS={hi_blue:FD,hi_green:FD,mr_white:[['graphic','Front graphic',0,.37,.66,1],FL,FT],mr_brown:[['graphic','Front graphic',0,.37,.66,1],FL,FT],psb_brown:[['graphic','Front logo',0,.51,.5,1],FL,FT]};
const SIZE_ORDER=['XXS','XS','S','M','L','XL','XXL','2XL','3XL','4XL'];
const PRODUCTS={}, PIECES=[], TH={}, SHIRT_TEX={}, DECAL_TEX={};
CFG.pieces.forEach(c=>{
  PRODUCTS[c.handle]={title:c.title,type:c.type||'Shirt',desc:c.desc,url:c.url};
  const names=(c.options||[]).map(o=>String(o).toLowerCase());
  const si=names.findIndex(o=>/size/.test(o)), ci=names.findIndex(o=>/colou?r/.test(o));
  const vs=c.variants.filter(v=>ci<0||!c.color||String(v.options[ci]).toLowerCase()===String(c.color).toLowerCase());
  const sizes=vs.map(v=>[si>=0?String(v.options[si]):v.title,v.id,v.available?1:0,v.price])
    .sort((a,b)=>(SIZE_ORDER.indexOf(a[0].toUpperCase())+99)%110-(SIZE_ORDER.indexOf(b[0].toUpperCase())+99)%110);
  if(!sizes.length) return;
  const side=c.side==='back'?'Back':'Front';
  PIECES.push({key:c.key,handle:c.handle,color:c.color||'',sw:c.swatch||c.glow,glow:c.glow||'#2f8cff',side,table:!!c.table,
    details:DETAIL_PRESETS[c.key]||(side==='Back'?[['graphic','Back print',0,.41,.66,-1],FL,FT]:FD),sizes});
  TH[c.key]=c.thumb; SHIRT_TEX[c.key]=c.tex; if(c.table) DECAL_TEX[c.key]=c.decal;
});
const N=PIECES.length;
const VARIANTS={};
PIECES.forEach((p,i)=>p.sizes.forEach(([s,id,av,pr])=>VARIANTS[id]={i,size:s,av:!!av,price:pr}));
const inStock=p=>p.sizes.some(s=>s[2]);
const pad=n=>String(n).padStart(2,'0');
const fmt=(()=>{ try{ return new Intl.NumberFormat(CFG.locale||'en',{style:'currency',currency:CFG.currency||'USD'}); }catch(e){ return {format:v=>'$'+v.toFixed(2)}; } })();
const money=cents=>fmt.format((cents||0)/100);
const pieceFrom=p=>{ const r=p.sizes.find(s=>s[2])||p.sizes[0]; return r[3]; };
const nameHTML=t=>{const w=t.split(' ');const last=w.pop();return `${w.join(' ')} <em>${last}.</em>`;};
const otherSide=s=>s==='Front'?'Back':'Front';
const chosen={};
const defaultSize=p=>{const c=chosen[p.key]; if(c&&p.sizes.some(s=>s[0]===c)) return c; const a=p.sizes.find(s=>s[2]); return a?a[0]:(p.sizes[1]||p.sizes[0])[0];};

/* =========================================================
   State, DOM
   ========================================================= */
let sel=0, mode='intro';
let cart={items:[],item_count:0,total_price:0};
const $=id=>document.getElementById(id);
const RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
const COARSE=matchMedia('(pointer: coarse)').matches;
const narrow=()=>innerWidth<=860;
const body=document.body;
const drawer=$('drawer'), bagEl=$('bag'), warpEl=$('warp');

/* =========================================================
   Sound (synthesized)
   ========================================================= */
const Sound={ctx:null,on:false,
  init(){ if(this.ctx) return; const AC=window.AudioContext||window.webkitAudioContext; if(!AC) return;
    const c=this.ctx=new AC(); this.master=c.createGain(); this.master.gain.value=0; this.master.connect(c.destination);
    const lp=c.createBiquadFilter(); lp.type='lowpass'; lp.frequency.value=380; lp.Q.value=.7; this.pad=lp;
    const pg=c.createGain(); pg.gain.value=.055; lp.connect(pg); pg.connect(this.master);
    [[55,'sawtooth',.5],[55.4,'sawtooth',.5],[82.4,'triangle',.45],[110.3,'sine',.3],[164.8,'sine',.12]].forEach(([f,t,v])=>{const o=c.createOscillator();o.type=t;o.frequency.value=f;const g=c.createGain();g.gain.value=v;o.connect(g);g.connect(lp);o.start();});
    const lfo=c.createOscillator(); lfo.frequency.value=.07; const lg=c.createGain(); lg.gain.value=130; lfo.connect(lg); lg.connect(lp.frequency); lfo.start();
    const len=c.sampleRate*2, buf=c.createBuffer(1,len,c.sampleRate), d=buf.getChannelData(0); for(let i=0;i<len;i++) d[i]=Math.random()*2-1; this.noise=buf; },
  set(v){ this.init(); if(!this.ctx) return; this.on=v; if(this.ctx.state==='suspended') this.ctx.resume();
    const t=this.ctx.currentTime; this.master.gain.cancelScheduledValues(t); this.master.gain.setTargetAtTime(v?.85:0,t,.5);
    if(v&&mode!=='intro') Music.start(); else if(!v) Music.stop();
    $('soundBtn').setAttribute('aria-pressed',v); $('soundTxt').textContent=v?'Sound on':'Sound off'; },
  room(f){ if(this.ctx) this.pad.frequency.setTargetAtTime(f,this.ctx.currentTime,.8); },
  thump(v=.3){ if(!this.on) return; const c=this.ctx,t=c.currentTime,o=c.createOscillator(),g=c.createGain();
    o.frequency.setValueAtTime(80,t); o.frequency.exponentialRampToValueAtTime(34,t+.38);
    g.gain.setValueAtTime(0,t); g.gain.linearRampToValueAtTime(v,t+.012); g.gain.exponentialRampToValueAtTime(.001,t+.55); o.connect(g); g.connect(this.master); o.start(t); o.stop(t+.6); },
  whoosh(dur=.45,f0=1600,f1=320,vol=.06){ if(!this.on) return; const c=this.ctx,t=c.currentTime,s=c.createBufferSource(),f=c.createBiquadFilter(),g=c.createGain();
    s.buffer=this.noise; f.type='bandpass'; f.Q.value=1.4; f.frequency.setValueAtTime(f0,t); f.frequency.exponentialRampToValueAtTime(f1,t+dur);
    g.gain.setValueAtTime(0,t); g.gain.linearRampToValueAtTime(vol,t+dur*.3); g.gain.exponentialRampToValueAtTime(.001,t+dur); s.connect(f); f.connect(g); g.connect(this.master); s.start(t); s.stop(t+dur+.05); },
  ping(f=1320,vol=.035){ if(!this.on) return; const c=this.ctx,t=c.currentTime;
    [f,f*1.502,f*2.01].forEach((fr,i)=>{const o=c.createOscillator(),g=c.createGain();o.frequency.value=fr;g.gain.setValueAtTime(vol/(i+1),t);g.gain.exponentialRampToValueAtTime(.0005,t+.9-i*.2);o.connect(g);g.connect(this.master);o.start(t);o.stop(t+1);}); },
  step(){ if(!this.on) return; this.whoosh(.18,500,240,.025); },
  warp(){ if(!this.on) return; this.whoosh(1.1,180,4200,.09); const c=this.ctx,t=c.currentTime,o=c.createOscillator(),g=c.createGain();
    o.type='triangle'; o.frequency.setValueAtTime(110,t); o.frequency.exponentialRampToValueAtTime(660,t+1);
    g.gain.setValueAtTime(0,t); g.gain.linearRampToValueAtTime(.045,t+.7); g.gain.exponentialRampToValueAtTime(.001,t+1.2); o.connect(g); g.connect(this.master); o.start(t); o.stop(t+1.25); },
  curtain(){ if(!this.on) return; this.whoosh(.7,2600,700,.07); }
};
$('soundBtn').onclick=()=>Sound.set(!Sound.on);

/* =========================================================
   Stations + product rail
   ========================================================= */
const V=(x,y,z)=>new THREE.Vector3(x,y,z);
const STATIONS=[
  {id:'entrance',label:'Entrance',idx:'PSB / Flagship',name:'The <em>Flagship.</em>',sub:'Every colorway on the walls and the rail.',pos:[-2.55,1.66,6.2],look:[-1.05,1.3,1.0]},
  {id:'core',label:'The Core',idx:'PSB / Centerpiece',name:'The <em>Core.</em>',sub:'Tap it. Tell it what you carry, and it picks your piece.',pos:[1.1,1.5,5.3],look:[-.55,1.42,3.55]},
  {id:'vault',label:'Drop Vault',idx:'PSB / Vault',name:'The <em>Vault.</em>',sub:'The next drop, sealed behind glass. Tap it.',pos:[2.2,1.52,6.3],look:[1.3,1.12,4.3]},
  {id:'wallL',label:'PSB Wall',idx:'PSB / Wall 01',name:'The PSB <em>Wall.</em>',sub:'Every colorway, face out. Tap one to pull it.',pos:[-2.95,1.62,4.9],look:[-3.95,1.45,2.2]},
  {id:'rail',label:'The Rail',idx:'PSB / Rail',name:'The <em>Rail.</em>',sub:`All ${PIECES.reduce((a,p)=>a+p.sizes.length,0)} variants on one rail. Tap a hanger to pull it out.`,pos:[-.25,1.55,1.3],look:[-1.9,1.15,1.25]},
  {id:'wallR',label:'Wall 02',idx:'PSB / Wall 02',name:'The <em>Drop.</em>',sub:'The full run, mirrored on the east wall.',pos:[2.35,1.62,4.9],look:[3.4,1.45,2.2]},
  {id:'counter',label:'Cash Wrap',idx:'PSB / Counter',name:'Cash <em>Wrap.</em>',sub:'Pay here with Shop Pay, Apple Pay, Google Pay, PayPal or card. Tap the terminal.',pos:[-.1,1.6,.35],look:[.05,1.2,-1.9]},
  {id:'booth',label:'The Booth',idx:'PSB / Booth',name:'The <em>Booth.</em>',sub:'Sound on, then walk up to the decks.',pos:[-1.82,1.6,-1.25],look:[-2.3,1.05,-3.55]},
  {id:'fitting',label:'Fitting Rooms',idx:'PSB / Fitting',name:'Fitting <em>Rooms.</em>',sub:'Pick a shirt, then step inside.',pos:[2.0,1.6,-2.9],look:[1.6,1.4,-5.3]}
];
let station='entrance';
const stEl=$('stations');
STATIONS.forEach((s,i)=>{ const b=document.createElement('button'); b.innerHTML=`<b>${pad(i+1)}</b>${s.label}`; b.onclick=()=>goStation(s.id); b.dataset.id=s.id; stEl.appendChild(b); });
function setLoc(s){
  $('locIdx').textContent=s.idx; $('locName').innerHTML=s.name; $('locSub').textContent=s.sub;
  [...stEl.children].forEach(b=>b.setAttribute('aria-current',b.dataset.id===s.id?'true':'false'));
}
const rail=$('rail');
PIECES.forEach((p,i)=>{ const b=document.createElement('button'); b.innerHTML=`<img src="${TH[p.key]}" alt="">`;
  b.setAttribute('aria-label',`Go to ${PRODUCTS[p.handle].title}, ${p.color}`); b.onclick=()=>focusPiece(i); rail.appendChild(b); });
function updateHUD(){
  [...rail.children].forEach((b,i)=>b.setAttribute('aria-current',i===sel?'true':'false'));
  document.documentElement.style.setProperty('--glow',PIECES[sel].glow);
}

/* =========================================================
   Detail drawer
   ========================================================= */
function renderDrawer(){
  parkWallets&&parkWallets();
  const p=PIECES[sel], pr=PRODUCTS[p.handle], ok=inStock(p);
  const sibs=PIECES.map((q,i)=>({q,i})).filter(o=>o.q.handle===p.handle);
  const size=chosen[p.key]; const row=p.sizes.find(s=>s[0]===size);
  let cta;
  if(!ok) cta=`<button class="chrome-btn add" disabled>Sold out</button>`;
  else if(!row) cta=`<button class="chrome-btn add" disabled>Select a size</button>`;
  else if(!row[2]) cta=`<button class="chrome-btn add" disabled>${size} is sold out</button>`;
  else cta=`<button class="chrome-btn add" id="addBtn">Add to bag · ${size} · ${money(row[3])}</button>`;
  const fit=mode==='fitting';
  drawer.innerHTML=`
    <div class="d-head">
      <span class="eyebrow">${fit?'Fitting room 01':(focusDisplay&&focusDisplay.kind==='core')?'Summoned by the Core':'On the floor'} · PSB / ${pad(sel+1)}</span>
      <button class="mini" id="dPrev" aria-label="Previous piece">‹</button>
      <button class="mini" id="dNext" aria-label="Next piece">›</button>
      <button class="mini" id="dClose" aria-label="Back to the floor">✕</button>
    </div>
    <h3 class="title-xl d-title">${nameHTML(pr.title)}</h3>
    <div class="d-price"><span>${money(row?row[3]:pieceFrom(p))}</span><span class="pill ${ok?'':'out'}">${ok?'In stock':'Sold out'}</span></div>
    <p class="d-desc">${pr.desc}</p>
    <div class="group"><span class="eyebrow">Colorway</span><div class="chips">
      ${sibs.map(o=>`<button class="chip" data-go="${o.i}" aria-pressed="${o.i===sel}"><i class="sw" style="background:${o.q.sw}"></i>${o.q.color}${inStock(o.q)?'':' · sold out'}</button>`).join('')}
    </div></div>
    <div class="group"><span class="eyebrow">Size</span><div class="chips">
      ${p.sizes.map(([s,id,av])=>`<button class="chip" data-size="${s}" ${av?'':'disabled'} aria-pressed="${s===size&&av?'true':'false'}" ${av?'':'title="Sold out"'}>${s}</button>`).join('')}
    </div></div>
    ${cta}
    ${fit?`<p class="rail-note"><b>Every size of this shirt is on the booth rail.</b> Tap a hanger to swap it onto the hook.</p>`:`<button class="try-btn" id="tryBtn">Try it on in the fitting room →</button>`}
    ${(focusDisplay&&focusDisplay.kind==='core')?`<button class="ghost" id="askAgain">Ask the Core again</button>`:''}
    <p class="d-note">Designed by Winners. Stock is live from the store.</p>`;
  $('dClose').onclick=backToFloor;
  $('dPrev').onclick=()=>switchPiece(((sel-1)%N+N)%N);
  $('dNext').onclick=()=>switchPiece((sel+1)%N);
  drawer.querySelectorAll('[data-go]').forEach(b=>b.onclick=()=>switchPiece(+b.dataset.go));
  drawer.querySelectorAll('[data-size]').forEach(b=>b.onclick=()=>{ chosen[p.key]=b.dataset.size; pullSize(sel,b.dataset.size); renderDrawer(); const a=$('addBtn'); a&&a.focus(); });
  const add=$('addBtn'); if(add) add.onclick=()=>{ track('add_to_bag',{source:mode==='fitting'?'fitting_room':'3d',handle:p.handle,color:p.color,size:row[0]}); addToBag(row[1]); flyToBag(); };
  const tr=$('tryBtn'); if(tr) tr.onclick=()=>enterFitting();
  const aa=$('askAgain'); if(aa) aa.onclick=()=>openCore(true);
}
function openDrawer(){ if(!drawer.classList.contains('open')||drawer.dataset.kind!=='piece') drawer.scrollTop=0; drawer.dataset.kind='piece'; renderDrawer(); drawer.classList.add('open'); body.classList.add('drawer-open'); }
function closeDrawerUI(){ parkWallets(); drawer.classList.remove('open'); if(!bagEl.classList.contains('open')) body.classList.remove('drawer-open'); }

/* =========================================================
   Bag: the real Shopify cart (AJAX Cart API)
   ========================================================= */
async function cartReq(path,data){
  const r=await fetch(ROOT+path,{method:data?'POST':'GET',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:data?JSON.stringify(data):undefined});
  const j=await r.json().catch(()=>({}));
  if(!r.ok) throw new Error(j.description||j.message||'The bag could not be updated. Try again.');
  return j; }
async function refreshCart(){
  try{ cart=await cartReq('cart.js'); }catch(e){}
  updateBagCount(); if(bagEl.classList.contains('open')) renderBag(); if(mode==='checkout'&&drawer.classList.contains('open')) renderCheckout();
  document.dispatchEvent(new CustomEvent('cart:refresh',{detail:cart})); }
let adding=false;
async function addToBag(id){
  if(adding) return; adding=true;
  try{ await cartReq('cart/add.js',{items:[{id,quantity:1}]}); Sound.ping(1568,.05);
    const v=VARIANTS[id], p=v?PIECES[v.i]:null; toast(p?`Added: ${PRODUCTS[p.handle].title} · ${p.color} · ${v.size}`:'Added to your bag'); }
  catch(e){ toast(e.message); }
  finally{ adding=false; refreshCart(); } }
async function setQty(key,q){ try{ await cartReq('cart/change.js',{id:key,quantity:q}); }catch(e){ toast(e.message); } refreshCart(); }
function updateBagCount(){ $('bagCount').textContent=cart.item_count||0; if(window.__term) window.__term(); }
const lineThumb=it=>{ const v=VARIANTS[it.variant_id]; return v?TH[PIECES[v.i].key]:(it.image||''); };
const lineMeta=it=>{ const v=VARIANTS[it.variant_id]; return v?`${PIECES[v.i].color?PIECES[v.i].color+' · ':''}${v.size}`:(it.variant_title||''); };
function renderBag(){
  const count=cart.item_count||0;
  bagEl.innerHTML=`
    <div class="d-head"><span class="eyebrow">Your bag · ${count} ${count===1?'piece':'pieces'}</span><button class="mini" id="bClose" aria-label="Close bag">✕</button></div>
    <h3 class="title-xl d-title">The <em>Bag.</em></h3>
    ${count?`<ul class="bag-list">${cart.items.map(it=>`
      <li><img src="${lineThumb(it)}" alt="">
        <div style="min-width:0"><div class="n">${it.product_title}</div><div class="v">${lineMeta(it)}</div></div>
        <div class="qty"><button data-dec="${it.key}" data-q="${it.quantity-1}" aria-label="Remove one">−</button><span>${it.quantity}</span><button data-inc="${it.key}" data-q="${it.quantity+1}" aria-label="Add one">+</button></div></li>`).join('')}</ul>
      <div class="sub"><span class="eyebrow">Subtotal</span><span>${money(cart.total_price)}</span></div>
      ${(qsOpen||mode==='intro'||window.__flat)?`<div class="pay"><a class="pay-btn shop" href="${cartURL()}?payment=shop_pay"><b>Shop Pay</b><span>One tap if you've used Shop Pay before</span></a><a class="pay-btn" href="${ROOT}checkout"><b>Checkout</b><span>Card · Apple Pay · Google Pay · PayPal</span></a></div>`
        :`<button class="chrome-btn add" id="toWrap">Pay at the cash wrap →</button>
      <p class="d-note">Shop Pay, Apple Pay, Google Pay, PayPal and cards are accepted at the counter.</p>`}`
    :`<p class="empty"><em>Nothing in the bag yet.</em>Pull a shirt off the wall, pick your size, and add it.</p>`}`;
  $('bClose').onclick=()=>closeBag();
  const tw=$('toWrap'); if(tw) tw.onclick=()=>goCheckout();
  bagEl.querySelectorAll('[data-inc],[data-dec]').forEach(b=>b.onclick=()=>setQty(b.dataset.inc||b.dataset.dec,+b.dataset.q));
}
function openBag(){ drawer.classList.remove('open'); bagEl.scrollTop=0; renderBag(); bagEl.classList.add('open'); body.classList.add('drawer-open'); }
function closeBag(){ bagEl.classList.remove('open'); if(qsOpen){ body.classList.remove('drawer-open'); return; } if(mode==='focus'||mode==='fitting') openDrawer(); else if(mode==='checkout') openCheckoutPanel(); else if(mode==='core') openCore(); else if(mode==='vault') openVault(); else if(mode==='booth') openBoothDJ(); else body.classList.remove('drawer-open'); }
const cartURL=()=>`${location.origin}${ROOT}cart/${cart.items.map(i=>`${i.variant_id}:${i.quantity}`).join(',')}`;
function qrSVG(text,px){ try{ const q=qrcode(0,'M'); q.addData(text); q.make(); return q.createSvgTag({cellSize:Math.max(2,Math.floor(px/(q.getModuleCount()+8))),margin:4,scalable:true}); }catch(e){ return ''; } }
const walletHome=$('psbWalletHome'), wallets=$('psbWallets');
function parkWallets(){ if(wallets&&walletHome&&wallets.parentNode!==walletHome) walletHome.appendChild(wallets); }
function renderCheckout(){
  parkWallets();
  const count=cart.item_count||0, url=cartURL(), hasWallets=!!(wallets&&wallets.children.length);
  drawer.innerHTML=`
    <div class="d-head"><span class="eyebrow">Cash wrap · PSB Flagship</span><button class="mini" id="cClose" aria-label="Back to the floor">✕</button></div>
    <h3 class="title-xl d-title">Ring it <em>up.</em></h3>
    ${count?`<ul class="bag-list">${cart.items.map(it=>`
      <li><img src="${lineThumb(it)}" alt="">
        <div style="min-width:0"><div class="n">${it.product_title}</div><div class="v">${lineMeta(it)} · ×${it.quantity}</div></div>
        <div class="mono" style="font-variant-numeric:tabular-nums">${money(it.final_line_price)}</div></li>`).join('')}</ul>
      <div class="sub"><span class="eyebrow">Subtotal · ${count} ${count===1?'piece':'pieces'}</span><span>${money(cart.total_price)}</span></div>
      <div class="pay">
        <div id="walletSlot" class="wallet-slot"></div>
        ${hasWallets?'':`<a class="pay-btn shop" href="${url}?payment=shop_pay"><b>Shop Pay</b><span>One tap if you've used Shop Pay before</span></a>`}
        <a class="pay-btn" href="${ROOT}checkout"><b>Checkout</b><span>Card · Apple Pay · Google Pay · PayPal</span></a>
      </div>
      <div class="qr-row"><div class="qr">${qrSVG(url,132)}</div><p><b>Pay on your phone.</b> Scan with your camera. Your bag opens in checkout with Apple Pay, Google Pay, Venmo and Shop Pay ready.</p></div>
      <p class="d-note">Payment happens in your secure Shopify checkout. Shipping and taxes are added there.</p>`
    :`<p class="empty"><em>The counter's ready. Your bag is empty.</em>Pull a shirt off the wall or ask the Core, then come back here to pay.</p>`}`;
  $('cClose').onclick=()=>backToFloor();
  const slot=$('walletSlot'); if(slot&&hasWallets) slot.appendChild(wallets);
}
function openCheckoutPanel(){ drawer.scrollTop=0; drawer.dataset.kind='checkout'; renderCheckout(); drawer.classList.add('open'); body.classList.add('drawer-open'); }
$('bagBtn').onclick=()=>bagEl.classList.contains('open')?closeBag():openBag();
$('toastBag').onclick=()=>{hideToast();openBag();};
let toastT; function toast(t){ $('toastTxt').textContent=t; $('toast').classList.add('show'); clearTimeout(toastT); toastT=setTimeout(hideToast,3200); }
function hideToast(){ $('toast').classList.remove('show'); }
updateHUD(); updateBagCount(); setLoc(STATIONS[0]); refreshCart();
/* =========================================================
   Styles for the v3 additions (kept in the script so the theme files don't change)
   ========================================================= */
{ const st=document.createElement('style'); st.textContent=`
.qs{position:fixed;inset:0;z-index:5;background:rgba(7,8,11,.95);opacity:0;transition:opacity .3s;display:flex;flex-direction:column}
.qs.open{opacity:1}
.qs-scroll{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:calc(env(safe-area-inset-top,0px) + 96px) max(16px,env(safe-area-inset-right,0px)) 40px max(16px,env(safe-area-inset-left,0px))}
.qs-in{max-width:1180px;margin:0 auto}
.qs-head{display:flex;justify-content:space-between;align-items:flex-end;gap:16px;flex-wrap:wrap;margin-bottom:28px}
.qs-head h2{margin:10px 0 6px;font-size:clamp(40px,7vw,84px);line-height:.95}
.qs-head p{margin:0;color:var(--chrome);font-size:20px}
.qs-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:18px}
.qs-card{border:1px solid var(--line);border-radius:20px;background:rgba(255,255,255,.025);overflow:hidden;display:flex;flex-direction:column}
.qs-img{display:block;width:100%;border:0;padding:0;background:radial-gradient(120% 90% at 50% 30%,color-mix(in srgb,var(--c) 24%,#15161b),#0b0c10);aspect-ratio:4/5;cursor:pointer;overflow:hidden}
.qs-img img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .6s cubic-bezier(.2,.7,.2,1)}
.qs-img img.th{object-fit:contain;padding:12%}
.qs-card:hover .qs-img img{transform:scale(1.035)}
.qs-meta{padding:16px;display:flex;flex-direction:column;gap:12px;flex:1}
.qs-meta h3{margin:0;font-family:var(--sans);font-stretch:125%;font-weight:800;text-transform:uppercase;font-size:17px;letter-spacing:.02em;line-height:1.15}
.qs-row{display:flex;justify-content:space-between;align-items:center;color:var(--chrome);font-size:13px;gap:8px}
.qs-row .mono{font-family:var(--mono);color:var(--bone)}
.qs-col{display:inline-flex;align-items:center;gap:8px}
.qs-col i{width:12px;height:12px;border-radius:50%;border:1px solid var(--line);flex:none}
.qs-sizes{display:flex;flex-wrap:wrap;gap:6px}
.qs-sizes .chip{height:36px;min-width:44px;padding:0 12px}
.qs-meta .chrome-btn{margin-top:auto}
.qs-meta .ghost{align-self:flex-start;padding:2px 0}
.qs-foot{display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;padding:12px max(16px,env(safe-area-inset-right,0px)) calc(env(safe-area-inset-bottom,0px) + 12px) max(16px,env(safe-area-inset-left,0px));background:rgba(7,8,11,.96);border-top:1px solid var(--line)}
.qs-pay{display:flex;gap:8px}
.qs-pay .pay-btn{padding:11px 18px;flex-direction:row;align-items:center}
.qs-sum b{display:block;font-family:var(--mono);font-size:15px;font-weight:500;color:var(--bone);margin-top:3px}
body.qs-open .hud,body.qs-open .credit,body.qs-open .walk-hint,body.qs-open .atl-ui,body.qs-open #hotspots{opacity:0;pointer-events:none}
.qs-btn{gap:9px}
.qs-btn svg{width:14px;height:14px;flex:none}
.intro .qs-intro{color:var(--bone);text-decoration-color:var(--glow)}
.vault-cd{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin:6px 0 4px}
.vault-cd div{border:1px solid var(--line);border-radius:14px;padding:12px 6px;text-align:center;background:rgba(255,255,255,.03)}
.vault-cd b{display:block;font-family:var(--mono);font-size:30px;font-weight:500;color:var(--bone);font-variant-numeric:tabular-nums}
.vault-cd span{font-family:var(--mono);font-size:10px;letter-spacing:.2em;text-transform:uppercase;color:var(--mute)}
.notify{display:flex;gap:8px}
.notify input{flex:1;min-width:0;height:50px;border-radius:999px;border:1px solid var(--line);background:rgba(255,255,255,.04);color:var(--bone);padding:0 18px;font:inherit;font-size:14px}
.notify input:focus{outline:none;border-color:var(--chrome)}
.notify button{flex:none;width:auto;padding:0 22px}
.booth-row{display:flex;gap:8px;align-items:center;flex-wrap:wrap}
.eqbars{display:inline-flex;gap:3px;align-items:flex-end;height:18px}
.eqbars i{width:3px;background:var(--glow);border-radius:2px;animation:eqb 1s ease-in-out infinite}
.eqbars i:nth-child(2){animation-delay:-.3s}.eqbars i:nth-child(3){animation-delay:-.6s}.eqbars i:nth-child(4){animation-delay:-.15s}
@keyframes eqb{0%,100%{height:4px}50%{height:18px}}
@media (max-width:600px){
  .qs-scroll{padding-top:calc(env(safe-area-inset-top,0px) + 78px)}
  .qs-head{margin-bottom:18px}.qs-head p{font-size:17px}
  .qs-grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
  .qs-meta{padding:11px;gap:9px}.qs-meta h3{font-size:13px}
  .qs-sizes{gap:4px}.qs-sizes .chip{height:30px;min-width:34px;padding:0 8px;font-size:11px}
  .qs-meta .chrome-btn{height:42px;font-size:10px;letter-spacing:.12em}
  .qs-pay .pay-btn{padding:10px 14px}
  .qs-btn span{display:none}
  .vault-cd b{font-size:24px}
}
@media (prefers-reduced-motion:reduce){.qs{transition:none}.eqbars i{animation:none;height:10px}}

/* phones: panels were 100% wide plus padding, so they ran off the right edge */
.drawer{box-sizing:border-box}
@media (max-width:860px){
  .drawer{width:100%;max-width:100vw}
  .drawer .d-head{min-width:0}
  .drawer .d-head .eyebrow{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
  .drawer .mini{flex:none}
  .bag-list li{grid-template-columns:52px minmax(0,1fr) auto;gap:10px}
  .bag-list img{width:52px;height:52px}
  .notify{flex-wrap:wrap}.notify input{flex:1 1 100%}.notify button{flex:1 1 100%}
  .toast{max-width:calc(100vw - 32px);box-sizing:border-box}
}
.hs.flip{flex-direction:row-reverse}
/* LED edge glow on pop-ups: a thin multicolor light that travels around the panel */
.psb-glow{position:fixed;left:0;top:0;width:0;height:0;z-index:6;pointer-events:none;opacity:0;transition:opacity .45s}
.psb-glow.on{opacity:1}
.psb-glow.over{z-index:8}
.psb-glow .g-ring,.psb-glow .g-soft{position:absolute;inset:0;border-radius:inherit;overflow:hidden}
.psb-glow .g-ring{padding:1.5px;-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box exclude,linear-gradient(#000 0 0)}
.psb-glow .g-soft{inset:-10px;padding:14px;filter:blur(18px);opacity:.85;-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box exclude,linear-gradient(#000 0 0)}
.psb-glow i{position:absolute;left:50%;top:50%;width:300vmax;height:300vmax;margin:-150vmax 0 0 -150vmax;
  background:conic-gradient(from 0deg,#4285F4,#7b6cf6,#EA4335,#FBBC05,#34A853,#4285F4 50%,#4285F4,#7b6cf6,#EA4335,#FBBC05,#34A853,#4285F4);
  animation:psbglow 9s linear infinite;will-change:transform}
@keyframes psbglow{to{transform:rotate(1turn)}}
.psb-glow.over .g-soft{opacity:.45;inset:-6px;padding:8px;filter:blur(10px)}
@media (prefers-reduced-motion:reduce){.psb-glow i{animation:none}}
`; document.head.appendChild(st); }

/* =========================================================
   Analytics: custom events for pixels, plus a real Shopify product view per inspected piece
   (needs templates/product.psb-ping.liquid; skipped safely when it's not there)
   ========================================================= */
function track(name,data){ try{ if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish) Shopify.analytics.publish('psb_'+name,data||{}); }catch(e){} }
const viewed={}; let pingOK=null;
async function pingView(handle){
  if(!handle||viewed[handle]) return; viewed[handle]=1;
  try{ if(pingOK===null){ const r=await fetch(`${ROOT}products/${handle}?view=psb-ping`,{credentials:'same-origin'}); pingOK=r.ok&&/psb-ping-ok/.test(await r.text()); }
    if(!pingOK) return;
    const f=document.createElement('iframe'); f.hidden=true; f.tabIndex=-1; f.setAttribute('aria-hidden','true'); f.title='';
    f.src=`${ROOT}products/${handle}?view=psb-ping`; body.appendChild(f); setTimeout(()=>f.remove(),20000); }catch(e){} }

/* =========================================================
   Quick Shop: every piece on one flat page. Opens instantly, even before the 3D store has loaded.
   ========================================================= */
const qsEl=document.createElement('section'); qsEl.className='qs'; qsEl.id='qs'; qsEl.hidden=true; qsEl.setAttribute('aria-label','Quick shop');
qsEl.innerHTML='<div class="qs-scroll" id="qsScroll"></div><div class="qs-foot" id="qsFoot"></div>'; body.appendChild(qsEl);
let qsOpen=false, qsShown=false; const PIMG={}; let pimgReq=null;
const GRID_ICON='<svg viewBox="0 0 14 14" fill="currentColor" aria-hidden="true"><rect width="6" height="6" rx="1"/><rect x="8" width="6" height="6" rx="1"/><rect y="8" width="6" height="6" rx="1"/><rect x="8" y="8" width="6" height="6" rx="1"/></svg>';
{ const b=document.createElement('button'); b.className='bag-btn qs-btn'; b.id='qsBtn'; b.innerHTML=GRID_ICON+'<span>Quick shop</span>'; b.setAttribute('aria-label','Quick shop: every piece on one page');
  const tr=document.querySelector('.top-right'); if(tr) tr.insertBefore(b,tr.firstChild); b.onclick=()=>qsOpen?closeQS():openQS('top');
  const ir=document.querySelector('.intro-row'); if(ir){ const g=document.createElement('button'); g.className='ghost qs-intro'; g.id='qsIntro'; g.textContent='Just shopping? Quick shop'; ir.appendChild(g); g.onclick=()=>openQS('intro'); } }
const sized=(u,w)=>{ u=String(u); if(u.startsWith('//')) u='https:'+u; return u+(u.includes('?')?'&':'?')+'width='+w; };
function loadImages(){ if(pimgReq) return pimgReq;
  pimgReq=Promise.all([...new Set(PIECES.map(p=>p.handle))].map(h=>fetch(`${ROOT}products/${h}.js`,{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).then(j=>{ if(j) PIMG[h]=j; }).catch(()=>{})))
    .then(()=>{ if(qsOpen) renderQS(); }); return pimgReq; }
function imgFor(p){ const j=PIMG[p.handle]; if(!j) return null;
  const ci=(j.options||[]).findIndex(o=>/colou?r/i.test(o&&o.name||o));
  const v=(j.variants||[]).find(v=>v.featured_image&&(!p.color||ci<0||String(v.options[ci]).toLowerCase()===p.color.toLowerCase()));
  let src=v&&v.featured_image&&v.featured_image.src;
  if(!src&&p.color){ const m=(j.media||[]).find(m=>m.alt&&m.alt.toLowerCase().includes(p.color.toLowerCase())); src=m&&(m.src||(m.preview_image&&m.preview_image.src)); }
  const sib=PIECES.filter(q=>q.handle===p.handle);
  if(!src&&sib.length>1){ const imgs=j.images||[]; if(imgs.length>=sib.length) src=imgs[sib.indexOf(p)]; else return null; }   // photos in colorway order; otherwise the 3D render keeps the color right
  src=src||j.featured_image||(j.images&&j.images[0]); return src?sized(src,720):null; }
function qsFoot(){ const n=cart.item_count||0;
  $('qsFoot').innerHTML=`<div class="qs-sum"><span class="eyebrow">${n?`Your bag · ${n} ${n===1?'piece':'pieces'}`:'Your bag is empty'}</span><b>${money(cart.total_price)}</b></div>
    ${n?`<div class="qs-pay"><a class="pay-btn shop" href="${cartURL()}?payment=shop_pay"><b>Shop Pay</b></a><a class="pay-btn" href="${ROOT}checkout"><b>Checkout</b></a></div>`:`<span class="eyebrow" style="color:var(--chrome)">Pick a size, add it, pay here.</span>`}`; }
function renderQS(){
  const y=$('qsScroll').scrollTop;
  $('qsScroll').innerHTML=`<div class="qs-in">
    <div class="qs-head"><div><span class="eyebrow">PSB® / Quick shop</span><h2 class="title-xl">Every <em>piece.</em></h2><p class="serif">No walking. Pick a size, add it, check out.</p></div>
      ${window.__flat?'':`<button class="pill-btn" id="qsTo3d">${mode==='intro'?'Walk into the 3D store →':'← Back to the 3D store'}</button>`}</div>
    <div class="qs-grid">${PIECES.map((p,i)=>{ const pr=PRODUCTS[p.handle], ok=inStock(p), size=chosen[p.key], row=p.sizes.find(s=>s[0]===size&&s[2]), im=imgFor(p);
      return `<article class="qs-card" style="--c:${p.glow}">
        <button class="qs-img" data-3d="${i}" aria-label="See ${pr.title}${p.color?', '+p.color:''} in 3D"><img src="${im||TH[p.key]}" class="${im?'':'th'}" alt="${pr.title}${p.color?', '+p.color:''}" decoding="async"></button>
        <div class="qs-meta"><span class="eyebrow">PSB / ${pad(i+1)}</span><h3>${pr.title}</h3>
          <div class="qs-row"><span class="qs-col"><i style="background:${p.sw}"></i>${p.color||'One colorway'}</span><span class="mono">${ok?money(row?row[3]:pieceFrom(p)):'Sold out'}</span></div>
          <div class="chips qs-sizes" role="group" aria-label="Size">${p.sizes.map(([s,id,av])=>`<button class="chip" data-p="${i}" data-s="${s}" ${av?'':'disabled title="Sold out"'} aria-pressed="${s===size&&!!av}">${s}</button>`).join('')}</div>
          <button class="chrome-btn add" data-add="${i}" ${ok&&row?'':'disabled'}>${!ok?'Sold out':row?`Add to bag · ${size}`:'Pick a size'}</button>
          ${window.__flat?'':`<button class="ghost" data-3d="${i}">See it in 3D →</button>`}</div></article>`; }).join('')}</div></div>`;
  $('qsScroll').scrollTop=y; qsFoot();
  $('qsScroll').querySelectorAll('[data-s]').forEach(b=>b.onclick=()=>{ chosen[PIECES[+b.dataset.p].key]=b.dataset.s; renderQS(); const a=$('qsScroll').querySelector(`[data-add="${b.dataset.p}"]`); a&&a.focus({preventScroll:true}); });
  $('qsScroll').querySelectorAll('[data-add]').forEach(b=>b.onclick=()=>{ const p=PIECES[+b.dataset.add], row=p.sizes.find(s=>s[0]===chosen[p.key]&&s[2]); if(!row) return;
    track('add_to_bag',{source:'quick_shop',handle:p.handle,color:p.color,size:row[0]}); addToBag(row[1]); });
  $('qsScroll').querySelectorAll('[data-3d]').forEach(b=>b.onclick=()=>{ if(window.__flat) return; const i=+b.dataset['3d'];
    closeQS(); if(mode==='intro'){ if(!$('enterQuiet').disabled){ enter(false,i); } } else focusPiece(i); });
  const t3=$('qsTo3d'); if(t3) t3.onclick=()=>{ closeQS(); if(mode==='intro'&&!$('enterQuiet').disabled) enter(false); };
}
function openQS(from){ if(bagEl.classList.contains('open')) closeBag(); if(mode!=='intro'&&mode!=='walk'&&mode!=='flat'&&!window.__flat) backToFloor(true); else closeDrawerUI();
  qsOpen=true; qsEl.hidden=false; body.classList.add('qs-open'); $('intro').style.visibility='hidden'; hideToast(); renderQS(); loadImages();
  requestAnimationFrame(()=>qsEl.classList.add('open')); setTimeout(()=>{ if(qsOpen) qsShown=true; },320);
  $('qsBtn').setAttribute('aria-pressed','true'); track('quick_shop_open',{from}); const f=qsEl.querySelector('.chip:not([disabled]),.chrome-btn'); f&&f.focus({preventScroll:true}); }
function closeQS(){ qsOpen=false; qsShown=false; $('intro').style.visibility=''; qsEl.classList.remove('open'); body.classList.remove('qs-open'); $('qsBtn').setAttribute('aria-pressed','false');
  setTimeout(()=>{ if(!qsOpen) qsEl.hidden=true; },320); }
document.addEventListener('cart:refresh',()=>{ if(qsOpen) qsFoot(); });
/* =========================================================
   LED edge glow: follows whichever pop-up is open (detail panel, bag, toast)
   ========================================================= */
const GLOWS=[[drawer,false],[bagEl,false],[$('toast'),true]].map(([el,over])=>{ const g=document.createElement('div'); g.className='psb-glow'+(over?' over':''); g.setAttribute('aria-hidden','true');
  g.innerHTML='<div class="g-soft"><i></i></div><div class="g-ring"><i></i></div>'; body.appendChild(g); return {el,g,on:false}; });
function syncGlow(){
  GLOWS.forEach(o=>{ const open=o.el.classList.contains('open')||o.el.classList.contains('show');
    if(open){ const r=o.el.getBoundingClientRect(); const st=o.g.style;
      st.transform=`translate(${r.left}px,${r.top}px)`; st.width=r.width+'px'; st.height=r.height+'px'; st.borderRadius=getComputedStyle(o.el).borderRadius; }
    if(open!==o.on){ o.on=open; o.g.classList.toggle('on',open); } });
  requestAnimationFrame(syncGlow); }
requestAnimationFrame(syncGlow);

addEventListener('keydown',e=>{ if(e.key==='Escape'&&qsOpen&&!bagEl.classList.contains('open')) closeQS(); });


/* =========================================================
   Renderer
   ========================================================= */
const canvas=$('scene');
let renderer;
try{ if(!window.THREE||!THREE.Reflector||!THREE.GLTFLoader) throw 0; renderer=new THREE.WebGLRenderer({canvas,antialias:true,powerPreference:'high-performance'}); }
catch(e){ return fallback(); }
function fallback(){
  canvas.hidden=true; $('intro').classList.add('gone'); $('hud').style.display='none'; $('fallback').hidden=false; mode='flat';
  $('fallbackGrid').innerHTML=PIECES.map((p,i)=>`<button data-i="${i}"><img src="${TH[p.key]}" alt=""><span class="eyebrow">PSB / ${pad(i+1)}</span><strong style="font-stretch:125%;text-transform:uppercase">${PRODUCTS[p.handle].title}</strong><span class="serif" style="color:var(--chrome);font-size:17px">${p.color} · ${inStock(p)?money(pieceFrom(p)):'Sold out'}</span></button>`).join('');
  $('fallbackGrid').querySelectorAll('button').forEach(b=>b.onclick=()=>{sel=+b.dataset.i;updateHUD();openDrawer();});
  window.__flat=true; $('fallback').hidden=true; openQS('fallback');
}
const HQ=!COARSE;
const DPR=Math.min(devicePixelRatio||1,COARSE?1.5:2);
renderer.setPixelRatio(DPR); renderer.setSize(innerWidth,innerHeight,false);
renderer.outputEncoding=THREE.sRGBEncoding; renderer.toneMapping=THREE.ACESFilmicToneMapping; renderer.toneMappingExposure=1.05;
if(HQ){ renderer.shadowMap.enabled=true; renderer.shadowMap.type=THREE.PCFSoftShadowMap; renderer.shadowMap.autoUpdate=false; }
const MAXANI=renderer.capabilities.getMaxAnisotropy();
const scene=new THREE.Scene(); const VOID=0x07080b;
scene.background=new THREE.Color(VOID); scene.fog=new THREE.FogExp2(VOID,.034);
const pmrem=new THREE.PMREMGenerator(renderer);
scene.environment=pmrem.fromScene(new THREE.RoomEnvironment(),.04).texture;
const camera=new THREE.PerspectiveCamera(52,innerWidth/innerHeight,.03,120);
const white=new THREE.Color(0xffffff);

/* =========================================================
   Cinematic finish: bloom, contact shadows (screen-space AO), focus depth of field, grain + vignette
   tier 2 = everything (desktop), 1 = no AO (phones), 0 = straight render (old GPUs, or ?nopost)
   ========================================================= */
const POST={tier:0,rt:null,bloom:null,quad:null,mat:null,focus:0,focusZ:1.2,ao:0,frames:[],checked:0};
(function initPost(){
  try{
    if(!renderer.capabilities.isWebGL2||!THREE.UnrealBloomPass||!THREE.FullScreenQuad||/[?&]nopost/.test(location.search)) return;
    const s=renderer.getDrawingBufferSize(new THREE.Vector2());
    const dtex=new THREE.DepthTexture(s.x,s.y); dtex.type=THREE.UnsignedIntType;
    POST.rt=new THREE.WebGLRenderTarget(s.x,s.y,{type:THREE.HalfFloatType,samples:4,depthTexture:dtex});
    POST.bloom=new THREE.UnrealBloomPass(new THREE.Vector2(s.x,s.y),COARSE?.42:.5,.28,.97);
    /* contact shadows: half-res AO pass, blurred in the composite */
    POST.aoRT=new THREE.WebGLRenderTarget(Math.ceil(s.x/2),Math.ceil(s.y/2),{type:THREE.UnsignedByteType});
    POST.aoMat=new THREE.ShaderMaterial({uniforms:{tDepth:{value:null},uProjInv:{value:new THREE.Matrix4()},uP11:{value:1},uRes:{value:new THREE.Vector2(s.x,s.y)}},
      vertexShader:'varying vec2 vUv; void main(){ vUv=uv; gl_Position=vec4(position.xy,0.,1.); }',
      fragmentShader:`precision highp float;
uniform sampler2D tDepth; uniform mat4 uProjInv; uniform vec2 uRes; uniform float uP11; varying vec2 vUv;
vec3 viewPos(vec2 uv){ float d=texture2D(tDepth,uv).x; vec4 p=uProjInv*vec4(uv*2.-1.,d*2.-1.,1.); return p.xyz/p.w; }
float ign(vec2 p){ return fract(52.9829189*fract(dot(p,vec2(.06711056,.00583715)))); }
void main(){
  vec3 P=viewPos(vUv); float z=-P.z; float occ=0.;
  vec3 N=normalize(cross(dFdx(P),dFdy(P)));
  float R=.28, rp=min(R*uP11*.5*uRes.y/z,64.);
  if(z<30.&&rp>2.){ float a0=ign(gl_FragCoord.xy)*6.2832;
    for(int i=0;i<12;i++){ float fi=float(i); float a=a0+fi*2.39996; float r=sqrt((fi+.5)/12.);
      vec3 S=viewPos(vUv+vec2(cos(a),sin(a))*r*rp/uRes); vec3 v=S-P; float l=length(v)+1e-4;
      occ+=max(0.,dot(N,v)/l-.12)*(1.-smoothstep(R*.6,R*1.6,l)); }
    occ=clamp(occ/12.*2.2,0.,1.); }
  gl_FragColor=vec4(occ,0.,0.,1.);
}`,depthTest:false,depthWrite:false});
    POST.aoMat.extensions.derivatives=true; POST.aoQuad=new THREE.FullScreenQuad(POST.aoMat);
    POST.mat=new THREE.ShaderMaterial({
      uniforms:{tColor:{value:null},tDepth:{value:null},tAO:{value:null},uProjInv:{value:new THREE.Matrix4()},uP11:{value:1},uRes:{value:new THREE.Vector2(s.x,s.y)},
        uTime:{value:0},uFocus:{value:0},uFocusZ:{value:1.2},uAperture:{value:.55},uMaxR:{value:16},uAO:{value:0},uGrain:{value:.032},uVig:{value:.34}},
      vertexShader:'varying vec2 vUv; void main(){ vUv=uv; gl_Position=vec4(position.xy,0.,1.); }',
      fragmentShader:`precision highp float;
uniform sampler2D tColor,tDepth,tAO; uniform mat4 uProjInv; uniform vec2 uRes; uniform float uP11,uTime,uFocus,uFocusZ,uAperture,uMaxR,uAO,uGrain,uVig;
varying vec2 vUv;
vec3 viewPos(vec2 uv){ float d=texture2D(tDepth,uv).x; vec4 p=uProjInv*vec4(uv*2.-1.,d*2.-1.,1.); return p.xyz/p.w; }
float ign(vec2 p){ return fract(52.9829189*fract(dot(p,vec2(.06711056,.00583715)))); }
float cocAt(float z){ return clamp(abs(z-uFocusZ)/max(z,.05)*uAperture,0.,1.)*uFocus; }
vec3 toSRGB(vec3 c){ c=clamp(c,0.,1.); return mix(c*12.92,1.055*pow(c,vec3(1./2.4))-.055,step(.0031308,c)); }
void main(){
  vec2 uv=vUv; vec3 col=texture2D(tColor,uv).rgb;
  vec3 P=viewPos(uv); float z=-P.z; float blur=0.;
  if(uFocus>.002){
    float coc=cocAt(z); float rad=coc*uMaxR;
    if(rad>.6){ vec3 acc=col; float ws=1.; float a0=ign(gl_FragCoord.xy)*6.2832;
      for(int i=0;i<24;i++){ float fi=float(i); float r=sqrt((fi+.5)/24.); float a=a0+fi*2.39996;
        vec2 su=uv+vec2(cos(a),sin(a))*r*rad/uRes; float sz=-viewPos(su).z;
        float w=clamp(cocAt(sz)*uMaxR-r*rad+1.,0.,1.); acc+=texture2D(tColor,su).rgb*w; ws+=w; }
      blur=smoothstep(.6,3.,rad); col=mix(col,acc/ws,blur); }
  }
  if(uAO>.001){ float o=0.,w=0.; vec2 px=2./uRes;
    for(int i=-2;i<2;i++) for(int j=-2;j<2;j++){ vec2 su=uv+(vec2(float(i),float(j))+.5)*px; float sz=-viewPos(su).z; float k=1.-smoothstep(.0,.08,abs(sz-z)/z); o+=texture2D(tAO,su).r*k; w+=k; }
    col*=1.-uAO*(1.-blur)*.6*o/max(w,1e-3); }
  vec2 q=uv-.5; col*=1.-uVig*dot(q,q)*1.7;
  col=toSRGB(col);
  col+=(ign(gl_FragCoord.xy+vec2(uTime*61.7,uTime*23.3))-.5)*uGrain;
  gl_FragColor=vec4(col,1.);
}`,depthTest:false,depthWrite:false});
    POST.mat.extensions.derivatives=true;
    POST.quad=new THREE.FullScreenQuad(POST.mat);
    POST.tier=HQ?2:1; POST.ao=POST.tier===2?.8:0;
  }catch(e){ console.warn('PSB: post-processing off',e); POST.tier=0; }
})();
function postSize(){ if(!POST.rt) return; const s=renderer.getDrawingBufferSize(new THREE.Vector2());
  POST.rt.setSize(s.x,s.y); POST.aoRT.setSize(Math.ceil(s.x/2),Math.ceil(s.y/2)); POST.aoMat.uniforms.uRes.value.set(s.x,s.y); POST.bloom.setSize(s.x,s.y); POST.mat.uniforms.uRes.value.set(s.x,s.y); POST.mat.uniforms.uMaxR.value=s.y*(COARSE?.016:.02); }
postSize();
function renderFrame(t){
  if(!POST.tier){ renderer.render(scene,camera); return; }
  renderer.setRenderTarget(POST.rt); renderer.render(scene,camera);
  POST.bloom.render(renderer,null,POST.rt,0,false);
  const u=POST.mat.uniforms;
  if(POST.ao>0){ const a=POST.aoMat.uniforms; a.tDepth.value=POST.rt.depthTexture; a.uProjInv.value.copy(camera.projectionMatrixInverse); a.uP11.value=camera.projectionMatrix.elements[5];
    renderer.setRenderTarget(POST.aoRT); POST.aoQuad.render(renderer); }
  renderer.setRenderTarget(null); u.tAO.value=POST.aoRT.texture; u.tColor.value=POST.rt.texture; u.tDepth.value=POST.rt.depthTexture;
  u.uProjInv.value.copy(camera.projectionMatrixInverse); u.uP11.value=camera.projectionMatrix.elements[5];
  u.uTime.value=t%100; u.uFocus.value=POST.focus; u.uFocusZ.value=POST.focusZ; u.uAO.value=POST.ao;
  POST.quad.render(renderer);
}
/* if the device can't keep up, step the finish down: AO first, then everything */
function postGovernor(dt){
  if(!POST.tier||mode==='intro'||document.hidden) return;
  POST.frames.push(dt); if(POST.frames.length<90) return;
  const avg=POST.frames.reduce((a,b)=>a+b,0)/POST.frames.length; POST.frames=[];
  if(avg>.034&&POST.ao>0){ POST.ao=0; POST.tier=1; }
  else if(avg>.045&&POST.tier===1&&++POST.checked>1){ POST.tier=0; }
}

/* helpers */
function cnv(w,h){const c=document.createElement('canvas');c.width=w;c.height=h;return [c,c.getContext('2d')];}
function glowTex(){const [c,g]=cnv(256,256);const r=g.createRadialGradient(128,128,0,128,128,128);
  r.addColorStop(0,'rgba(255,255,255,1)');r.addColorStop(.18,'rgba(255,255,255,.55)');r.addColorStop(.5,'rgba(255,255,255,.12)');r.addColorStop(1,'rgba(255,255,255,0)');
  g.fillStyle=r;g.fillRect(0,0,256,256);return new THREE.CanvasTexture(c);}
function vGrad(){const [c,g]=cnv(4,256);const r=g.createLinearGradient(0,0,0,256);
  r.addColorStop(0,'rgba(255,255,255,0)');r.addColorStop(.25,'rgba(255,255,255,.9)');r.addColorStop(.75,'rgba(255,255,255,.9)');r.addColorStop(1,'rgba(255,255,255,0)');
  g.fillStyle=r;g.fillRect(0,0,4,256);return new THREE.CanvasTexture(c);}
function fluteTex(){const [c,g]=cnv(512,4);const img=g.createImageData(512,4);const w=32;
  for(let x=0;x<512;x++){const u=(x%w)/w*2-1,nx=u*.9,nz=Math.sqrt(1-nx*nx);for(let y=0;y<4;y++){const i=(y*512+x)*4;img.data[i]=(nx*.5+.5)*255;img.data[i+1]=128;img.data[i+2]=(nz*.5+.5)*255;img.data[i+3]=255;}}
  g.putImageData(img,0,0);const t=new THREE.CanvasTexture(c);t.wrapS=t.wrapT=THREE.RepeatWrapping;return t;}
function marbleTex(){const [c,g]=cnv(1024,1024);g.fillStyle='#e9e6e0';g.fillRect(0,0,1024,1024);
  let s=7;const rnd=()=>(s=(s*16807)%2147483647)/2147483647;
  for(let k=0;k<26;k++){g.strokeStyle=`rgba(${110+rnd()*40|0},${112+rnd()*40|0},${118+rnd()*40|0},${.08+rnd()*.22})`;g.lineWidth=.6+rnd()*3.2;g.beginPath();let x=rnd()*1024,y=-20;g.moveTo(x,y);
    for(let i=0;i<9;i++){x+=(rnd()-.5)*260;y+=60+rnd()*90;g.quadraticCurveTo(x+(rnd()-.5)*120,y-50,x,y);}g.stroke();}
  const t=new THREE.CanvasTexture(c);t.encoding=THREE.sRGBEncoding;t.wrapS=t.wrapT=THREE.RepeatWrapping;return t;}
const GLOW=glowTex(), VG=vGrad(), FLUTE=fluteTex();
const addMat=(color,opacity,map=GLOW)=>new THREE.MeshBasicMaterial({map,color,transparent:true,opacity,blending:THREE.AdditiveBlending,depthWrite:false,toneMapped:false,side:THREE.DoubleSide});
const fontsReady=Promise.race([document.fonts?Promise.all([document.fonts.load('500 64px "IBM Plex Mono"'),document.fonts.load('italic 500 64px "Cormorant Garamond"'),document.fonts.load('800 64px "Archivo"')]):Promise.resolve(),new Promise(r=>setTimeout(r,2000))]);
function textTex(lines,w,h){ const [c,g]=cnv(w,h); g.textBaseline='middle';
  lines.forEach(L=>{g.font=L.font;g.fillStyle=L.color||'#efece6';g.textAlign=L.align||'left';if(g.letterSpacing!==undefined)g.letterSpacing=L.ls||'0px';g.fillText(L.text,L.x,L.y);});
  const t=new THREE.CanvasTexture(c); t.encoding=THREE.sRGBEncoding; t.anisotropy=MAXANI; return t; }

/* materials (the PSB restyle of the store) */
const M={
  lacquer:new THREE.MeshStandardMaterial({color:0x0e0f12,roughness:.3,metalness:.25,envMapIntensity:.45}),
  walnut:new THREE.MeshStandardMaterial({color:0x2c211b,roughness:.5,metalness:0,envMapIntensity:.3}),
  chrome:new THREE.MeshStandardMaterial({color:0xffffff,roughness:.12,metalness:1,envMapIntensity:1.3}),
  blackChrome:new THREE.MeshStandardMaterial({color:0x34363b,roughness:.2,metalness:1,envMapIntensity:1}),
  mirrorChrome:new THREE.MeshStandardMaterial({color:0xe8eaee,roughness:.06,metalness:1,envMapIntensity:1.6}),
  marble:new THREE.MeshStandardMaterial({color:0xffffff,map:marbleTex(),roughness:.18,metalness:0,envMapIntensity:.5}),
  rug:new THREE.MeshStandardMaterial({color:0x1d1e22,roughness:1,metalness:0,envMapIntensity:.05}),
  felt:new THREE.MeshStandardMaterial({color:0x232428,roughness:1,metalness:0,envMapIntensity:.05}),
  velvet:new THREE.MeshStandardMaterial({color:0x17181c,roughness:.92,metalness:0,envMapIntensity:.15,side:THREE.DoubleSide}),
  leather:new THREE.MeshStandardMaterial({color:0x101114,roughness:.35,metalness:0,envMapIntensity:.5}),
  boucle:new THREE.MeshStandardMaterial({color:0xd8d2c6,roughness:1,metalness:0,envMapIntensity:.1}),
  plastic:new THREE.MeshStandardMaterial({color:0x0c0d0f,roughness:.4,metalness:.1,envMapIntensity:.4}),
  darkMirror:new THREE.MeshStandardMaterial({color:0x5a5e66,roughness:.03,metalness:1,envMapIntensity:.9}),
  box:new THREE.MeshStandardMaterial({color:0x111215,roughness:.7,metalness:0,envMapIntensity:.15}),
  floor:new THREE.MeshStandardMaterial({color:0x111216,roughness:.28,metalness:.2,envMapIntensity:.35}),
  cotton:[0xe8e6e1,0x5c3f32,0x141416,0xe8e6e1,0x5c3f32].map(c=>new THREE.MeshStandardMaterial({color:c,roughness:.95,metalness:0,envMapIntensity:.15}))
};
/* folded polos + tees: PSB mark on the wearer's left chest, placed in each garment's own UV space */
const POLO_COLS=[[0xe8e6e1,'#141416'],[0x5c3f32,'#efece6'],[0x141416,'#efece6']];
const LOGO_UV={polo:{c:[.1505,.3157],r:[-.0602,0],u:[0,-.0745]},tee:{c:[.3035,.5986],r:[.0589,.0014],u:[-.0009,.0599]}};
const poloMats={};
function poloMat(kind,i){ const ci=i%POLO_COLS.length, k=kind+ci; if(poloMats[k]) return poloMats[k];
  const [col,ink]=POLO_COLS[ci];
  const m=new THREE.MeshStandardMaterial({color:0xffffff,roughness:.95,metalness:0,envMapIntensity:.15});
  const img=new Image(); img.onload=()=>{
    const S=1024, [c,g]=cnv(S,S); g.fillStyle='#'+new THREE.Color(col).getHexString(); g.fillRect(0,0,S,S);
    const [lc,lg]=cnv(img.width,img.height); lg.drawImage(img,0,0); lg.globalCompositeOperation='source-in'; lg.fillStyle=ink; lg.fillRect(0,0,img.width,img.height);
    const L=LOGO_UV[kind], iw=img.width, ih=img.height, h=ih/iw;
    g.setTransform(L.r[0]*S/iw, L.r[1]*S/iw, -L.u[0]*S/iw, -L.u[1]*S/iw, (L.c[0]-.5*L.r[0]+h/2*L.u[0])*S, (L.c[1]-.5*L.r[1]+h/2*L.u[1])*S);
    g.drawImage(lc,0,0);
    const t=new THREE.CanvasTexture(c); t.flipY=false; t.encoding=THREE.sRGBEncoding; t.anisotropy=MAXANI; m.map=t; m.needsUpdate=true; };
  img.crossOrigin='anonymous'; img.src=CFG.files.mark; return poloMats[k]=m; }
function matFor(name,i){
  const n=name.toLowerCase();
  if(n.includes('gengyijian_ditan')) return M.felt;
  if(n.includes('ditan')) return M.rug;
  if(n.includes('jingzi')) return M.darkMirror;
  if(n.includes('gengyijianjiazi')) return M.chrome;
  if(n.includes('kuangjia')) return M.lacquer;
  if(n.includes('dengzi')) return M.leather;
  if(n.includes('chuanglian')) return M.velvet;
  if(n.includes('huawen')) return M.walnut;
  if(n.includes('heitie')) return M.blackChrome;
  if(n.includes('jinshu')||n.includes('lashou')||n.includes('zhijia')||n.startsWith('jiazi02')) return M.chrome;
  if(n.includes('dalishi')) return M.marble;
  if(n.includes('buliao')) return M.boucle;
  if(n.includes('model')) return M.mirrorChrome;
  if(n.startsWith('chenshan')) return poloMat('polo',i);
  if(n.includes('shangyi')) return poloMat('tee',i);
  if(n.includes('jiazi03_kuzi')) return M.cotton[i%M.cotton.length];
  if(n.includes('diannao')||n.includes('pos')) return M.plastic;
  if(n.includes('nanxie')||n.includes('gaogenxie')) return M.leather;
  if(n.includes('xiebaozhuang')) return M.box;
  if(n.includes('jiazi01_mutou')||n.includes('jiazi03_mutou')) return M.walnut;
  return M.lacquer;
}

/* =========================================================
   World: shell, lights, branding
   ========================================================= */
const world=new THREE.Group(); scene.add(world);
const ROOM={x0:-4.9,x1:4.55,z0:-6.3,z1:6.5,h:3.3};
function fluted(w,color,rx){ const n=FLUTE.clone(); n.needsUpdate=true; n.repeat.set(w/.16/16,1);
  return new THREE.MeshStandardMaterial({color,roughness:.6,metalness:.2,normalMap:n,normalScale:new THREE.Vector2(1.2,1.2),envMapIntensity:.08}); }
function wallMesh(w,h,mat,pos,ry){ const m=new THREE.Mesh(new THREE.PlaneGeometry(w,h),mat); m.position.set(...pos); m.rotation.y=ry; m.receiveShadow=true; world.add(m); return m; }
const D=ROOM.z1-ROOM.z0, W=ROOM.x1-ROOM.x0;
wallMesh(D,ROOM.h,fluted(D,0x101115),[ROOM.x0,ROOM.h/2,(ROOM.z0+ROOM.z1)/2],Math.PI/2);
wallMesh(D,ROOM.h,fluted(D,0x101115),[ROOM.x1,ROOM.h/2,(ROOM.z0+ROOM.z1)/2],-Math.PI/2);
wallMesh(W,ROOM.h,fluted(W,0x0f1013),[(ROOM.x0+ROOM.x1)/2,ROOM.h/2,ROOM.z0],0);
{ const c=new THREE.Mesh(new THREE.PlaneGeometry(W,D),new THREE.MeshStandardMaterial({color:0x060708,roughness:.9,envMapIntensity:.05})); c.rotation.x=Math.PI/2; c.position.set((ROOM.x0+ROOM.x1)/2,ROOM.h,(ROOM.z0+ROOM.z1)/2); world.add(c); }
/* =========================================================
   Façade: board-formed concrete, brushed-steel fascia, real channel letters (lit faces + halo),
   steel canopy, black storefront, wet pavers that mirror the sign
   ========================================================= */
const FILE=n=>String(CFG.files.mark).replace(/psb-mark\.webp.*$/,n);
const EXTRA=[];                       // extra loads the doors wait for
const FZ=ROOM.z1, FXC=(ROOM.x0+ROOM.x1)/2;
const rng=seed=>{ let v=seed; return ()=>(v=(v*16807)%2147483647)/2147483647; };
function concreteTex(){ const [c,g]=cnv(512,1024), r=rng(11); g.fillStyle='#55565a'; g.fillRect(0,0,512,1024);
  for(let i=0;i<14000;i++){ const v=70+r()*55|0; g.fillStyle=`rgba(${v},${v},${v+4},${.04+r()*.1})`; const z=1+r()*3; g.fillRect(r()*512,r()*1024,z,z); }
  for(let i=0;i<70;i++){ g.fillStyle=`rgba(12,12,14,${.02+r()*.05})`; g.fillRect(r()*512,r()*1024,1+r()*5,40+r()*320); }
  for(let y=0;y<1024;y+=128){ g.fillStyle='rgba(18,18,20,.45)'; g.fillRect(0,y,512,2); g.fillStyle='rgba(255,255,255,.05)'; g.fillRect(0,y+2,512,1);
    for(let k=0;k<3;k++){ g.fillStyle='rgba(14,14,16,.55)'; g.beginPath(); g.arc(86+k*170,y+64,5,0,7); g.fill(); } }
  const t=new THREE.CanvasTexture(c); t.encoding=THREE.sRGBEncoding; t.anisotropy=MAXANI; t.wrapS=t.wrapT=THREE.RepeatWrapping; return t; }
function streakTex(){ const [c,g]=cnv(16,512), r=rng(5); for(let y=0;y<512;y++){ const v=150+r()*60|0; g.fillStyle=`rgb(${v},${v},${v})`; g.fillRect(0,y,16,1); }
  const t=new THREE.CanvasTexture(c); t.wrapS=t.wrapT=THREE.RepeatWrapping; return t; }
function paverTex(){ const S=1024, [c,g]=cnv(S,S), [rc,rg]=cnv(S,S), [ac,ag]=cnv(S,S), r=rng(23), n=10, p=S/n;
  rg.fillStyle='#9a9a9a'; rg.fillRect(0,0,S,S); ag.fillStyle='#e6e6e6'; ag.fillRect(0,0,S,S);
  for(let i=0;i<n;i++) for(let j=0;j<n;j++){ const v=24+r()*14|0; g.fillStyle=`rgb(${v},${v},${v+3})`; g.fillRect(i*p,j*p,p,p);
    for(let k=0;k<160;k++){ const w=v+(r()-.5)*14|0; g.fillStyle=`rgba(${w},${w},${w},.5)`; g.fillRect(i*p+r()*p,j*p+r()*p,2,2); } }
  g.fillStyle='#0d0e10'; for(let i=0;i<=n;i++){ g.fillRect(i*p-2,0,4,S); g.fillRect(0,i*p-2,S,4); }
  for(let k=0;k<9;k++){ const x=r()*S, y=r()*S, rx=40+r()*150, ry=25+r()*80;
    [rg,ag].forEach((q,qi)=>{ const gr=q.createRadialGradient(x,y,0,x,y,rx); gr.addColorStop(0,qi?'rgba(40,40,40,1)':'rgba(14,14,14,1)'); gr.addColorStop(.7,qi?'rgba(40,40,40,.8)':'rgba(14,14,14,.8)'); gr.addColorStop(1,'rgba(0,0,0,0)');
      q.save(); q.translate(x,y); q.scale(1,ry/rx); q.translate(-x,-y); q.fillStyle=gr; q.beginPath(); q.arc(x,y,rx,0,7); q.fill(); q.restore(); }); }
  const T=x=>{ const t=new THREE.CanvasTexture(x); t.wrapS=t.wrapT=THREE.RepeatWrapping; t.anisotropy=MAXANI; return t; };
  const map=T(c); map.encoding=THREE.sRGBEncoding; return {map,rough:T(rc),alpha:T(ac)}; }
const FAC={
  concrete:new THREE.MeshStandardMaterial({map:concreteTex(),roughness:.92,metalness:0,envMapIntensity:.25}),
  steel:new THREE.MeshStandardMaterial({color:0x111215,metalness:.9,roughness:1,roughnessMap:streakTex(),envMapIntensity:.42}),
  frame:new THREE.MeshStandardMaterial({color:0x0b0c0e,metalness:.6,roughness:.38,envMapIntensity:.6}),
  plaster:new THREE.MeshStandardMaterial({color:0x131418,roughness:.95,metalness:0,envMapIntensity:.12})
};
FAC.steel.roughnessMap.repeat.set(1,12);
FAC.concrete.map.repeat.set(1,1);
const box=(w,h,d,mat,x,y,z,par=world)=>{ const m=new THREE.Mesh(new THREE.BoxGeometry(w,h,d),mat); m.position.set(x,y,z); m.castShadow=m.receiveShadow=true; par.add(m); return m; };
const glass=new THREE.MeshStandardMaterial({color:0x0c0e12,roughness:.04,metalness:.9,transparent:true,opacity:.3,envMapIntensity:.9,side:THREE.DoubleSide,depthWrite:false});
[[ROOM.x0,-1.15],[1.15,ROOM.x1]].forEach(([a,b])=>{ const g=new THREE.Mesh(new THREE.PlaneGeometry(b-a,2.75),glass); g.position.set((a+b)/2,1.375,FZ); world.add(g);
  box(.07,2.75,.12,FAC.frame,a<0?b:a,1.375,FZ);                                   // door jambs
  const n=Math.round((b-a)/1.25); for(let k=1;k<n;k++) box(.045,2.75,.1,FAC.frame,a+(b-a)*k/n,1.375,FZ); // mullions
  box(b-a,.24,.1,FAC.frame,(a+b)/2,.12,FZ); });                                    // kick plates
box(2.3,.012,.16,M.chrome,0,.006,FZ);                                               // threshold
/* building: pilasters, fascia, upper wall, neighbours */
const FW=W+1.3, FH0=2.75, FH1=4.4;
[ROOM.x0-.3,ROOM.x1+.3].forEach(x=>{ const pl=box(.62,FH1+.25,.62,FAC.concrete,x,(FH1+.25)/2,FZ+.12); pl.material=FAC.concrete; });
box(FW,FH1-FH0,.34,FAC.steel,FXC,(FH0+FH1)/2,FZ+.16);
box(FW+.2,.05,.4,FAC.frame,FXC,FH1+.025,FZ+.18);                                    // coping
box(FW+.2,.035,.38,FAC.frame,FXC,FH0-.0175,FZ+.18);                                 // soffit edge
const ROOF=5.25;
{ const up=new THREE.Mesh(new THREE.PlaneGeometry(FW+.6,ROOF-FH1),FAC.plaster); up.position.set(FXC,(FH1+ROOF)/2,FZ+.02); world.add(up);
  box(FW+.7,.08,.5,FAC.frame,FXC,ROOF+.04,FZ+.1);
  [[-1,6.4],[1,7.1]].forEach(([sd,hh])=>{ const nb=new THREE.Mesh(new THREE.PlaneGeometry(14,hh),FAC.plaster); nb.position.set(sd<0?ROOM.x0-.61-7:ROOM.x1+.61+7,hh/2,FZ+.02); world.add(nb);
    box(14,.08,.4,FAC.frame,nb.position.x,hh+.04,FZ+.1); }); }
/* steel blade canopy over the door, with downlights */
const canopy=new THREE.Group(); canopy.position.set(0,2.84,FZ); world.add(canopy);
box(3.3,.07,1.45,FAC.steel,0,0,.72,canopy); box(3.3,.02,1.45,FAC.frame,0,-.045,.72,canopy);
const dlMat=new THREE.MeshBasicMaterial({color:new THREE.Color(0xffe2bd).multiplyScalar(2.2),toneMapped:false});
[-1.05,0,1.05].forEach(x=>{ const d=new THREE.Mesh(new THREE.CircleGeometry(.05,24),dlMat); d.rotation.x=Math.PI/2; d.position.set(x,-.056,.95); canopy.add(d); });
const canopyLight=new THREE.SpotLight(0xffd9ad,HQ?3.2:2.4,7,.95,.75,1.4); canopyLight.position.set(0,2.75,FZ+.95); canopyLight.target.position.set(0,0,FZ+1.6); scene.add(canopyLight,canopyLight.target);
/* the street: wet pavers (they mirror the sign on desktop), curb, asphalt */
const PAV=paverTex(); let PAVMAT=null;
let streetReflector=null;
{ const SW=30, SD=5.2, cz=FZ+SD/2;
  const pm=new THREE.MeshStandardMaterial({map:PAV.map,roughnessMap:PAV.rough,roughness:1,metalness:.15,envMapIntensity:.55}); PAVMAT=pm;
  [PAV.map,PAV.rough,PAV.alpha].forEach(t=>t.repeat.set(SW/6,SD/6));
  if(HQ){ streetReflector=new THREE.Reflector(new THREE.PlaneGeometry(SW,SD),{clipBias:.003,textureWidth:innerWidth*DPR*.45,textureHeight:innerHeight*DPR*.45,color:0x8d939c});
    streetReflector.rotation.x=-Math.PI/2; streetReflector.position.set(0,.0004,cz); streetReflector.visible=false; world.add(streetReflector);
    pm.transparent=true; pm.alphaMap=PAV.alpha; pm.depthWrite=true; }
  const pv=new THREE.Mesh(new THREE.PlaneGeometry(SW,SD),pm); pv.rotation.x=-Math.PI/2; pv.position.set(0,.002,cz); pv.receiveShadow=true; world.add(pv);
  box(SW,.14,.28,FAC.concrete,0,.07-.12,FZ+SD+.14);
  const as=new THREE.Mesh(new THREE.PlaneGeometry(60,40),new THREE.MeshStandardMaterial({color:0x0b0c0e,roughness:.55,metalness:.2,envMapIntensity:.3})); as.rotation.x=-Math.PI/2; as.position.set(0,-.12,FZ+SD+.28+20); world.add(as);
  const ln=new THREE.Mesh(new THREE.PlaneGeometry(30,.1),new THREE.MeshStandardMaterial({color:0x8a8478,roughness:.7})); ln.rotation.x=-Math.PI/2; ln.position.set(0,-.115,FZ+SD+4); world.add(ln); }
/* window graphics */
fontsReady.then(()=>{
  const vt=textTex([{text:'POWERFUL SINCE BIRTH',font:'800 58px "Archivo", sans-serif',x:512,y:70,ls:'14px',align:'center'},
    {text:'FLAGSHIP  ·  DESIGNED BY WINNERS',font:'500 26px "IBM Plex Mono", monospace',x:512,y:142,ls:'8px',align:'center',color:'#c7cbd3'},
    {text:'Open every hour, online.',font:'italic 500 40px "Cormorant Garamond", serif',x:512,y:206,align:'center',color:'#efece6'}],1024,256);
  const v=new THREE.Mesh(new THREE.PlaneGeometry(1.5,.375),new THREE.MeshBasicMaterial({map:vt,transparent:true,opacity:.82,depthWrite:false})); v.position.set(-3.05,1.52,FZ-.012); world.add(v);
  const v2=v.clone(); v2.rotation.y=Math.PI; v2.position.z=FZ-.02; v2.material=v.material.clone(); v2.material.opacity=.25; world.add(v2); });
new THREE.TextureLoader().setCrossOrigin('anonymous').load(CFG.files.mark,t=>{ t.encoding=THREE.sRGBEncoding;
  const m=new THREE.Mesh(new THREE.PlaneGeometry(.62,.62*81/230),new THREE.MeshBasicMaterial({map:t,transparent:true,opacity:.85,depthWrite:false})); m.position.set(2.85,1.6,FZ-.012); world.add(m); });
/* channel letters: traced from the PSB lockup, extruded, front-lit faces and a halo on the fascia */
const signTL=new THREE.TextureLoader(); signTL.setCrossOrigin('anonymous');
const SIGN={y:4.24,z:FZ+.335,w:3.0};
/* halo: the lockup, padded and blurred by down/up-sampling (works everywhere, no canvas filters) */
function haloTex(img){ const PW=1600+640, PH=460+640; const [a,ag]=cnv(PW/8,PH/8); ag.drawImage(img,40,40,200,57.5);
  const [b,bg]=cnv(PW/32,PH/32); bg.drawImage(a,0,0,PW/32,PH/32); const [c,g]=cnv(PW/4,PH/4); g.imageSmoothingEnabled=true;
  g.globalAlpha=.75; g.drawImage(a,0,0,PW/4,PH/4); g.globalAlpha=1; g.drawImage(b,0,0,PW/4,PH/4);
  const t=new THREE.CanvasTexture(c); t.encoding=THREE.sRGBEncoding; return t; }
let signFaceMat=null, haloMesh=null;
EXTRA.push(new Promise(res=>{
  signTL.load(CFG.files.lockup,t=>{ t.encoding=THREE.sRGBEncoding;
    /* the back wall keeps the flat lit lockup */
    const back=new THREE.Mesh(new THREE.PlaneGeometry(1.95,1.95*460/1600),new THREE.MeshBasicMaterial({map:t,transparent:true,toneMapped:false,opacity:.92}));
    back.position.set(-1.84,2.98,ROOM.z0+.02); world.add(back);
    const bh=new THREE.Mesh(new THREE.PlaneGeometry(3.4,1.4),addMat(0xffffff,.12)); bh.position.set(-1.84,2.98,ROOM.z0+.03); world.add(bh);
    /* halo behind the letters, on the steel */
    haloMesh=new THREE.Mesh(new THREE.PlaneGeometry(SIGN.w*2240/1600,SIGN.w*1100/1600),addMat(0xe7ecff,.7,haloTex(t.image))); haloMesh.position.set(FXC,SIGN.y-.43125,FZ+.333); world.add(haloMesh);
    const flat=()=>{ const sign=new THREE.Mesh(new THREE.PlaneGeometry(SIGN.w,SIGN.w*460/1600),new THREE.MeshBasicMaterial({map:t,transparent:true,toneMapped:false,color:new THREE.Color(1.8,1.8,1.8)}));
      sign.position.set(FXC,SIGN.y-.43125,SIGN.z+.01); world.add(sign); res(); };
    const sl=new THREE.GLTFLoader(); sl.setCrossOrigin('anonymous'); if(window.MeshoptDecoder) sl.setMeshoptDecoder(MeshoptDecoder);
    sl.load(FILE('psb-sign.glb'),g=>{
      signFaceMat=new THREE.MeshBasicMaterial({color:new THREE.Color(2.1,2.1,2.15),toneMapped:false});
      const ret=new THREE.MeshStandardMaterial({color:0x101114,metalness:.75,roughness:.32,envMapIntensity:1});
      g.scene.traverse(o=>{ if(!o.isMesh) return; o.material=/face/.test(o.name)||/face/.test(o.parent&&o.parent.name||'')?signFaceMat:ret; o.castShadow=true; });
      g.scene.position.set(FXC,SIGN.y,SIGN.z); world.add(g.scene);
      const sl2=new THREE.SpotLight(0xe9eeff,HQ?1.6:1.1,8,1.05,.9,1.5); sl2.position.set(FXC,SIGN.y-.3,FZ+.6); sl2.target.position.set(FXC,0,FZ+3.2); scene.add(sl2,sl2.target);
      res(); },undefined,()=>flat());
  },undefined,()=>res());
}));
fontsReady.then(()=>{
  const frieze=(txt,len,x,ry)=>{ const t=textTex([{text:txt,font:'500 46px "IBM Plex Mono", monospace',x:30,y:64,ls:'16px',color:'#c7cbd3'}],4096,128);
    const m=new THREE.Mesh(new THREE.PlaneGeometry(len,len*128/4096),new THREE.MeshBasicMaterial({map:t,transparent:true,opacity:.62,toneMapped:false,depthWrite:false}));
    m.position.set(x,3.0,-.2); m.rotation.y=ry; world.add(m); };
  frieze('01 / SPEAK WITHOUT ASKING     02 / KEEP YOUR OWN COUNSEL     03 / MAKE IT IMPOSSIBLE TO IGNORE',10.5,ROOM.x0+.02,Math.PI/2);
  frieze('POWERFUL SINCE BIRTH     BUILT WITH PURPOSE     DESIGNED BY WINNERS     PSB® 2026',10.5,ROOM.x1-.02,-Math.PI/2);
});
/* ceiling light lines */
[-2.75,-.55,1.85].forEach(x=>{ const b=new THREE.Mesh(new THREE.BoxGeometry(.05,.02,9.6),new THREE.MeshBasicMaterial({color:new THREE.Color(0xfff4e6).multiplyScalar(1.7),toneMapped:false})); b.position.set(x,ROOM.h-.012,0); world.add(b);
  const g=new THREE.Mesh(new THREE.PlaneGeometry(.9,10.4),addMat(0xfff0dc,.16)); g.rotation.x=Math.PI/2; g.position.set(x,ROOM.h-.03,0); world.add(g); });

/* lights */
const hemi=new THREE.HemisphereLight(0x9aa2b6,0x0a0a0c,.42); scene.add(hemi);
const sun=new THREE.DirectionalLight(0xfff4ea,.55); sun.position.set(2.2,9,3.5); sun.target.position.set(-.2,0,0); scene.add(sun,sun.target);
if(HQ){ sun.castShadow=true; sun.shadow.mapSize.set(2048,2048); Object.assign(sun.shadow.camera,{left:-6.5,right:6.5,top:7.5,bottom:-7.5,near:1,far:20}); sun.shadow.bias=-.0006; sun.shadow.normalBias=.02; }
const spot=(pos,tgt,int,ang=.6,col=0xfff3e6)=>{ const l=new THREE.SpotLight(col,int,11,ang,.7,1.3); l.position.set(...pos); l.target.position.set(...tgt); scene.add(l,l.target); return l; };
spot([-2.3,3.2,2.2],[-3.95,1.3,2.2],2.2,.75);
spot([1.75,3.2,2.2],[3.4,1.3,2.2],2.2,.75);
spot([-.7,3.2,1.2],[-2.0,1.1,1.2],1.4,.7);
const boothSpot=spot([1.335,3.15,-4.75],[1.335,1.45,-5.6],2.2,.55);
spot([-.3,3.2,-1.2],[-.3,1.0,-2.1],1.0,.6);

/* floor: mirror-polished stone (desktop) */
let floorReflector=null;
if(HQ){ floorReflector=new THREE.Reflector(new THREE.PlaneGeometry(W,D),{clipBias:.003,textureWidth:innerWidth*DPR*.4,textureHeight:innerHeight*DPR*.4,color:0x8a9099});
  floorReflector.rotation.x=-Math.PI/2; floorReflector.position.set((ROOM.x0+ROOM.x1)/2,.0005,(ROOM.z0+ROOM.z1)/2); world.add(floorReflector);
  const lac=new THREE.Mesh(new THREE.PlaneGeometry(W,D),new THREE.MeshStandardMaterial({color:0x0b0c0f,roughness:.4,metalness:.2,transparent:true,opacity:.84,envMapIntensity:.25}));
  lac.rotation.x=-Math.PI/2; lac.position.set((ROOM.x0+ROOM.x1)/2,.002,(ROOM.z0+ROOM.z1)/2); lac.receiveShadow=true; world.add(lac); }
else { const f=new THREE.Mesh(new THREE.PlaneGeometry(W,D),M.floor); f.rotation.x=-Math.PI/2; f.position.set((ROOM.x0+ROOM.x1)/2,.001,(ROOM.z0+ROOM.z1)/2); world.add(f); }
const floorHit=new THREE.Mesh(new THREE.PlaneGeometry(40,40),new THREE.MeshBasicMaterial({visible:false})); floorHit.rotation.x=-Math.PI/2; floorHit.position.y=.01; scene.add(floorHit);

/* =========================================================
   Time of day: the street follows the visitor's own clock. Sunrise, day, dusk, night.
   (?tod=dawn|day|dusk|night or ?tod=7.5 to preview)
   ========================================================= */
const TOD=(()=>{
  const P={
    night:{top:0x03040a,hor:0x0b0d17,sun:0x9fb0ff,glow:0,day:0,shaft:0,fog:.034,ext:.0},
    dawn: {top:0x1a2445,hor:0xff9d5c,sun:0xffb26a,glow:.9,day:.55,shaft:1,fog:.022,ext:.5,az:.65,el:.12},
    day:  {top:0x2b5a98,hor:0xbfd2e6,sun:0xfff4e2,glow:.35,day:1,shaft:.35,fog:.018,ext:1,az:.2,el:.75},
    dusk: {top:0x221b3c,hor:0xff6b4d,sun:0xff8a57,glow:.85,day:.45,shaft:.9,fog:.024,ext:.45,az:-.7,el:.1}};
  const KEYS=[[0,'night'],[5.2,'night'],[7,'dawn'],[9.6,'day'],[16.4,'day'],[18.3,'dusk'],[19.9,'night'],[24,'night']];
  let h=new Date().getHours()+new Date().getMinutes()/60;
  const q=(location.search.match(/[?&]tod=([\w.]+)/)||[])[1]; if(q) h=isNaN(+q)?({dawn:7,day:12,dusk:18.3,night:23})[q]??h:+q;
  let i=0; while(i<KEYS.length-2&&h>=KEYS[i+1][0]) i++;
  const [h0,a]=KEYS[i], [h1,b]=KEYS[i+1], f=THREE.MathUtils.smoothstep(h,h0,h1), A=P[a], B=P[b];
  const C=k=>new THREE.Color(A[k]).lerp(new THREE.Color(B[k]),f), L=k=>(A[k]??B[k]??0)*(1-f)+(B[k]??A[k]??0)*f;
  const name=f<.5?a:b, az=L('az'), el=L('el');
  return {h,name,top:C('top'),hor:C('hor'),sun:C('sun'),glow:L('glow'),day:L('day'),shaft:L('shaft'),fog:L('fog'),ext:L('ext'),
    dir:new THREE.Vector3(Math.sin(az)*Math.cos(el),Math.sin(el),Math.cos(az)*Math.cos(el)).normalize()};
})();
{ /* sky dome */
  const sky=new THREE.Mesh(new THREE.SphereGeometry(90,48,24),new THREE.ShaderMaterial({side:THREE.BackSide,depthWrite:false,fog:false,toneMapped:false,
    uniforms:{top:{value:TOD.top},hor:{value:TOD.hor},sun:{value:TOD.sun},dir:{value:TOD.dir},glow:{value:TOD.glow}},
    vertexShader:'varying vec3 vD; void main(){ vD=normalize(position); gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.); }',
    fragmentShader:`uniform vec3 top,hor,sun,dir; uniform float glow; varying vec3 vD;
      void main(){ float y=max(vD.y,0.); vec3 c=mix(hor,top,pow(y,.55)); float s=max(dot(vD,normalize(dir)),0.);
        c+=sun*glow*(pow(s,8.)*.55+pow(s,300.)*3.); c=mix(c,hor*.35,smoothstep(0.,-.08,vD.y)); gl_FragColor=vec4(c,1.); }`}));
  sky.renderOrder=-10; sky.frustumCulled=false; scene.add(sky); TOD.mesh=sky;
  scene.fog.color.copy(new THREE.Color(VOID).lerp(TOD.hor,TOD.day*.08)); scene.fog.density=Math.max(.026,TOD.fog); scene.background=new THREE.Color(VOID).lerp(TOD.hor,TOD.day*.5);
  /* daylight on the street and through the glass */
  FAC.concrete.color.setScalar(.55+.45*TOD.ext); FAC.plaster.color.lerp(TOD.hor.clone().multiplyScalar(.25),TOD.day*.6);
  /* daylight only on the street side: exterior materials pick up the sky as a soft self-light, the store interior keeps its own lighting */
  if(TOD.day>.01){ const sky=TOD.hor.clone().lerp(TOD.top,.35).lerp(TOD.sun,.25);
    [[FAC.concrete,.34],[FAC.plaster,.26],[FAC.steel,.1],[FAC.frame,.05]].forEach(([m,k])=>{ m.emissive=sky.clone().multiplyScalar(k*TOD.ext); });
    if(PAVMAT) PAVMAT.emissive=sky.clone().multiplyScalar(.16*TOD.ext); }
  /* low sun: warm shafts through the storefront onto the floor */
  if(TOD.shaft>.05){ const sx=-TOD.dir.x/Math.max(.08,TOD.dir.y)*.5, warm=TOD.sun.clone();
    [[ROOM.x0+.1,-1.25],[1.25,ROOM.x1-.1]].forEach(([a,b])=>{ const n=Math.max(1,Math.round((b-a)/1.25));
      for(let k=0;k<n;k++){ const x0=a+(b-a)*k/n+.05, x1=a+(b-a)*(k+1)/n-.05, len=Math.min(4.2,2.6/Math.max(.12,TOD.dir.y*2.2));
        const sh=new THREE.Shape(); sh.moveTo(x0,FZ); sh.lineTo(x1,FZ); sh.lineTo(x1+sx*len,FZ-len); sh.lineTo(x0+sx*len,FZ-len);
        const pg=new THREE.ShapeGeometry(sh); pg.rotateX(Math.PI/2); const patch=new THREE.Mesh(pg,addMat(warm,.16*TOD.shaft,VG)); patch.position.y=.006;
        patch.material.side=THREE.DoubleSide; world.add(patch);
      } }); }
}
/* booth mirror (true reflection, only live while you're in the fitting room) */
const boothMirror=new THREE.Reflector(new THREE.PlaneGeometry(.97,2.21),{clipBias:.003,textureWidth:COARSE?512:1024,textureHeight:COARSE?1024:2048,color:0x8b9099});
boothMirror.position.set(1.185,1.365,-6.183); boothMirror.visible=false; world.add(boothMirror);

/* =========================================================
   Power core (centerpiece)
   ========================================================= */
const CORE=V(-.55,1.42,3.55);
const core=new THREE.Group(); core.position.copy(CORE); world.add(core);
const lattice=new THREE.Group(); core.add(lattice); const CR=.36; const latMat=M.chrome.clone(); latMat.transparent=true;
for(let k=1;k<8;k++){const ph=k*Math.PI/8;const t=new THREE.Mesh(new THREE.TorusGeometry(CR*Math.sin(ph),.004,8,96),latMat);t.rotation.x=Math.PI/2;t.position.y=CR*Math.cos(ph);lattice.add(t);}
for(let k=0;k<10;k++){const t=new THREE.Mesh(new THREE.TorusGeometry(CR,.004,8,128),latMat);t.rotation.y=k*Math.PI/10;lattice.add(t);}
lattice.rotation.z=.18;
const heart=new THREE.Mesh(new THREE.SphereGeometry(.13,40,28),new THREE.MeshBasicMaterial({color:0xffffff,toneMapped:false})); core.add(heart);
const coreHit=new THREE.Mesh(new THREE.SphereGeometry(CR,16,12),new THREE.MeshBasicMaterial({visible:false})); core.add(coreHit);
const halo1=new THREE.Sprite(new THREE.SpriteMaterial({map:GLOW,transparent:true,opacity:.75,blending:THREE.AdditiveBlending,depthWrite:false,toneMapped:false})); halo1.scale.set(1.5,1.5,1); core.add(halo1);
const halo2=new THREE.Sprite(halo1.material.clone()); halo2.material.opacity=.14; halo2.scale.set(4.2,4.2,1); core.add(halo2);
const coreLight=new THREE.PointLight(0xffffff,1.6,6,1.6); core.add(coreLight);
{ const base=new THREE.Mesh(new THREE.CylinderGeometry(.42,.46,.1,72),M.lacquer); base.position.set(CORE.x,.05,CORE.z); base.castShadow=base.receiveShadow=true; world.add(base);
  const rim=new THREE.Mesh(new THREE.TorusGeometry(.44,.007,10,140),M.chrome); rim.rotation.x=Math.PI/2; rim.position.set(CORE.x,.1,CORE.z); world.add(rim); }
const corePool=new THREE.Mesh(new THREE.PlaneGeometry(2.6,2.6),addMat(0xffffff,.3)); corePool.rotation.x=-Math.PI/2; corePool.position.set(CORE.x,.012,CORE.z); world.add(corePool);
const beam=new THREE.Mesh(new THREE.CylinderGeometry(.12,.55,ROOM.h-1.6,48,1,true),addMat(0xffffff,.05,VG)); beam.position.set(CORE.x,1.6+(ROOM.h-1.6)/2,CORE.z); world.add(beam);
const shock=new THREE.Mesh(new THREE.RingGeometry(.95,1,160),addMat(0xffffff,0,null)); shock.rotation.x=-Math.PI/2; shock.position.set(CORE.x,.02,CORE.z); world.add(shock);
let shockT=-1;

/* =========================================================
   3D shirts: sewn crew-neck mesh on a real hanger, product art printed on the pattern pieces
   ========================================================= */
const TEX={};
const DARKEN={mr_brown:.8,psb_brown:.8};
const HOOK=V(0,.786,-.004);        // inside top of the hook, where it sits on a bar
const TEE_DROP=.456;               // hook contact to garment centre
const PROTO={};                    // shirt hi / lo, hanger, hook (node clones keep their dequantization transforms)
const TMAT={};
/* jersey knit: a tiny tiled normal map so close-ups read as cotton, not plastic */
function knitTex(){ const S=128, [c,g]=cnv(S,S), img=g.createImageData(S,S), H=new Float32Array(S*S);
  const r9=rng(3); for(let y=0;y<S;y++) for(let x=0;x<S;x++){ const v=(y%4)/4, lean=(x%4<2?1:-1)*(v-.5)*.8; H[y*S+x]=.5+.35*Math.cos(2*Math.PI*((x+lean)/2))+.15*Math.cos(2*Math.PI*v)+(r9()-.5)*.12; }
  const h=(x,y)=>H[((y+S)%S)*S+((x+S)%S)];
  for(let y=0;y<S;y++) for(let x=0;x<S;x++){ const nx=(h(x-1,y)-h(x+1,y))*1.4, ny=(h(x,y-1)-h(x,y+1))*1.4, l=Math.hypot(nx,ny,1), i=(y*S+x)*4;
    img.data[i]=(nx/l*.5+.5)*255; img.data[i+1]=(ny/l*.5+.5)*255; img.data[i+2]=(1/l*.5+.5)*255; img.data[i+3]=255; }
  g.putImageData(img,0,0); const t=new THREE.CanvasTexture(c); t.wrapS=t.wrapT=THREE.RepeatWrapping; return t; }
const KNIT=knitTex();
/* fabric sway: hems ripple a little, more when you walk past (attribute "hem" = 0 at the shoulders, 1 at the hem) */
const SWAY={uT:{value:0},uAmp:{value:RM?0:.004}};
function fabric(m){ m.onBeforeCompile=sh=>{ sh.uniforms.uT=SWAY.uT; sh.uniforms.uAmp=SWAY.uAmp;
  sh.vertexShader=sh.vertexShader.replace('#include <common>','#include <common>\nattribute float hem; uniform float uT,uAmp;')
    .replace('#include <project_vertex>',`vec4 wp=modelMatrix*vec4(transformed,1.); float hh=hem*hem;
      wp.x+=sin(uT*1.6+wp.y*7.+wp.z*3.1)*uAmp*hh; wp.z+=cos(uT*1.25+wp.x*4.3+wp.y*6.)*uAmp*hh*1.2;
      vec4 mvPosition=viewMatrix*wp; gl_Position=projectionMatrix*mvPosition;`);
  sh.fragmentShader=sh.fragmentShader.replace('#include <normal_fragment_maps>',THREE.ShaderChunk.normal_fragment_maps.replace('texture2D( normalMap, vUv )','texture2D( normalMap, vUv*96. )')); };
  m.customProgramCacheKey=()=>'psb-fabric'; return m; }
function addHem(node){ const g=node.geometry; if(!g||g.attributes.hem) return; const p=g.attributes.position, v=new THREE.Vector3(); node.updateMatrix();
  const ys=new Float32Array(p.count); let lo=1e9,hi=-1e9; for(let i=0;i<p.count;i++){ v.fromBufferAttribute(p,i).applyMatrix4(node.matrix); ys[i]=v.y; lo=Math.min(lo,v.y); hi=Math.max(hi,v.y); }
  const hem=new Float32Array(p.count); for(let i=0;i<p.count;i++) hem[i]=(hi-ys[i])/Math.max(1e-4,hi-lo); g.setAttribute('hem',new THREE.BufferAttribute(hem,1)); }
function teeMat(key,dim){ const k=key+(dim?'d':''); if(TMAT[k]) return TMAT[k];
  const m=new THREE.MeshPhysicalMaterial({map:TEX[key],normalMap:KNIT,normalScale:new THREE.Vector2(.1,.1),roughness:.9,metalness:0,sheen:.35,sheenRoughness:.9,sheenColor:new THREE.Color(0x6f6f6f),envMapIntensity:.35,side:THREE.DoubleSide});
  m.color.setScalar((DARKEN[key]||1)*(dim?.6:1)); return TMAT[k]=fabric(m); }
const woodMat=new THREE.MeshStandardMaterial({color:0x0d0d10,roughness:.32,metalness:.1,envMapIntensity:.6});
const sizeTexCache={};
function sizeTex(s,av){ const k=s+av; if(sizeTexCache[k]) return sizeTexCache[k];
  const [c,g]=cnv(128,128); g.fillStyle=av?'#0c0d11':'#26272b'; g.fillRect(0,0,128,128);
  g.fillStyle=av?'#efece6':'#6b6e75'; g.textAlign='center'; g.textBaseline='middle'; g.font=`800 ${s.length>1?54:66}px "Archivo", sans-serif`; g.fillText(s,64,66);
  if(!av){ g.strokeStyle='#6b6e75'; g.lineWidth=5; g.beginPath(); g.moveTo(18,110); g.lineTo(110,18); g.stroke(); }
  const t=new THREE.CanvasTexture(c); t.encoding=THREE.sRGBEncoding; return sizeTexCache[k]=t; }
const CUBE_GEO=new THREE.BoxGeometry(.022,.022,.022);
const cubeMats={}; const cubeMat=(s,av)=>cubeMats[s+av]||(cubeMats[s+av]=new THREE.MeshStandardMaterial({map:sizeTex(s,av),roughness:.4}));
const pickables=[];
const LO='lo', HI='hi';
/* =========================================================
   Woven neck label: a crisp separate decal (the shirt texture is too coarse inside the collar),
   drawn from the PSB lockup, with the size, bent to sit on the inside back of the neck
   ========================================================= */
const NECK={w:.062,h:.026,cx:.003,top:.6265};
const lockupImg=new Image(); lockupImg.crossOrigin='anonymous'; lockupImg.src=CFG.files.lockup;
const labelTexCache={}, labelMats={};
function drawLabel(c,g,size){ const W=c.width,H=c.height, ch=H*.16;
  g.clearRect(0,0,W,H); g.beginPath(); g.moveTo(0,0); g.lineTo(W,0); g.lineTo(W,H-ch); g.lineTo(W-ch,H); g.lineTo(ch,H); g.lineTo(0,H-ch); g.closePath();
  g.fillStyle='#0c0c0e'; g.fill(); g.save(); g.clip();
  const r=rng(7); for(let y=0;y<H;y+=2){ g.fillStyle=`rgba(255,255,255,${.012+r()*.018})`; g.fillRect(0,y,W,1); }      // woven ribs
  g.strokeStyle='rgba(255,255,255,.07)'; g.lineWidth=2; g.setLineDash([6,5]); g.strokeRect(10,10,W-20,H-ch*.5-20); g.setLineDash([]);
  if(lockupImg.complete&&lockupImg.naturalWidth){ const lw=W*.76, lh=lw*460/1600; g.drawImage(lockupImg,(W-lw)/2,H*.13,lw,lh); }
  if(size){ g.fillStyle='#efece6'; g.font=`700 ${Math.round(H*.13)}px "Archivo", "Helvetica Neue", Arial, sans-serif`; g.textAlign='center'; g.textBaseline='middle'; g.fillText(size,W/2,H*.8); }
  g.restore(); }
function labelMat(size){ const k=size||'-'; if(labelMats[k]) return labelMats[k];
  const [c,g]=cnv(640,268); drawLabel(c,g,size); const t=new THREE.CanvasTexture(c); t.encoding=THREE.sRGBEncoding; t.anisotropy=MAXANI; labelTexCache[k]={c,g,t,size};
  return labelMats[k]=new THREE.MeshStandardMaterial({map:t,roughness:.72,metalness:0,envMapIntensity:.25,alphaTest:.5,side:THREE.DoubleSide}); }
const redrawLabels=()=>Object.values(labelTexCache).forEach(o=>{ drawLabel(o.c,o.g,o.size); o.t.needsUpdate=true; });
lockupImg.onload=redrawLabels; fontsReady.then(redrawLabels);
/* bend a small grid onto the garment's inner back by casting rays from the front, in the garment's own space */
function neckGeo(mesh,cx,top,w,h,backZ){
  const rc=new THREE.Raycaster(), NX=12, NY=4, pos=[], uv=[], idx=[]; mesh.updateMatrixWorld(true);
  const Z=[], col=[];
  for(let j=NY;j>=0;j--) for(let i=0;i<=NX;i++){ const x=cx-w/2+w*i/NX, y=top-h*j/NY;
    rc.set(V(x,y,.5),V(0,0,-1)); const hit=rc.intersectObject(mesh,false).find(q=>q.point.z<backZ);
    const z=hit?hit.point.z:(col[i]!==undefined?col[i]:null); if(z!==null) col[i]=z; Z[j*(NX+1)+i]=z; }
  const zs=Z.filter(z=>z!==null), zf=zs.length?zs.reduce((a,b)=>a+b,0)/zs.length:backZ-.008;
  for(let j=0;j<=NY;j++) for(let i=0;i<=NX;i++){ const x=cx-w/2+w*i/NX, y=top-h*j/NY, z=Z[j*(NX+1)+i];
    pos.push(x,y,(z===null?zf:z)+.0011); uv.push(i/NX,1-j/NY); }
  for(let j=0;j<NY;j++) for(let i=0;i<NX;i++){ const a=j*(NX+1)+i, b=a+1, c=a+NX+1, d=c+1; idx.push(a,c,b,b,c,d); }
  const g=new THREE.BufferGeometry(); g.setAttribute('position',new THREE.Float32BufferAttribute(pos,3)); g.setAttribute('uv',new THREE.Float32BufferAttribute(uv,2)); g.setIndex(idx); g.computeVertexNormals(); return g; }
const NECKGEO={};
function neckFor(lod){ if(NECKGEO[lod]) return NECKGEO[lod];
  const n=PROTO[lod], m=new THREE.Mesh(n.geometry,new THREE.MeshBasicMaterial({side:THREE.DoubleSide})); m.position.copy(n.position); m.quaternion.copy(n.quaternion); m.scale.copy(n.scale);
  return NECKGEO[lod]=neckGeo(m,NECK.cx,NECK.top,NECK.w,NECK.h,-.004); }

function cloneNode(n){ const c=n.clone(false); c.geometry=n.geometry; return c; }
function makeItem(pi,size,av,lod=LO){
  const p=PIECES[pi], root=new THREE.Group(); root.rotation.order='YXZ';
  const tee=new THREE.Group(); tee.position.set(-HOOK.x,-HOOK.y,-HOOK.z); root.add(tee);
  const sc=({S:.96,M:.985,L:1,XL:1.025})[size]||1; tee.scale.setScalar(sc); tee.position.multiplyScalar(sc);
  const hanger=cloneNode(PROTO.hanger); hanger.material=woodMat; const hook=cloneNode(PROTO.hook); hook.material=M.chrome;
  const shirt=cloneNode(PROTO[lod]); shirt.material=teeMat(p.key,!av); shirt.castShadow=true; hanger.castShadow=true;
  const neck=new THREE.Mesh(neckFor(lod),labelMat(size)); tee.add(hanger,hook,shirt,neck);
  const cube=new THREE.Mesh(CUBE_GEO,cubeMat(size,av)); cube.position.set(0,-.05,.0); root.add(cube);
  const it={pi,size,av,flip:p.side==='Back',root,tee,shirt,neck,lod,t:0,tt:0,hov:0,sx:0,sz:0,vx:0,vz:0,rest:V(),restYaw:0,heroPos:V(),heroYaw:0,phase:Math.random()*6,display:null};
  shirt.userData.item=it; pickables.push(shirt);
  return it;
}
function setLod(it,lod){ if(it.lod===lod) return; it.shirt.geometry=PROTO[lod].geometry; it.shirt.position.copy(PROTO[lod].position); it.shirt.scale.copy(PROTO[lod].scale); it.shirt.quaternion.copy(PROTO[lod].quaternion); if(it.neck) it.neck.geometry=neckFor(lod); it.lod=lod; }
/* surface point on the garment for hotspots/close-ups: x,y in garment metres (hem = 0), side +1 front / -1 back */
const ray2=new THREE.Raycaster();
function surfacePoint(it,x,y,side){
  const a=it.tee.localToWorld(V(x,y,.25*side)), b=it.tee.localToWorld(V(x,y,-.25*side));
  ray2.set(a,b.sub(a).normalize()); ray2.far=.6;
  const h=ray2.intersectObject(it.shirt,false)[0];
  return h?it.tee.worldToLocal(h.point.clone()):V(x,y,.05*side);
}
const items=[];
const displays=[];

/* face-out wall display: one colorway per arm, every size stacked behind the front hanger */
function addFaceOut(pi,armEnd,normal,yaw,wallId){
  const p=PIECES[pi], d={kind:'faceout',pi,items:[],armEnd,normal,yaw,wallId};
  const arm=new THREE.Mesh(new THREE.CylinderGeometry(.009,.009,.44,12),M.chrome);
  arm.position.copy(armEnd).addScaledVector(normal,-.22); arm.rotation.z=Math.PI/2; if(Math.abs(normal.z)>.5){arm.rotation.z=0;arm.rotation.x=Math.PI/2;} world.add(arm);
  const stop=new THREE.Mesh(new THREE.SphereGeometry(.014,16,12),M.chrome); stop.position.copy(armEnd).addScaledVector(normal,.01); world.add(stop);
  const order=[...p.sizes].sort((a,b)=>(b[0]===defaultSize(p))-(a[0]===defaultSize(p)));
  order.forEach(([s,id,av],k)=>{
    const it=makeItem(pi,s,!!av,LO), fy=yaw+(it.flip?Math.PI:0); it.display=d; it.rest.copy(armEnd).addScaledVector(normal,-.03-k*.05); it.restYaw=fy;
    it.heroPos.copy(armEnd).addScaledVector(normal,.3); it.heroPos.y-=.01; it.heroYaw=fy;
    it.root.position.copy(it.rest); it.root.rotation.y=yaw; if(k>1) it.root.visible=false; it.stackK=k;
    world.add(it.root); d.items.push(it); items.push(it);
  });
  displays.push(d); return d;
}
/* side-hung rail display */
function addRail(handles,railX,railY,z0,z1,side){
  const d={kind:'rail',items:[],side,railX};
  const seq=[]; PIECES.forEach((p,i)=>{ if(handles.includes(p.handle)) p.sizes.forEach(([s,id,av])=>seq.push([i,s,!!av])); });
  const stepZ=(z1-z0)/(seq.length-1);
  seq.forEach(([i,s,av],k)=>{ const it=makeItem(i,s,av,LO); it.display=d; it.rest.set(railX,railY,z0+k*stepZ); it.restYaw=0;
    it.heroPos.set(railX+side*.55,railY-.01,z0+k*stepZ); it.heroYaw=(side>0?Math.PI/2:-Math.PI/2)+(it.flip?Math.PI:0);
    it.root.position.copy(it.rest); world.add(it.root); d.items.push(it); items.push(it); });
  displays.push(d); return d;
}
/* fitting booth rail (built for whichever shirt you take in) */
const BOOTH={x:1.335,y:2.02,z:-5.55,cam:V(1.335,1.54,-3.98)};
{ const r=new THREE.Mesh(new THREE.CylinderGeometry(.011,.011,1.42,16),M.chrome); r.rotation.z=Math.PI/2; r.position.set(BOOTH.x,BOOTH.y,BOOTH.z); world.add(r); }
/* booth items return to their face-out stack and hide when buried */
let booth={kind:'booth',items:[]};
const boothArms=[[.62,.92],[2.05,1.75]].map(([a,c])=>{ const m=new THREE.Mesh(new THREE.CylinderGeometry(.008,.008,Math.abs(c-a),12),M.chrome); m.rotation.z=Math.PI/2; m.position.set((a+c)/2,BOOTH.y-.04,BOOTH.z-.02); world.add(m); return m; });

/* =========================================================
   Load the store + shirts
   ========================================================= */
let storeRoot=null, curtains=null; const tl=new THREE.TextureLoader(); tl.setCrossOrigin('anonymous'); let pending=N+3+Object.keys(DECAL_TEX).length+EXTRA.length;
const LOADP={};
function loadState(){ const v=Object.values(LOADP); if(!v.length) return; const f=v.reduce((a,b)=>a+b,0)/v.length; if(pending>0) $('loadState').textContent=`Building the store · ${Math.round(f*100)}%`; }
function ready(){ if(--pending>0) return;
  buildDisplays(); if(HQ) renderer.shadowMap.needsUpdate=true;
  $('enter').disabled=false; $('enterQuiet').disabled=false; $('loadState').textContent='Doors open'; }
PIECES.forEach(p=>tl.load(SHIRT_TEX[p.key],t=>{ t.encoding=THREE.sRGBEncoding; t.anisotropy=MAXANI; TEX[p.key]=t; $('loadState').textContent='Steaming shirts'; ready(); }));
const DECAL={};
Object.keys(DECAL_TEX).forEach(k=>tl.load(DECAL_TEX[k],t=>{ t.encoding=THREE.sRGBEncoding; t.anisotropy=MAXANI; DECAL[k]=t; ready(); }));
const gl=new THREE.GLTFLoader(); gl.setCrossOrigin('anonymous'); if(window.MeshoptDecoder) gl.setMeshoptDecoder(MeshoptDecoder);
EXTRA.forEach(p=>p.then(()=>ready()));
/* meshopt-compressed twins (psb-*-mo.glb) are a third of the size; fall back to the originals if they're missing */
function loadGLB(url,ok,fail){ const k=String(url).split('?')[0].split('/').pop(); LOADP[k]=0;
  const prog=e=>{ if(e&&e.total){ LOADP[k]=e.loaded/e.total; loadState(); } };
  const done=g=>{ LOADP[k]=1; loadState(); ok(g); };
  const mo=window.MeshoptDecoder?String(url).replace(/(psb-[a-z-]+)\.glb(\?.*)?$/,'$1-mo.glb'):url;
  if(mo!==url) gl.load(mo,done,prog,()=>gl.load(url,done,prog,fail)); else gl.load(url,done,prog,fail); }
const failLoad=e=>{ console.error(e); $('loadState').textContent='A 3D file failed to load. Check the files in Content → Files, then refresh.'; };
loadGLB(CFG.files.tee,g=>{ g.scene.updateMatrixWorld(true);
  const get=n=>g.scene.getObjectByName(n); PROTO.hi=get('T_Shirt'); PROTO.lo=get('T_Shirt_LO'); PROTO.hanger=get('Hanger'); PROTO.hook=get('Hanger_Metal_Element'); addHem(PROTO.hi); addHem(PROTO.lo);
  ready(); },failLoad);
loadGLB(CFG.files.worn,g=>{ g.scene.traverse(o=>{ if(o.isMesh) PROTO.worn=o; }); ready(); },failLoad);
{ loadGLB(CFG.files.store,g=>{
    storeRoot=g.scene; storeRoot.scale.setScalar(.01); let i=0;
    storeRoot.traverse(o=>{ if(!o.isMesh) return; const n=(o.name||'')+' '+(o.parent?o.parent.name:'');
      if(/diban|baojiazi|jiazi03_model/.test(n)){ o.visible=false; return; }
      o.material=matFor(n,i++); o.castShadow=!/ditan|chuanglian/.test(n); o.receiveShadow=true;
      if(/chuanglian/.test(n)) curtains=o; });
    world.add(storeRoot); ready();
  },failLoad);
}
function buildDisplays(){
  const L=-3.94, Rx=3.38, cols=[1.2,2.23,3.26], rows=[2.05,1.15];
  const layout=PIECES.slice(0,6).map((p,i)=>[i,Math.floor(i/3),i%3]);
  layout.forEach(([pi,r,c])=>{ addFaceOut(pi,V(L,rows[r],cols[c]),V(1,0,0),Math.PI/2,'wallL'); addFaceOut(pi,V(Rx,rows[r],cols[2-c]),V(-1,0,0),-Math.PI/2,'wallR'); });
  addRail(Object.keys(PRODUCTS),-1.76,1.61,-.1,2.52,1);
  addGhosts(); addVideoWall(); buildCore(); buildVault(); buildDJ();
}

/* ghost mannequin displays: the worn tee from TestWalk.fbx, printed with the same placement rules as the wall shirts */
const ghostHits=[], ghosts=[];
const GMETA={"hi_blue": {"pc": 0.5032, "ptop": 0.1214, "phem": 0.877, "tu": 0.7335, "tv": 0.7979, "base": [0.9246, 0.9324, 0.9393]}, "mr_brown": {"pc": 0.485, "ptop": 0.1288, "phem": 0.8697, "tu": 0.7225, "tv": 0.8026, "base": [0.3825, 0.2673, 0.2173]}, "mr_white": {"pc": 0.5028, "ptop": 0.1222, "phem": 0.877, "tu": 0.7151, "tv": 0.7877, "base": [0.9221, 0.9305, 0.9352]}, "psb_brown": {"pc": 0.4846, "ptop": 0.1278, "phem": 0.8705, "tu": 0.7174, "tv": 0.8057, "base": [0.369, 0.2629, 0.2098]}, "hi_green": {"pc": 0.502, "ptop": 0.1158, "phem": 0.8825, "tu": 0.7341, "tv": 0.8041, "base": [0.9124, 0.9202, 0.9267]}, "dream": {"pc": 0.5006, "ptop": 0.1219, "phem": 0.8775, "tu": 0.6051, "tv": 0.7075, "base": [0.8972, 0.9049, 0.9124]}};
const WORN={cx:.0174,top:1.502,hem:.878,tagX:.118,labelDrop:.03,sK:.88};
/* Morning Radiance print: matched to the product photo (bigger, lower), same as the hanging shirts */
const GFIX={mr_brown:{k:1.209,gv0:.274,top:1.38},mr_white:{k:1.102,gv0:.283,top:1.38},hi_blue:{k:1.1,gv0:.303,top:1.371},hi_green:{k:1.1,gv0:.301,top:1.371},psb_brown:{k:1,gv0:.351,top:1.341}};
function ghostMat(key){
  const g=GMETA[key], dk=DARKEN[key]||1;
  const base=new THREE.Color().setRGB(...g.base).convertSRGBToLinear().multiplyScalar(dk);
  const m=new THREE.MeshPhysicalMaterial({color:base,roughness:.9,metalness:0,sheen:.35,sheenRoughness:.9,sheenColor:new THREE.Color(0x6f6f6f),side:THREE.DoubleSide,envMapIntensity:.35});
  const S=.424/.6*WORN.sK, tx=WORN.cx+WORN.tagX, ty=WORN.hem+(g.phem-g.tv)*S, ly=WORN.top-WORN.labelDrop;
  m.onBeforeCompile=sh=>{
    sh.uniforms.uDecal={value:DECAL[key]}; sh.uniforms.uA={value:new THREE.Vector4(g.pc,S,g.ptop,g.phem)};
    sh.uniforms.uB={value:new THREE.Vector4(WORN.cx,WORN.top,ly,0)}; sh.uniforms.uT={value:new THREE.Vector4(tx,ty,g.tu,g.tv)};
    { const fx=GFIX[key], Sg=fx?S*fx.k:S; sh.uniforms.uG={value:new THREE.Vector2(Sg,fx?fx.top+(fx.gv0-g.ptop)*Sg:WORN.top)}; }
    sh.vertexShader=sh.vertexShader.replace('#include <common>','#include <common>\nvarying vec3 vOP; varying vec3 vON;').replace('#include <begin_vertex>','#include <begin_vertex>\nvOP=position; vON=normal;');
    sh.fragmentShader=sh.fragmentShader.replace('#include <common>','#include <common>\nvarying vec3 vOP; varying vec3 vON; uniform sampler2D uDecal; uniform vec4 uA; uniform vec4 uB; uniform vec4 uT; uniform vec2 uG;')
      .replace('#include <map_fragment>',`#include <map_fragment>
{ vec3 n=normalize(vON); vec4 dc;
  if(gl_FrontFacing){
    float fw=smoothstep(.1,.4,n.z);
    vec2 p=vec2(uA.x+(vOP.x-uB.x)/uG.x, uA.z+(uG.y-vOP.y)/uG.x);
    float tz=step(.62,p.x)*step(p.x,.86)*step(.72,p.y);
    if(p.x>0.&&p.x<1.&&p.y>uA.z+.06&&p.y<uA.w&&!(abs(p.x-uA.x)<.09&&p.y<.235)){ dc=texture2D(uDecal,vec2(p.x,1.-p.y)); diffuseColor.rgb=mix(diffuseColor.rgb,dc.rgb,dc.a*fw*(1.-tz)); }
    vec2 q=vec2(uT.z+(vOP.x-uT.x)/uA.y, uT.w+(uT.y-vOP.y)/uA.y);
    if(abs(q.x-uT.z)<.075&&abs(q.y-uT.w)<.045){ dc=texture2D(uDecal,vec2(q.x,1.-q.y)); diffuseColor.rgb=mix(diffuseColor.rgb,dc.rgb,dc.a*fw); }
  } }`); };
  return m; }
let GHOSTNECK;
function ghostNeck(){ if(GHOSTNECK!==undefined) return GHOSTNECK;
  const g=PROTO.worn.geometry, p=g.attributes.position, v=new THREE.Vector3(); let zmin=1e9,zmax=-1e9; for(let i=0;i<p.count;i++){ v.fromBufferAttribute(p,i); zmin=Math.min(zmin,v.z); zmax=Math.max(zmax,v.z); }
  const zmid=(zmin+zmax)/2; let ytop=-1e9; for(let i=0;i<p.count;i++){ v.fromBufferAttribute(p,i); if(Math.abs(v.x-WORN.cx)<.012&&v.z<zmid) ytop=Math.max(ytop,v.y); }
  if(ytop<0) return GHOSTNECK=null;
  const m=new THREE.Mesh(g,new THREE.MeshBasicMaterial({side:THREE.DoubleSide}));
  return GHOSTNECK=neckGeo(m,WORN.cx,ytop-.022,NECK.w*1.05,NECK.h*1.05,zmid); }
function addGhosts(){
  PIECES.map((p,pi)=>[pi,p.key]).filter(([pi,k])=>PIECES[pi].table&&DECAL[k]&&GMETA[k]).slice(0,2).map(([pi,k],i)=>[pi,[.37,-.62][i],5.31,k]).forEach(([pi,x,z,key],i)=>{
    const g=new THREE.Group(); g.position.set(x,.9,z); world.add(g);
    const base=new THREE.Mesh(new THREE.CylinderGeometry(.09,.1,.012,48),M.chrome); base.position.y=.006; g.add(base);
    const pole=new THREE.Mesh(new THREE.CylinderGeometry(.007,.007,.42,12),M.chrome); pole.position.y=.21; g.add(pole);
    const spin=new THREE.Group(); spin.position.y=.08; g.add(spin);
    const m=new THREE.Mesh(PROTO.worn.geometry,ghostMat(key)); m.position.set(-.0175,-.87,-.016); m.castShadow=true; m.userData.ghost=pi; spin.add(m); ghostHits.push(m);
    { const gl2=ghostNeck(); if(gl2) m.add(new THREE.Mesh(gl2,labelMat(defaultSize(PIECES[pi])))); }
    ghosts.push({spin,phase:i*Math.PI}); });
}
/* LED wall playing the PSB campaign film */
let heroVideo=null;
function addVideoWall(){
  const W2=2.24,H2=1.26, P0=V(-3.03,1.52,ROOM.z0+.05);
  const bez=new THREE.Mesh(new THREE.BoxGeometry(W2+.06,H2+.06,.04),M.lacquer); bez.position.copy(P0).add(V(0,0,-.035)); world.add(bez);
  const poster=signTL.load(CFG.files.poster,t=>{t.encoding=THREE.sRGBEncoding;});
  const mat=new THREE.MeshBasicMaterial({map:poster,toneMapped:false,polygonOffset:true,polygonOffsetFactor:-2,polygonOffsetUnits:-2}); mat.color.setScalar(.92);
  const scr=new THREE.Mesh(new THREE.PlaneGeometry(W2,H2),mat); scr.position.copy(P0); world.add(scr);
  const spill=new THREE.Mesh(new THREE.PlaneGeometry(3.2,2.2),addMat(0xb9c2d6,.08)); spill.rotation.x=-Math.PI/2; spill.position.set(P0.x,.015,P0.z+1.0); world.add(spill);
  const v=document.createElement('video'); v.crossOrigin='anonymous'; v.src=CFG.files.video; v.muted=true; v.defaultMuted=true; v.loop=true; v.playsInline=true; v.setAttribute('playsinline',''); v.preload='none';
  v.addEventListener('playing',()=>{ if(mat.map===heroVideo.tex) return; try{ const t2=document.createElement('canvas'); t2.width=t2.height=2; const c2=t2.getContext('2d'); c2.drawImage(v,0,0,2,2); c2.getImageData(0,0,1,1); }catch(e){ return; } mat.map=heroVideo.tex; mat.needsUpdate=true; });
  heroVideo={el:v,tex:new THREE.VideoTexture(v)}; heroVideo.tex.encoding=THREE.sRGBEncoding;
  if(mode!=='intro') v.play().catch(()=>{});
}

/* =========================================================
   Hero handling (pull a hanger off its fixture)
   ========================================================= */
let hero=null, spin=0, spinVel=0, spinGoal=null, zoom=null, focusDisplay=null;
function pull(it,quiet){
  if(!it||it===hero) return;
  if(hero){ hero.tt=0; hero.vz+=1.2; hero.leaveYaw=hero.heroYaw+spin; }
  spin=0; spinVel=0; spinGoal=null; exitZoom(true);
  it.tt=1; it.vz-=1.4; it.root.visible=true; setLod(it,HI); hero=it;
  if(!quiet) Sound.ping(it.av?1320:880,.03);
  sel=it.pi; if(it.display.kind!=='core') chosen[PIECES[it.pi].key]=it.size; updateHUD();
  { const pc=PIECES[it.pi]; track('piece_inspected',{handle:pc.handle,color:pc.color,size:it.size,display:it.display.kind}); pingView(pc.handle); }
  buildHotspots(); updateSideUI();
  if(drawer.classList.contains('open')) renderDrawer();
}
function release(){ if(hero){ hero.tt=0; hero.leaveYaw=hero.heroYaw+spin; hero.vz+=1; } hero=null; spin=0; exitZoom(true); buildHotspots(); }
function displayFor(pi,wall='wallL'){ return displays.find(d=>d.kind==='faceout'&&d.pi===pi&&d.wallId===wall); }
function itemIn(d,pi,size){ return d.items.find(it=>it.pi===pi&&it.size===size)||d.items.find(it=>it.pi===pi); }
function pullSize(pi,size){
  if(window.__flat) return;
  const d=mode==='fitting'?booth:focusDisplay; if(!d) return;
  if(d.kind==='core') return;
  if(d.kind==='faceout'&&d.pi!==pi){ focusOn(displayFor(pi,d.wallId),size); return; }
  pull(itemIn(d,pi,size));
}
function switchPiece(j){
  if(window.__flat){ sel=j; updateHUD(); renderDrawer(); return; }
  const p=PIECES[j], want=hero&&p.sizes.some(s=>s[0]===hero.size)?hero.size:defaultSize(p);
  if(mode==='fitting'){
    if(PIECES[sel].handle===p.handle){ pull(itemIn(booth,j,want)); return; }
    flash(()=>{ sel=j; buildBooth(p.handle); pull(itemIn(booth,j,want),true); hero.t=.999; renderDrawer(); });
    return;
  }
  if(focusDisplay&&focusDisplay.kind==='core'){ pull(coreDisplay.items[j]); return; }
  if(focusDisplay&&focusDisplay.kind==='rail'&&focusDisplay.items.some(it=>it.pi===j)){ pull(itemIn(focusDisplay,j,want)); return; }
  focusOn(displayFor(j,focusDisplay&&focusDisplay.wallId?focusDisplay.wallId:'wallL'),want);
}
function flash(mid,hold=240){ warpEl.classList.add('on'); setTimeout(()=>{ mid&&mid(); setTimeout(()=>warpEl.classList.remove('on'),hold); },380); }

/* =========================================================
   Camera rig: first-person with smoothed goals
   ========================================================= */
const cam={pos:V(0,1.75,12.5),yaw:0,pitch:.06,posG:V(0,1.75,12.5),yawG:0,pitchG:.06,dist:2,rate:2};
const fwd=(y,p)=>V(-Math.sin(y)*Math.cos(p),Math.sin(p),-Math.cos(y)*Math.cos(p));
function aimAt(P,T){ const dx=T.x-P.x, dy=T.y-P.y, dz=T.z-P.z; cam.posG.copy(P); cam.yawG=Math.atan2(-dx,-dz); cam.pitchG=Math.atan2(dy,Math.hypot(dx,dz)); cam.dist=Math.hypot(dx,dy,dz); }
const angD=(a,b)=>Math.atan2(Math.sin(a-b),Math.cos(a-b));
function goStation(id,quiet){
  const s=STATIONS.find(x=>x.id===id); if(!s) return;
  if(mode==='focus'||mode==='fitting'||mode==='core'||mode==='checkout'||mode==='vault'||mode==='booth') backToFloor(true);
  station=id; setLoc(s); aimAt(V(...s.pos),V(...s.look)); cam.rate=1.6; if(!quiet) Sound.whoosh(.6,900,260,.04);
}
function focusOn(d,size,item){
  if(!d) return;
  const first=!focusDisplay||mode!=='focus';
  if(focusDisplay&&focusDisplay!==d) release();
  focusDisplay=d; mode='focus'; body.classList.add('focus'); body.classList.remove('fitting');
  const it=item||(d.kind==='faceout'?itemIn(d,d.pi,size||defaultSize(PIECES[d.pi])):d.items[0]);
  pull(it);
  if(!drawer.classList.contains('open')) openDrawer(); else renderDrawer();
  if(first) Sound.whoosh(.5,1100,300,.04);
}
function focusPiece(i){ if(mode==='fitting'||(focusDisplay&&focusDisplay.kind==='core')) { switchPiece(i); return; } if(mode==='core'){ summon(i); return; } focusOn(displayFor(i,focusDisplay&&focusDisplay.wallId?focusDisplay.wallId:'wallL')); }
function backToFloor(silent){
  if(window.__flat){ closeDrawerUI(); return; }
  if(mode==='fitting'){ exitFitting(); return; }
  const st=mode==='checkout'?'counter':mode==='core'?'core':mode==='vault'?'vault':mode==='booth'?'booth':focusDisplay?(focusDisplay.wallId||'rail'):station;
  release(); focusDisplay=null; mode='walk'; body.classList.remove('focus','zoomed','checkout','coremode'); closeDrawerUI();
  if(!silent){ const s=STATIONS.find(x=>x.id===st); station=st; setLoc(s); aimAt(V(...s.pos),V(...s.look)); cam.rate=1.8; }
  canvas.focus({preventScroll:true});
}
function framingGoal(){
  if(mode==='intro'||mode==='walk') return;
  if(mode==='checkout'){ aimAt(TERM.cam,TERM.look); cam.rate=2; return; }
  if(mode==='vault'){ aimAt(VAULT.cam,VAULT.look); cam.rate=2; return; }
  if(mode==='booth'){ aimAt(BOOTH_DJ.cam,BOOTH_DJ.look); cam.rate=2; return; }
  if(mode==='core'){ aimAt(V(CORE.x+.05,CORE.y+.12,CORE.z+1.55),V(CORE.x,CORE.y,CORE.z)); cam.rate=2; return; }
  if(!hero) return;
  const fy=hero.heroYaw+(hero.flip?Math.PI:0), P=hero.heroPos, nrm=V(Math.sin(fy),0,Math.cos(fy));
  const T=V(P.x,P.y-TEE_DROP,P.z);
  if(zoom){ const q=hero.tee.localToWorld(zoom.local.clone());
    const n2=V(Math.sin(hero.heroYaw+spin),0,Math.cos(hero.heroYaw+spin)).multiplyScalar(zoom.side); aimAt(q.clone().addScaledVector(n2,zoom.dist),q); cam.rate=3; return; }
  if(mode==='fitting'){ aimAt(BOOTH.cam,V(BOOTH.x,1.53,BOOTH.z)); cam.rate=2.2; return; }
  const dist=(hero.display.kind==='core'?1.3:1)*(narrow()?1.18:1.05); aimAt(T.clone().addScaledVector(nrm,dist).setY(T.y+.05),T); cam.rate=2.2;
}
const WB={x0:-4.1,x1:3.35,z0:-4.4,z1:10};
const BLOCK=[[-2.34,-1.71,-.23,2.63],[.54,1.63,-.54,2.95],[-.87,.65,4.37,6.02],[-.92,.39,-2.47,-1.74],[-1.0,-.1,3.1,4.0],[3.36,4.5,-4.31,-1.88]];
function clampWalk(p){
  p.x=Math.max(WB.x0,Math.min(WB.x1,p.x)); p.z=Math.max(WB.z0,Math.min(WB.z1,p.z));
  if(p.z>ROOM.z1-.25&&p.z<ROOM.z1+.25&&Math.abs(p.x)>1.0) p.z=p.z<ROOM.z1?ROOM.z1-.25:ROOM.z1+.25;
  BLOCK.forEach(([x0,x1,z0,z1])=>{ const m=.3; if(p.x>x0-m&&p.x<x1+m&&p.z>z0-m&&p.z<z1+m){
    const dx0=p.x-(x0-m), dx1=(x1+m)-p.x, dz0=p.z-(z0-m), dz1=(z1+m)-p.z, mn=Math.min(dx0,dx1,dz0,dz1);
    if(mn===dx0) p.x=x0-m; else if(mn===dx1) p.x=x1+m; else if(mn===dz0) p.z=z0-m; else p.z=z1+m; } });
  p.y=1.6; return p;
}

/* =========================================================
   Fitting room
   ========================================================= */
function buildBooth(handle){
  booth.items.forEach(it=>{ world.remove(it.root); [it.shirt].forEach(m=>{const k=pickables.indexOf(m); if(k>=0) pickables.splice(k,1);}); });
  booth.items=[]; hero=null;
  const seq=[]; PIECES.forEach((p,i)=>{ if(p.handle===handle) p.sizes.forEach(([s,id,av])=>seq.push([i,s,!!av])); });
  /* each colorway hangs face-out on its own wall hook inside the booth; the shirt you're trying hangs on the centre rail */
  const cols=[...new Set(seq.map(s=>s[0]))];
  seq.forEach(([i,s,av])=>{ const it=makeItem(i,s,av,LO); it.display=booth;
    const side=cols.indexOf(i)===0?-1:1, k=booth.items.filter(o=>o.pi===i).length;
    it.rest.set(side<0?.9-k*.045:1.77+k*.045,BOOTH.y-.04,BOOTH.z-.02); it.restYaw=side<0?Math.PI/2:-Math.PI/2; it.stackK=k;
    it.heroPos.set(BOOTH.x,BOOTH.y,BOOTH.z); it.heroYaw=it.flip?Math.PI:0;
    it.root.position.copy(it.rest); it.root.rotation.y=it.restYaw; if(k>1) it.root.visible=false; world.add(it.root); booth.items.push(it); });
  boothArms.forEach((a,j)=>a.visible=j<cols.length);
}
function enterFitting(){
  if(mode!=='focus'||!hero) return;
  const pi=hero.pi, size=hero.size;
  Sound.curtain(); warpEl.classList.add('on');
  setTimeout(()=>{
    release(); focusDisplay=null; buildBooth(PIECES[pi].handle);
    mode='fitting'; body.classList.remove('focus'); body.classList.add('fitting');
    if(curtains) curtains.visible=false; boothMirror.visible=true; if(floorReflector) floorReflector.visible=false;
    cam.pos.set(BOOTH.x,1.55,-3.6); cam.posG.copy(cam.pos);
    $('topMeta').textContent='PSB® / Fitting room 01'; $('atlBack').textContent='← Back to the floor';
    Sound.room(700); pull(itemIn(booth,pi,size),true); renderDrawer(); framingGoal(); cam.yaw=cam.yawG; cam.pitch=cam.pitchG;
    setTimeout(()=>warpEl.classList.remove('on'),140);
  },420);
}
function exitFitting(){
  Sound.curtain(); warpEl.classList.add('on');
  setTimeout(()=>{
    release(); booth.items.forEach(it=>{ world.remove(it.root); [it.shirt].forEach(m=>{const k=pickables.indexOf(m); if(k>=0) pickables.splice(k,1);}); }); booth.items=[];
    mode='walk'; body.classList.remove('fitting','zoomed','focus'); closeDrawerUI();
    if(curtains) curtains.visible=true; boothMirror.visible=false; if(floorReflector) floorReflector.visible=true;
    $('topMeta').textContent='PSB® / Flagship / 2026'; Sound.room(380);
    const s=STATIONS.find(x=>x.id==='fitting'); station='fitting'; setLoc(s); cam.pos.set(...s.pos); aimAt(V(...s.pos),V(...s.look)); cam.yaw=cam.yawG; cam.pitch=cam.pitchG;
    setTimeout(()=>warpEl.classList.remove('on'),140); canvas.focus({preventScroll:true});
  },420);
}

/* side + zoom + hotspots */
function updateSideUI(){ const s=PIECES[sel].side; $('sideA').textContent=s; $('sideB').textContent=otherSide(s);
  const f=Math.cos(spinGoal!==null?spinGoal:spin)>=0; $('sideA').setAttribute('aria-pressed',f); $('sideB').setAttribute('aria-pressed',!f); }
const nearest=t=>spin+Math.atan2(Math.sin(t-spin),Math.cos(t-spin));
$('sideA').onclick=()=>{ spinGoal=nearest(0); spinVel=0; exitZoom(); updateSideUI(); Sound.whoosh(.4,700,300,.04); };
$('sideB').onclick=()=>{ spinGoal=nearest(Math.PI); spinVel=0; exitZoom(); updateSideUI(); Sound.whoosh(.4,700,300,.04); };
$('atlBack').onclick=()=>backToFloor();
$('detailClose').onclick=()=>exitZoom();
function enterZoom(d){ if(!hero) return; zoom={local:surfacePoint(hero,d[2],d[3],d[5]),dist:d[4],side:d[5]}; spinGoal=nearest(((d[5]>0)!==hero.flip)?0:Math.PI); spinVel=0; body.classList.add('zoomed'); $('detailTxt').textContent=d[1]; Sound.whoosh(.5,1200,400,.05); updateSideUI(); }
function exitZoom(silent){ if(!zoom) return; zoom=null; body.classList.remove('zoomed'); if(!silent) Sound.whoosh(.4,500,900,.03); }
const hsWrap=$('hotspots'); let hsEls=[];
function buildHotspots(){ hsWrap.innerHTML=''; hsEls=[]; if(!hero) return;
  PIECES[hero.pi].details.forEach(d=>{ const b=document.createElement('button'); b.className='hs'; b.innerHTML=`<i></i><span>${d[1]}</span>`; b.setAttribute('aria-label',`Close look: ${d[1]}`);
    b.onclick=()=>enterZoom(d); hsWrap.appendChild(b); hsEls.push({el:b,d,local:surfacePoint(hero,d[2],d[3],d[5]).add(V(0,0,.006*d[5]))}); }); }
const tmp=new THREE.Vector3(), tmp2=new THREE.Vector3();
function placeHotspots(){
  const show=(mode==='focus'||mode==='fitting')&&hero&&hero.t>.97&&!zoom&&!pdrag&&!warpEl.classList.contains('on');
  hsEls.forEach(({el,d,local})=>{ if(!show||Math.cos(spin+(hero.flip?Math.PI:0))*d[5]<.82){ el.hidden=true; return; }
    tmp.copy(local); hero.tee.localToWorld(tmp); tmp.project(camera);
    const x=(tmp.x*.5+.5)*innerWidth, y=(-tmp.y*.5+.5)*innerHeight;
    el.hidden=(tmp.z>1)||(drawer.classList.contains('open')&&(narrow()?y>innerHeight*.52:x>innerWidth-drawer.offsetWidth-20));
    const fl=x>innerWidth-(narrow()?150:180)-(drawer.classList.contains('open')&&!narrow()?drawer.offsetWidth:0); el.classList.toggle('flip',fl);
    el.style.transform=`translate(${fl?x+7-el.offsetWidth:x-7}px,${y-7}px)`; }); }
function flyToBag(){ if(!hero) return; hero.root.localToWorld(tmp.set(0,-TEE_DROP,0)); tmp.project(camera);
  const x=(tmp.x*.5+.5)*innerWidth, y=(-tmp.y*.5+.5)*innerHeight, w=narrow()?110:150;
  const img=document.createElement('img'); img.className='fly'; img.src=TH[PIECES[hero.pi].key]; img.alt=''; img.style.transform=`translate(${x-w/2}px,${y-w/2}px)`; body.appendChild(img);
  const r=$('bagBtn').getBoundingClientRect();
  requestAnimationFrame(()=>requestAnimationFrame(()=>{ img.style.transform=`translate(${r.left+r.width/2-w/2}px,${r.top+r.height/2-w/2}px) scale(.12)`; img.style.opacity='.4'; }));
  setTimeout(()=>{ img.remove(); const b=$('bagBtn'); b.classList.remove('pulse'); void b.offsetWidth; b.classList.add('pulse'); },880); hero.vx+=1.4; }

/* =========================================================
   Input
   ========================================================= */
const ray=new THREE.Raycaster(), ndc=new THREE.Vector2();
function setRay(e){ const r=canvas.getBoundingClientRect(); ndc.set(((e.clientX-r.left)/r.width)*2-1,-((e.clientY-r.top)/r.height)*2+1); ray.setFromCamera(ndc,camera); }
function pick(e){ setRay(e);
  const h=ray.intersectObjects([...pickables,...ghostHits,coreHit,termHit,...(vaultHit?[vaultHit]:[]),...(boothHit?[boothHit]:[])],false).find(h=>h.object===coreHit||h.object===termHit||h.object===vaultHit||h.object===boothHit||h.object.userData.ghost!==undefined||(h.object.userData.item&&h.object.userData.item.root.visible));
  if(h) return h.object===vaultHit?{vault:true}:h.object===boothHit?{booth:true}:h.object===coreHit?{core:true}:h.object===termHit?{term:true}:h.object.userData.ghost!==undefined?{ghost:h.object.userData.ghost}:{item:h.object.userData.item};
  if(mode==='walk'){ const f=ray.intersectObject(floorHit,false)[0]; if(f&&f.distance<14) return {floor:f.point}; }
  return null; }
let pdrag=null, hoverItem=null; const keys={};
const ring=$('floorRing');
canvas.addEventListener('pointerdown',e=>{ if(mode==='intro') return; canvas.setPointerCapture(e.pointerId);
  pdrag={x:e.clientX,y:e.clientY,lx:e.clientX,ly:e.clientY,lt:performance.now(),v:0,moved:0,spin0:spin}; });
canvas.addEventListener('pointermove',e=>{
  if(mode==='intro') return;
  if(pdrag){
    const dx=e.clientX-pdrag.x, dy=e.clientY-pdrag.y; pdrag.moved=Math.max(pdrag.moved,Math.abs(dx),Math.abs(dy));
    if(pdrag.moved>6){
      canvas.classList.add('dragging'); ring.classList.remove('on');
      const ddx=e.clientX-pdrag.lx, ddy=e.clientY-pdrag.ly, now=performance.now(), dt=Math.max(1,now-pdrag.lt);
      if((mode==='focus'||mode==='fitting')&&hero){ if(zoom) exitZoom(); spinGoal=null; spin=pdrag.spin0+dx*(COARSE?.013:.0095); pdrag.v=ddx/dt; hero.vx=Math.max(-3,Math.min(3,hero.vx+pdrag.v*.06)); updateSideUI(); }
      else { const k=COARSE?.006:.0042; cam.yawG+=ddx*k; cam.pitchG=Math.max(-.7,Math.min(.6,cam.pitchG+ddy*k)); cam.yaw=cam.yawG; cam.pitch=cam.pitchG; }
      pdrag.lx=e.clientX; pdrag.ly=e.clientY; pdrag.lt=now;
    }
    return;
  }
  if(COARSE) return;
  const p=pick(e); const it=p&&p.item; hoverItem=it&&it!==hero?it:null;
  canvas.classList.toggle('hovering',!!(p&&(p.item||p.core||p.term||p.vault||p.booth||p.ghost!==undefined)));
  if(p&&p.floor&&mode==='walk'){ tmp.copy(p.floor); tmp.project(camera); ring.style.transform=`translate(${(tmp.x*.5+.5)*innerWidth}px,${(-tmp.y*.5+.5)*innerHeight}px) scaleY(.45)`; ring.classList.add('on'); }
  else ring.classList.remove('on');
});
canvas.addEventListener('pointerup',e=>{
  if(!pdrag) return; canvas.classList.remove('dragging');
  const moved=pdrag.moved, v=pdrag.v; pdrag=null;
  if(moved>=6){ if((mode==='focus'||mode==='fitting')&&hero) spinVel=v*(COARSE?13:9.5); return; }
  const p=pick(e); if(!p){ return; }
  if(p.core){ if(mode==='walk'||mode==='focus') openCore(); else fireShock(); return; }
  if(p.term){ goCheckout(); return; }
  if(p.vault){ openVault(); return; }
  if(p.booth){ openBoothDJ(); return; }
  if(p.ghost!==undefined){ if(mode!=='fitting') focusPiece(p.ghost); return; }
  if(p.item){ const it=p.item;
    if(mode==='fitting'){ if(it.display===booth) pull(it); return; }
    if(it===hero) return;
    if(mode==='focus'&&it.display===focusDisplay){ pull(it); return; }
    if(it.display===booth) return;
    focusOn(it.display,it.size,it); return; }
  if(p.floor&&mode==='walk'){ const q=clampWalk(p.floor.clone()); const dx=q.x-cam.pos.x, dz=q.z-cam.pos.z;
    if(Math.hypot(dx,dz)>1.2) cam.yawG=cam.yaw+angD(Math.atan2(-dx,-dz),cam.yaw)*.6;
    cam.posG.copy(q); cam.rate=1.6; Sound.step(); hideHint(); }
  else if(mode==='focus'&&!p.item){ /* tap empty space keeps focus */ }
});
canvas.addEventListener('pointercancel',()=>{ pdrag=null; canvas.classList.remove('dragging'); });
canvas.addEventListener('pointerleave',()=>ring.classList.remove('on'));
canvas.addEventListener('wheel',e=>{ e.preventDefault(); if(mode!=='walk') return;
  const f=fwd(cam.yaw,0); cam.posG.addScaledVector(f,-e.deltaY*.004); clampWalk(cam.posG); cam.rate=3; },{passive:false});
addEventListener('keydown',e=>{
  if(mode==='intro'||qsOpen||e.target.closest&&e.target.closest('input,textarea')) return;
  if(e.key==='Escape'){ if(bagEl.classList.contains('open')) closeBag(); else if(zoom) exitZoom(); else if(mode!=='walk') backToFloor(); return; }
  if(document.activeElement!==canvas&&mode!=='walk') return;
  keys[e.key.toLowerCase()]=true;
  if(mode==='walk'&&['arrowup','arrowdown','arrowleft','arrowright','w','a','s','d'].includes(e.key.toLowerCase())&&document.activeElement===canvas) e.preventDefault();
});
addEventListener('keyup',e=>{ keys[e.key.toLowerCase()]=false; });
/* =========================================================
   The Core: tell it what you carry, it summons your piece
   ========================================================= */
const coreDisplay={kind:'core',wallId:'core',items:[]};
const INTENT_COPY={'human-imagination':['Imagine','Create what has never existed.'],'dream-the-world':['Dream','Dream past the limits of reality.'],'morning-radiance':['Radiate','Every sunrise, a new chance to shine.'],'powerful-since-birth-1':['Carry','Power you have held since day one.']};
const INTENTS=[...new Set(PIECES.map(p=>p.handle))].map(h=>{ const pi=Math.max(0,PIECES.findIndex(p=>p.handle===h&&inStock(p))>=0?PIECES.findIndex(p=>p.handle===h&&inStock(p)):PIECES.findIndex(p=>p.handle===h));
  const c=INTENT_COPY[h]||[PRODUCTS[h].title.split(' ')[0],(PRODUCTS[h].desc||'').split('. ')[0]+'.']; return {pi,word:c[0],line:c[1]}; }).slice(0,6);
let coreOpen=0, coreReading=0, coreHold=0;
function buildCore(){
  PIECES.forEach((p,i)=>{ const it=makeItem(i,defaultSize(p),inStock(p),LO); it.display=coreDisplay; it.stackK=9;
    it.rest.set(CORE.x,.35,CORE.z); it.restYaw=0; it.heroPos.set(CORE.x,CORE.y+TEE_DROP+.02,CORE.z); it.heroYaw=it.flip?Math.PI:0;
    it.root.position.copy(it.rest); it.root.visible=false; world.add(it.root); coreDisplay.items.push(it); });
}
function renderCore(){
  parkWallets();
  drawer.innerHTML=`
    <div class="d-head"><span class="eyebrow">The Core · PSB Flagship</span><button class="mini" id="kClose" aria-label="Back to the floor">✕</button></div>
    <h3 class="title-xl d-title">What do you <em>carry?</em></h3>
    <p class="d-desc">Pick the power you're bringing today. The Core reads it and pulls the piece that was made for it, straight up through the light.</p>
    <div class="intents">${INTENTS.map((o,k)=>{ const p=PIECES[o.pi]; return `
      <button class="intent" data-k="${k}" style="--c:${p.glow}"><i></i><b>${o.word}</b><span>${o.line}</span><em>${PRODUCTS[p.handle].title}${inStock(p)?'':' · sold out'}</em></button>`; }).join('')}</div>
    <button class="ghost" id="kSurprise">Surprise me</button>`;
  $('kClose').onclick=()=>backToFloor();
  drawer.querySelectorAll('[data-k]').forEach(b=>b.onclick=()=>summon(INTENTS[+b.dataset.k].pi));
  $('kSurprise').onclick=()=>{ const pool=PIECES.map((p,i)=>i).filter(i=>inStock(PIECES[i])&&i!==sel); summon(pool[Math.floor(Math.random()*pool.length)]); };
}
function openCore(again){
  if(mode==='fitting') return;
  hideToast();
  if(mode==='focus'||again){ release(); focusDisplay=null; }
  mode='core'; body.classList.remove('focus','zoomed','checkout'); body.classList.add('coremode');
  station='core'; setLoc(STATIONS.find(s=>s.id==='core'));
  drawer.scrollTop=0; drawer.dataset.kind='core'; renderCore(); drawer.classList.add('open'); body.classList.add('drawer-open');
  fireShock(); Sound.room(520);
}
function summon(pi){
  coreReading=1.2; fireShock(); Sound.warp();
  setTimeout(()=>{
    focusDisplay=coreDisplay; mode='focus'; body.classList.remove('coremode'); body.classList.add('focus');
    const it=coreDisplay.items[pi], p=PIECES[pi]; if(!chosen[p.key]&&inStock(p)) chosen[p.key]=defaultSize(p); it.tt=0; it.t=0; pull(it); drawer.scrollTop=0; drawer.dataset.kind='piece'; renderDrawer(); Sound.ping(988,.05);
    items.forEach(o=>{ if(o.pi===pi){ o.vx+=(Math.random()-.5)*2; o.vz+=1.4; } });
  },RM?0:900);
}
/* cash wrap pay terminal: total + QR for phone checkout */
const TERM={pos:V(.14,1.1,-1.86),cam:V(.2,1.56,-.98),look:V(.14,1.27,-1.86)};
const termCanvas=cnv(512,700), termTex=new THREE.CanvasTexture(termCanvas[0]); termTex.encoding=THREE.sRGBEncoding; termTex.anisotropy=MAXANI;
let termHit;
{ const g=new THREE.Group(); g.position.copy(TERM.pos); world.add(g);
  const foot=new THREE.Mesh(new THREE.CylinderGeometry(.055,.06,.012,40),M.chrome); foot.position.y=.006; g.add(foot);
  const neck=new THREE.Mesh(new THREE.CylinderGeometry(.008,.008,.11,12),M.chrome); neck.position.y=.06; g.add(neck);
  const head=new THREE.Group(); head.position.y=.17; head.rotation.x=-.28; g.add(head);
  const body3=new THREE.Mesh(new THREE.BoxGeometry(.2,.27,.014),M.lacquer); head.add(body3);
  const scr=new THREE.Mesh(new THREE.PlaneGeometry(.184,.252),new THREE.MeshBasicMaterial({map:termTex,toneMapped:false})); scr.position.z=.0075; head.add(scr);
  termHit=new THREE.Mesh(new THREE.BoxGeometry(.3,.4,.2),new THREE.MeshBasicMaterial({visible:false})); termHit.position.y=.17; g.add(termHit);
  const glow=new THREE.Mesh(new THREE.PlaneGeometry(.7,.7),addMat(0xcfd8ff,.18)); glow.rotation.x=-Math.PI/2; glow.position.y=.004; g.add(glow); }
function drawTerminal(){
  const [c,g]=termCanvas, W=c.width, H=c.height, count=cart.item_count||0;
  g.fillStyle='#0b0c10'; g.fillRect(0,0,W,H);
  g.fillStyle='#efece6'; g.textAlign='center'; g.textBaseline='middle';
  g.font='800 40px "Archivo", sans-serif'; if(g.letterSpacing!==undefined) g.letterSpacing='8px'; g.fillText('PSB',W/2,62);
  if(g.letterSpacing!==undefined) g.letterSpacing='4px'; g.font='500 20px "IBM Plex Mono", monospace'; g.fillStyle='#868a94'; g.fillText('CASH WRAP · TAP TO PAY',W/2,104);
  g.fillStyle='#efece6'; g.font='800 84px "Archivo", sans-serif'; if(g.letterSpacing!==undefined) g.letterSpacing='0px'; g.fillText(money(cart.total_price),W/2,190);
  g.font='italic 500 30px "Cormorant Garamond", serif'; g.fillStyle='#c7cbd3'; g.fillText(count?`${count} ${count===1?'piece':'pieces'} in your bag`:'Your bag is empty',W/2,248);
  if(count){ try{ const q=qrcode(0,'M'); q.addData(cartURL()); q.make(); const n=q.getModuleCount(), sz=300, cs=sz/n, x0=(W-sz)/2, y0=290;
      g.fillStyle='#efece6'; g.fillRect(x0-16,y0-16,sz+32,sz+32); g.fillStyle='#0b0c10';
      for(let r=0;r<n;r++) for(let k=0;k<n;k++) if(q.isDark(r,k)) g.fillRect(x0+k*cs,y0+r*cs,Math.ceil(cs),Math.ceil(cs)); }catch(e){}
    g.font='500 19px "IBM Plex Mono", monospace'; g.fillStyle='#868a94'; if(g.letterSpacing!==undefined) g.letterSpacing='2px'; g.fillText('SCAN TO PAY ON YOUR PHONE',W/2,642); }
  else { g.strokeStyle='#2a2c33'; g.lineWidth=2; g.strokeRect(W/2-150,290,300,300); g.font='500 19px "IBM Plex Mono", monospace'; g.fillStyle='#868a94'; g.fillText('ADD A PIECE TO START',W/2,440); }
  termTex.needsUpdate=true;
}
window.__term=drawTerminal; fontsReady.then(drawTerminal);
/* =========================================================
   Drop vault: the next drop, sealed behind glass by the door. Config: psb-drop.json in Content → Files
   {"name":"Drop 002","date":"2026-11-14T20:00:00-05:00","handle":"product-handle","teaser":"…"}
   ========================================================= */
const VAULT={pos:V(1.45,0,4.45),cam:V(2.15,1.48,6.15),look:V(1.4,1.05,4.45)};
let DROP={name:'The next drop',date:null,handle:'',teaser:'Sealed until release. Get on the list and the date reaches you first.'};
fetch(FILE('psb-drop.json'),{cache:'no-cache'}).then(r=>r.ok?r.json():null).then(j=>{ if(j&&typeof j==='object'){ DROP=Object.assign(DROP,j); if(DROP.date) DROP.t=Date.parse(DROP.date); vaultLive(); drawVaultLED(); } }).catch(()=>{});
const dropPiece=()=>DROP.handle?PIECES.findIndex(p=>p.handle===DROP.handle):-1;
const isLive=()=>DROP.t&&Date.now()>=DROP.t;
const vaultLEDc=cnv(512,160), vaultLEDt=new THREE.CanvasTexture(vaultLEDc[0]); vaultLEDt.encoding=THREE.sRGBEncoding;
let vaultHit, vaultShirt=null, vaultScan=null, vaultGlow=null, vaultDoor=null, vaultOpen=0;
function cdParts(ms){ ms=Math.max(0,ms); const d=Math.floor(ms/864e5), h=Math.floor(ms/36e5)%24, m=Math.floor(ms/6e4)%60, s=Math.floor(ms/1e3)%60; return [d,h,m,s]; }
function drawVaultLED(){ const [c,g]=vaultLEDc, W=c.width, H=c.height; g.fillStyle='#050608'; g.fillRect(0,0,W,H);
  g.textAlign='center'; g.textBaseline='middle'; g.fillStyle='#7d828c'; g.font='500 22px "IBM Plex Mono", monospace'; if(g.letterSpacing!==undefined) g.letterSpacing='6px';
  g.fillText((isLive()?'NOW LIVE · ':'')+String(DROP.name||'NEXT DROP').toUpperCase(),W/2,36);
  if(g.letterSpacing!==undefined) g.letterSpacing='2px'; g.fillStyle='#ff4d3a'; g.font='500 62px "IBM Plex Mono", monospace';
  if(isLive()) { g.fillStyle='#6cff9a'; g.fillText('OPEN',W/2,100); }
  else if(DROP.t){ const [d,h,m,s]=cdParts(DROP.t-Date.now()); g.fillText(`${pad(d)}:${pad(h)}:${pad(m)}:${pad(s)}`,W/2,100); g.fillStyle='#5c6068'; g.font='500 16px "IBM Plex Mono", monospace'; g.fillText('DAYS     HRS     MIN     SEC',W/2,142); }
  else g.fillText('SEALED',W/2,100);
  vaultLEDt.needsUpdate=true; }
function buildVault(){
  const g=new THREE.Group(); g.position.copy(VAULT.pos); world.add(g);
  box(.7,.92,.7,M.lacquer,0,.46,0,g); box(.72,.02,.72,M.chrome,0,.93,0,g); box(.72,.02,.72,M.chrome,0,.01,0,g);
  const led=new THREE.Mesh(new THREE.PlaneGeometry(.5,.156),new THREE.MeshBasicMaterial({map:vaultLEDt,toneMapped:false})); led.position.set(0,.62,.352); g.add(led);
  const caseG=new THREE.Group(); caseG.position.y=.94; g.add(caseG);
  const glassC=new THREE.Mesh(new THREE.BoxGeometry(.6,.86,.6),new THREE.MeshPhysicalMaterial({color:0xdfe6f2,roughness:.02,metalness:0,transmission:0,transparent:true,opacity:.14,envMapIntensity:1.4,side:THREE.DoubleSide,depthWrite:false}));
  glassC.position.y=.43; caseG.add(glassC); vaultDoor=glassC;
  [[-1,-1],[1,-1],[-1,1],[1,1]].forEach(([a,b])=>box(.014,.86,.014,M.chrome,a*.3,.43,b*.3,caseG));
  [0,.86].forEach(y=>{ [[0,-.3,.6,.014],[0,.3,.6,.014]].forEach(([x,z,w,d])=>box(w,.014,d,M.chrome,x,y,z,caseG)); [[-.3,0],[.3,0]].forEach(([x,z])=>box(.014,.014,.6,M.chrome,x,y,z,caseG)); });
  box(.64,.05,.64,M.lacquer,0,.885,0,caseG);
  const lamp=new THREE.Mesh(new THREE.PlaneGeometry(.4,.4),new THREE.MeshBasicMaterial({color:new THREE.Color(2,2,2.1),toneMapped:false})); lamp.rotation.x=Math.PI/2; lamp.position.y=.858; caseG.add(lamp);
  const vl=new THREE.SpotLight(0xe8eeff,1.1,2,.8,.6,1.4); vl.position.set(0,.84,0); vl.target.position.set(0,0,0); caseG.add(vl,vl.target);
  /* the shirt: a black silhouette until release */
  const hang=new THREE.Group(); hang.position.y=.84; caseG.add(hang);
  const tee=new THREE.Group(); tee.position.set(-HOOK.x,-HOOK.y,-HOOK.z); tee.scale.setScalar(.92); tee.position.multiplyScalar(.92); hang.add(tee);
  const hg=cloneNode(PROTO.hanger); hg.material=woodMat; const hk=cloneNode(PROTO.hook); hk.material=M.chrome;
  const sh=cloneNode(PROTO.hi); sh.material=new THREE.MeshPhysicalMaterial({color:0x020203,roughness:.6,metalness:0,sheen:1,sheenRoughness:.3,sheenColor:new THREE.Color(0x30343e),envMapIntensity:.35,side:THREE.DoubleSide});
  tee.add(hg,hk,sh); vaultShirt={hang,sh,dark:sh.material};
  vaultScan=new THREE.Mesh(new THREE.PlaneGeometry(.56,.012),addMat(0xff4d3a,.85,null)); vaultScan.rotation.x=-Math.PI/2; caseG.add(vaultScan);
  vaultGlow=new THREE.Mesh(new THREE.PlaneGeometry(1.6,1.6),addMat(0xff4d3a,.12)); vaultGlow.rotation.x=-Math.PI/2; vaultGlow.position.set(VAULT.pos.x,.013,VAULT.pos.z); world.add(vaultGlow);
  vaultHit=new THREE.Mesh(new THREE.BoxGeometry(.75,1.85,.75),new THREE.MeshBasicMaterial({visible:false})); vaultHit.position.y=.92; g.add(vaultHit);
  BLOCK.push([VAULT.pos.x-.36,VAULT.pos.x+.36,VAULT.pos.z-.36,VAULT.pos.z+.36]);
  vaultLive(); fontsReady.then(drawVaultLED);
}
function vaultLive(){ if(!vaultShirt) return; const i=dropPiece();
  if(isLive()&&i>=0&&TEX[PIECES[i].key]){ vaultShirt.sh.material=teeMat(PIECES[i].key,false); vaultScan.material.color.set(0x6cff9a); vaultGlow.material.color.set(0x6cff9a); }
  else { vaultShirt.sh.material=vaultShirt.dark; } }
function renderVault(){
  parkWallets(); const live=isLive(), i=dropPiece(); const [d,h,m,s]=DROP.t?cdParts(DROP.t-Date.now()):[0,0,0,0];
  drawer.innerHTML=`
    <div class="d-head"><span class="eyebrow">The Vault</span><button class="mini" id="vClose" aria-label="Back to the floor">✕</button></div>
    <h3 class="title-xl d-title">${live?'It’s <em>open.</em>':'Sealed <em>until release.</em>'}</h3>
    <p class="d-desc"><b style="color:var(--bone)">${DROP.name||'The next drop'}.</b> ${DROP.teaser||''}</p>
    ${DROP.t&&!live?`<div class="vault-cd" id="vCd">${[['Days',d],['Hrs',h],['Min',m],['Sec',s]].map(([l,v])=>`<div><b>${pad(v)}</b><span>${l}</span></div>`).join('')}</div>
      <p class="d-note" style="margin:0">Opens ${new Date(DROP.t).toLocaleString(undefined,{weekday:'long',month:'long',day:'numeric',hour:'numeric',minute:'2-digit'})}.</p>`:''}
    ${live&&i>=0?`<button class="chrome-btn add" id="vShop">Shop the drop →</button>`:`
    <div class="group"><span class="eyebrow">${DROP.t?'Get a reminder':'Get the date first'}</span>
      <form class="notify" id="vForm"><input type="email" required placeholder="Your email" aria-label="Your email" autocomplete="email"><button class="chrome-btn" type="submit">Notify me</button></form>
      <p class="d-note" id="vMsg" style="margin:0">One email when it opens. Unsubscribe anytime.</p></div>`}`;
  $('vClose').onclick=()=>backToFloor();
  const vs=$('vShop'); if(vs) vs.onclick=()=>{ backToFloor(true); setTimeout(()=>focusPiece(i),250); };
  const f=$('vForm'); if(f) f.onsubmit=async e=>{ e.preventDefault(); const em=f.querySelector('input').value.trim(); if(!em) return; const btn=f.querySelector('button'); btn.disabled=true; $('vMsg').textContent='Adding you…';
    try{ const fd=new FormData(); fd.append('form_type','customer'); fd.append('utf8','✓'); fd.append('contact[email]',em); fd.append('contact[tags]','newsletter,psb-drop-vault');
      const r=await fetch(ROOT+'contact#contact_form',{method:'POST',body:fd,credentials:'same-origin'});
      if(/challenge/.test(r.url||'')){ $('vMsg').innerHTML=`One more step: <a href="${r.url}" target="_blank" rel="noopener" style="color:var(--bone)">confirm you're human</a>.`; btn.disabled=false; return; }
      if(!r.ok) throw 0; $('vMsg').textContent="You're on the list. We'll email you when it opens."; f.querySelector('input').value=''; Sound.ping(1568,.05); track('drop_signup',{drop:DROP.name});
    }catch(err){ $('vMsg').textContent="That didn't go through. Try again in a moment."; btn.disabled=false; } };
}
function openVault(){ if(mode==='fitting') return; hideToast(); if(mode==='focus'){ release(); focusDisplay=null; }
  mode='vault'; body.classList.remove('focus','zoomed','coremode'); body.classList.add('checkout');
  station='vault'; setLoc(STATIONS.find(s=>s.id==='vault')); drawer.scrollTop=0; drawer.dataset.kind='vault'; renderVault(); drawer.classList.add('open'); body.classList.add('drawer-open');
  Sound.whoosh(.6,900,260,.04); track('vault_open',{drop:DROP.name}); }

/* =========================================================
   The Booth: decks at the back, playing live. Spatial audio: it gets louder as you walk up.
   (drop an MP3 named psb-booth.mp3 into Content → Files and the booth plays that instead)
   ========================================================= */
const BOOTH_DJ={pos:V(-2.3,0,-3.55),cam:V(-1.45,1.5,-1.9),look:V(-2.3,1.0,-3.55)};
let boothHit, platters=[], meters=[], boothStrip=null, ballMesh=null;
const recordTex=(()=>{ const [c,g]=cnv(256,256); g.fillStyle='#0b0b0d'; g.fillRect(0,0,256,256);
  for(let r=124;r>30;r-=2){ g.strokeStyle=`rgba(255,255,255,${.03+((r*7)%5)*.012})`; g.lineWidth=1; g.beginPath(); g.arc(128,128,r,0,7); g.stroke(); }
  g.fillStyle='#d9a46c'; g.beginPath(); g.arc(128,128,30,0,7); g.fill(); g.fillStyle='#0b0b0d'; g.font='800 15px Archivo, sans-serif'; g.textAlign='center'; g.fillText('PSB',128,126); g.font='500 8px monospace'; g.fillText('SIDE A',128,140);
  g.beginPath(); g.arc(128,128,3,0,7); g.fill(); const t=new THREE.CanvasTexture(c); t.encoding=THREE.sRGBEncoding; return t; })();
function buildDJ(){
  const g=new THREE.Group(); g.position.copy(BOOTH_DJ.pos); world.add(g);
  box(1.4,.92,.6,M.lacquer,0,.46,0,g); box(1.44,.025,.64,M.chrome,0,.935,0,g);
  boothStrip=new THREE.Mesh(new THREE.BoxGeometry(1.36,.012,.01),new THREE.MeshBasicMaterial({color:0xffffff,toneMapped:false})); boothStrip.position.set(0,.06,.305); g.add(boothStrip);
  new THREE.TextureLoader().setCrossOrigin('anonymous').load(CFG.files.mark,t=>{ t.encoding=THREE.sRGBEncoding;
    const m=new THREE.Mesh(new THREE.PlaneGeometry(.56,.56*81/230),new THREE.MeshBasicMaterial({map:t,transparent:true,toneMapped:false,color:new THREE.Color(1.6,1.6,1.6)})); m.position.set(0,.55,.302); g.add(m);
    const hl=new THREE.Mesh(new THREE.PlaneGeometry(1.1,.5),addMat(0xffffff,.1)); hl.position.set(0,.55,.301); g.add(hl); });
  [-.42,.42].forEach(x=>{ box(.42,.06,.34,FAC.frame,x,.97,0,g);
    const pl=new THREE.Mesh(new THREE.CylinderGeometry(.15,.15,.012,48),[new THREE.MeshStandardMaterial({color:0x151518,roughness:.4}),new THREE.MeshStandardMaterial({map:recordTex,roughness:.35,metalness:.1}),M.chrome]);
    pl.position.set(x-.03,1.007,0); g.add(pl); platters.push(pl);
    const arm=new THREE.Mesh(new THREE.CylinderGeometry(.004,.004,.22,8),M.chrome); arm.rotation.z=Math.PI/2; arm.rotation.y=.5; arm.position.set(x+.1,1.03,.05); g.add(arm); });
  box(.22,.07,.32,FAC.frame,0,.975,0,g);
  for(let k=0;k<6;k++){ const kn=new THREE.Mesh(new THREE.CylinderGeometry(.011,.011,.016,14),M.chrome); kn.position.set(-.05+(k%2)*.1,1.018,-.1+Math.floor(k/2)*.07); g.add(kn); }
  for(let c2=0;c2<2;c2++) for(let k=0;k<8;k++){ const m=new THREE.Mesh(new THREE.BoxGeometry(.012,.004,.008),new THREE.MeshBasicMaterial({color:k<5?0x3dff7a:k<7?0xffc23d:0xff4d3a,toneMapped:false}));
    m.position.set(-.012+c2*.024,1.012,.12-k*.012); g.add(m); meters.push({m,k,c2}); }
  /* speakers behind the decks */
  const cone=(()=>{ const [c,g2]=cnv(128,128); g2.fillStyle='#0a0a0c'; g2.fillRect(0,0,128,128); const r=g2.createRadialGradient(64,64,6,64,64,58); r.addColorStop(0,'#2a2b30'); r.addColorStop(.25,'#09090b'); r.addColorStop(.9,'#16171b'); r.addColorStop(1,'#050506');
    g2.fillStyle=r; g2.beginPath(); g2.arc(64,64,58,0,7); g2.fill(); const t=new THREE.CanvasTexture(c); t.encoding=THREE.sRGBEncoding; return t; })();
  [-.6,.6].forEach(x=>{ const sp=box(.34,1.25,.3,M.lacquer,x,.625,-.5,g);
    [[.95,.12],[.55,.12],[.22,.07]].forEach(([y,r])=>{ const d=new THREE.Mesh(new THREE.CircleGeometry(r,32),new THREE.MeshStandardMaterial({map:cone,roughness:.8})); d.position.set(x,y+.05,-.349); g.add(d); }); });
  /* mirror ball */
  ballMesh=new THREE.Mesh(new THREE.IcosahedronGeometry(.15,2),new THREE.MeshStandardMaterial({color:0xffffff,metalness:1,roughness:.06,flatShading:true,envMapIntensity:1.6}));
  ballMesh.position.set(0,2.85,.45); g.add(ballMesh); const cord=new THREE.Mesh(new THREE.CylinderGeometry(.003,.003,.3,6),M.chrome); cord.position.set(0,3.15,.45); g.add(cord);
  const bs=new THREE.SpotLight(0xffffff,2.4,6,.35,.5,1.4); bs.position.set(.8,3.2,1.6); bs.target=ballMesh; scene.add(bs);
  boothHit=new THREE.Mesh(new THREE.BoxGeometry(1.6,1.4,1.2),new THREE.MeshBasicMaterial({visible:false})); boothHit.position.set(0,.7,-.2); g.add(boothHit);
  BLOCK.push([BOOTH_DJ.pos.x-.8,BOOTH_DJ.pos.x+.8,BOOTH_DJ.pos.z-.7,BOOTH_DJ.pos.z+.35]);
}
/* the music: a swung four-bar loop played live by the Web Audio clock, routed through a 3D panner at the decks */
const Music={on:false,bus:null,panner:null,an:null,buf:null,next:0,step:0,timer:null,bpm:94,level:0,track:null,trackChecked:false,name:'PSB Radio · live in your browser',
  init(){ if(this.bus||!Sound.ctx) return; const c=Sound.ctx;
    this.bus=c.createGain(); this.bus.gain.value=.85; const comp=c.createDynamicsCompressor(); comp.threshold.value=-14; comp.ratio.value=3;
    const p=this.panner=c.createPanner(); p.panningModel='HRTF'; p.distanceModel='inverse'; p.refDistance=1.3; p.maxDistance=50; p.rolloffFactor=1.25;
    const P=BOOTH_DJ.pos; if(p.positionX){ p.positionX.value=P.x; p.positionY.value=1.2; p.positionZ.value=P.z; } else p.setPosition(P.x,1.2,P.z);
    this.an=c.createAnalyser(); this.an.fftSize=256; this.buf=new Uint8Array(this.an.fftSize);
    this.bus.connect(comp); comp.connect(p); p.connect(Sound.master); comp.connect(this.an); },
  async checkTrack(){ if(this.trackChecked) return; this.trackChecked=true;
    try{ const u=FILE('psb-booth.mp3'); const r=await fetch(u,{method:'HEAD'}); if(!r.ok) return;
      const a=new Audio(); a.crossOrigin='anonymous'; a.src=u; a.loop=true; a.preload='auto'; this.track=a; this.name='Now spinning · psb-booth.mp3';
      Sound.ctx.createMediaElementSource(a).connect(this.bus); if(this.on){ this.stopLoop(); a.play().catch(()=>{}); } }catch(e){} },
  start(){ if(this.on||!Sound.ctx) return; this.init(); this.on=true; this.checkTrack();
    if(this.track){ this.track.play().catch(()=>{}); return; }
    this.next=Sound.ctx.currentTime+.05; this.step=0; this.timer=setInterval(()=>this.sched(),25); },
  stopLoop(){ clearInterval(this.timer); this.timer=null; },
  stop(){ this.on=false; this.stopLoop(); if(this.track) this.track.pause(); },
  sched(){ const c=Sound.ctx, s16=60/this.bpm/4; while(this.next<c.currentTime+.12){ this.hit(this.step,this.next); this.next+=s16*(this.step%2?.86:1.14); this.step=(this.step+1)%64; } },
  env(t,g,a,d,v){ g.gain.setValueAtTime(0,t); g.gain.linearRampToValueAtTime(v,t+a); g.gain.exponentialRampToValueAtTime(.0008,t+a+d); },
  osc(type,f,t,d,v,dest,f1){ const c=Sound.ctx,o=c.createOscillator(),g=c.createGain(); o.type=type; o.frequency.setValueAtTime(f,t); if(f1) o.frequency.exponentialRampToValueAtTime(f1,t+d*.5);
    this.env(t,g,.004,d,v); o.connect(g); g.connect(dest||this.bus); o.start(t); o.stop(t+d+.05); return g; },
  noise(t,d,v,type,f,q){ const c=Sound.ctx,s=c.createBufferSource(),fl=c.createBiquadFilter(),g=c.createGain(); s.buffer=Sound.noise; fl.type=type; fl.frequency.value=f; fl.Q.value=q||.7;
    this.env(t,g,.002,d,v); s.connect(fl); fl.connect(g); g.connect(this.bus); s.start(t,Math.random()); s.stop(t+d+.05); },
  hit(st,t){ const b=Math.floor(st/16), s=st%16, ROOTS=[55,43.65,65.41,49], CH=[[220,261.6,329.6,392],[174.6,220,261.6,329.6],[261.6,329.6,392,493.9],[196,246.9,293.7,440]];
    const kicks=b===3?[0,3,10,13]:[0,7,10];
    if(kicks.includes(s)) this.osc('sine',150,t,.42,.95,null,42);
    if(s===4||s===12){ this.noise(t,.17,.38,'bandpass',1900,.9); this.osc('triangle',190,t,.09,.18); }
    if(s%2===0) this.noise(t,s%4===2?.07:.035,s%4===2?.13:.07,'highpass',7600); else if(s>=13) this.noise(t,.025,.04,'highpass',8200);
    const bl={0:3,3:1,8:2,11:1,14:2}; if(bl[s]){ const c=Sound.ctx,o=c.createOscillator(),f=c.createBiquadFilter(),g=c.createGain(); o.type='sawtooth'; o.frequency.value=ROOTS[b]*(s===3||s===11?2:1);
      f.type='lowpass'; f.frequency.value=360; f.Q.value=5; this.env(t,g,.008,bl[s]*.14,.3); o.connect(f); f.connect(g); g.connect(this.bus); o.start(t); o.stop(t+bl[s]*.14+.1); }
    if(s===0||s===10){ const c=Sound.ctx, lp=c.createBiquadFilter(); lp.type='lowpass'; lp.frequency.value=1500; lp.connect(this.bus);
      CH[b].forEach(fq=>{ this.osc('triangle',fq,t,s?.32:.75,.05,lp); this.osc('sine',fq*1.003,t,s?.32:.75,.035,lp); }); } },
  tick(){ if(!this.an||!this.on){ this.level*=.9; return this.level; } this.an.getByteTimeDomainData(this.buf); let m=0; for(let i=0;i<this.buf.length;i+=4){ const v=Math.abs(this.buf[i]-128); if(v>m) m=v; }
    this.level=Math.max(m/128,this.level*.88); return this.level; },
  listen(){ const c=Sound.ctx; if(!c||!this.on) return; const L=c.listener, F2=fwd(cam.yaw,cam.pitch), P=camera.position;
    if(L.positionX){ L.positionX.value=P.x; L.positionY.value=P.y; L.positionZ.value=P.z; L.forwardX.value=F2.x; L.forwardY.value=F2.y; L.forwardZ.value=F2.z; L.upX.value=0; L.upY.value=1; L.upZ.value=0; }
    else { L.setPosition(P.x,P.y,P.z); L.setOrientation(F2.x,F2.y,F2.z,0,1,0); } }
};
function renderBoothPanel(){
  parkWallets();
  drawer.innerHTML=`
    <div class="d-head"><span class="eyebrow">The Booth</span><button class="mini" id="bbClose" aria-label="Back to the floor">✕</button></div>
    <h3 class="title-xl d-title">On the <em>decks.</em></h3>
    <p class="d-desc">The sound in here comes from the booth. Walk away and it fades; come back and it's in your chest.</p>
    <div class="booth-row"><span class="eqbars" aria-hidden="true"><i></i><i></i><i></i><i></i></span><span class="eyebrow" style="color:var(--chrome)">${Music.name}</span></div>
    <button class="chrome-btn add" id="bbSound">${Sound.on?'Turn the sound off':'Turn the sound on'}</button>
    <p class="d-note">Headphones on for the full effect: the music sits where the decks are.</p>`;
  $('bbClose').onclick=()=>backToFloor();
  $('bbSound').onclick=()=>{ Sound.set(!Sound.on); renderBoothPanel(); };
}
function openBoothDJ(){ if(mode==='fitting') return; hideToast(); if(mode==='focus'){ release(); focusDisplay=null; }
  mode='booth'; body.classList.remove('focus','zoomed','coremode'); body.classList.add('checkout');
  station='booth'; setLoc(STATIONS.find(s=>s.id==='booth')); drawer.scrollTop=0; drawer.dataset.kind='booth'; renderBoothPanel(); drawer.classList.add('open'); body.classList.add('drawer-open');
  Sound.whoosh(.6,900,260,.04); track('booth_open',{}); }
let vaultT=0;
function updateExtras(dt,t){
  const lv=Music.tick();
  platters.forEach(p=>p.rotation.y-=dt*(Music.on?3.49:0));
  if(boothStrip){ boothStrip.material.color.copy(cNow).lerp(white,.2).multiplyScalar(.6+lv*2.4); }
  meters.forEach(({m,k,c2})=>m.visible=k<Math.round((lv*(c2?.92:1))*9));
  if(ballMesh&&!RM) ballMesh.rotation.y+=dt*.6;
  if(vaultScan){ vaultScan.position.y=.06+(.5+.5*Math.sin(t*1.4))*.74; vaultScan.material.opacity=.55+.3*Math.sin(t*9); }
  if(vaultGlow) vaultGlow.material.opacity=.09+.05*Math.sin(t*2.2);
  if(vaultShirt&&!RM) vaultShirt.hang.rotation.y+=dt*.35;
  if((vaultT+=dt)>1){ vaultT=0; drawVaultLED(); if(mode==='vault'&&$('vCd')&&DROP.t){ const v=cdParts(DROP.t-Date.now()); $('vCd').querySelectorAll('b').forEach((b,i)=>b.textContent=pad(v[i])); if(isLive()){ vaultLive(); renderVault(); } } }
  if(Sound.on) Music.listen();
}
function goCheckout(){
  bagEl.classList.remove('open'); hideToast();
  const go=()=>{ release(); focusDisplay=null; mode='checkout'; body.classList.remove('focus','zoomed','fitting','coremode'); body.classList.add('checkout');
    station='counter'; setLoc(STATIONS.find(s=>s.id==='counter')); drawTerminal(); openCheckoutPanel(); Sound.whoosh(.6,900,260,.04); };
  if(mode==='fitting'){ exitFitting(); setTimeout(go,520); } else go();
}
function fireShock(){ shockT=0; coreReading=Math.max(coreReading,.6); items.forEach(it=>{ it.vx+=(Math.random()-.5)*2.4; it.vz+=1.6+Math.random(); }); Sound.thump(.5); Sound.whoosh(.9,300,2400,.06); }
let hintT; function showHint(){ $('walkHint').classList.remove('gone'); clearTimeout(hintT); hintT=setTimeout(hideHint,6500); }
function hideHint(){ $('walkHint').classList.add('gone'); }
function enter(withSound,pieceI){
  if(mode!=='intro') return; track('enter',{sound:!!withSound});
  if(heroVideo) heroVideo.el.play().catch(()=>{});
  $('intro').classList.add('gone'); mode='walk'; if(withSound) Sound.set(true);
  if(RM){ goStation('entrance',true); cam.pos.copy(cam.posG); cam.yaw=cam.yawG; cam.pitch=cam.pitchG; }
  else { aimAt(V(0,1.65,7.1),V(-.3,1.4,2)); cam.rate=.9; setTimeout(()=>{ if(mode==='walk'&&cam.pos.z>6.3){ goStation('entrance',true); cam.rate=1.1; } },1900); }
  setTimeout(showHint,1800); canvas.focus({preventScroll:true});
  /* deep link: /?piece=<product-handle or key> opens the store focused on that shirt */
  let want=null; try{ want=new URLSearchParams(location.search).get('piece'); }catch(e){}
  const wi=pieceI!==undefined?pieceI:want?PIECES.findIndex(p=>p.handle===want||p.key===want):-1;
  if(wi>=0) setTimeout(()=>{ if(mode==='walk') focusPiece(wi); },RM?300:2400);
}
$('enter').onclick=()=>enter(true);
$('enterQuiet').onclick=()=>enter(false);
aimAt(V(.55,1.55,13.4),V(-.17,2.2,ROOM.z1)); cam.pos.copy(cam.posG); cam.yaw=cam.yawG; cam.pitch=cam.pitchG;

/* =========================================================
   Loop
   ========================================================= */
const clock=new THREE.Clock(); let clockT=0, beatK=-1; const lastCam=new THREE.Vector3();
const cNow=new THREE.Color(PIECES[0].glow), cGoal=new THREE.Color(); const viewOff={x:0,y:0};
const ease=x=>x<.5?4*x*x*x:1-Math.pow(-2*x+2,3)/2;
addEventListener('resize',()=>{ renderer.setSize(innerWidth,innerHeight,false); camera.aspect=innerWidth/innerHeight; camera.updateProjectionMatrix();
  if(floorReflector) floorReflector.getRenderTarget().setSize(innerWidth*DPR*.4,innerHeight*DPR*.4); postSize(); });
function tick(){
  if(qsShown){ clock.getDelta(); requestAnimationFrame(tick); return; }
  const dt=Math.min(clock.getDelta(),.05); clockT+=dt; const t=clockT;
  cGoal.set(PIECES[sel].glow); cNow.lerp(cGoal,1-Math.exp(-dt*2.2));
  /* keyboard walking */
  if(mode==='walk'){ const f=fwd(cam.yaw,0), r=V(-f.z,0,f.x); let mv=false;
    if(keys.w||keys.arrowup){cam.posG.addScaledVector(f,dt*2.1);mv=true;} if(keys.s||keys.arrowdown){cam.posG.addScaledVector(f,-dt*2.1);mv=true;}
    if(keys.a){cam.posG.addScaledVector(r,-dt*1.8);mv=true;} if(keys.d){cam.posG.addScaledVector(r,dt*1.8);mv=true;}
    if(keys.arrowleft){cam.yawG+=dt*1.6;} if(keys.arrowright){cam.yawG-=dt*1.6;}
    if(mv){ clampWalk(cam.posG); cam.rate=6; hideHint(); } }
  framingGoal();
  /* camera */
  const k=1-Math.exp(-dt*(RM?12:cam.rate));
  cam.pos.lerp(cam.posG,k); cam.yaw+=angD(cam.yawG,cam.yaw)*k; cam.pitch+=angD(cam.pitchG,cam.pitch)*k;
  const asp=innerWidth/innerHeight; camera.fov=narrow()?Math.min(72,58/Math.max(.55,asp)*.62+30):(mode==='fitting'?50:48); camera.updateProjectionMatrix();
  const F=fwd(cam.yaw,cam.pitch), Rt=V(-F.z,0,F.x).normalize();
  const half=Math.tan(camera.fov*Math.PI/360);
  /* frame the subject in the space the drawer leaves free: shift the lens, not the camera */
  const dOpen=(mode==='focus'||mode==='fitting'||mode==='core'||mode==='checkout'||mode==='vault'||mode==='booth')&&drawer.classList.contains('open');
  const vox=dOpen&&!narrow()?drawer.offsetWidth/2:0, voy=dOpen&&narrow()?drawer.offsetHeight*.42:0;
  viewOff.x+=(vox-viewOff.x)*k; viewOff.y+=(voy-viewOff.y)*k;
  if(Math.abs(viewOff.x)>.5||Math.abs(viewOff.y)>.5) camera.setViewOffset(innerWidth,innerHeight,viewOff.x,viewOff.y,innerWidth,innerHeight); else camera.clearViewOffset();
  camera.position.copy(cam.pos); camera.lookAt(tmp.copy(cam.pos).add(F));
  if(streetReflector){ const out=cam.pos.z>FZ-.6; streetReflector.visible=out; if(floorReflector&&mode!=='fitting') floorReflector.visible=cam.pos.z<FZ+1.2; }

  /* core */
  const beat=RM?.5:Math.pow(.5+.5*Math.sin(t*1.7),3);
  const bk=Math.floor((t*1.7-Math.PI/2)/(Math.PI*2)); if(bk!==beatK){ if(beatK>=0&&mode==='walk'&&cam.pos.distanceTo(CORE)<6) Sound.thump(.13); beatK=bk; }
  let sh=0; if(shockT>=0){ shockT+=dt; const q=shockT/1.6; if(q>=1){shockT=-1;shock.material.opacity=0;} else { sh=1-q; shock.scale.setScalar(.5+q*9); shock.material.opacity=.9*(1-q); shock.material.color.copy(cNow).lerp(white,.4);} }
  const coreOn=mode==='core'||(focusDisplay&&focusDisplay.kind==='core')?1:0; coreOpen+=(coreOn-coreOpen)*(1-Math.exp(-dt*3)); coreReading=Math.max(0,coreReading-dt);
  const coreHeld=focusDisplay&&focusDisplay.kind==='core'&&hero?1:0; coreHold+=(coreHeld-coreHold)*(1-Math.exp(-dt*2.5));
  lattice.scale.setScalar(1+.42*coreOpen+.5*coreHold); latMat.opacity=1-.86*coreHold; latMat.depthWrite=coreHold<.5; hemi.intensity=.42-.2*coreOpen; sun.intensity=.55-.25*coreOpen;
  heart.material.color.copy(cNow).lerp(white,.35).multiplyScalar(1.4+beat*.8+sh*3); heart.scale.setScalar((1+beat*.08+sh*.5)*(1-.85*(focusDisplay&&focusDisplay.kind==='core'&&hero?1:0)));
  halo1.material.color.copy(cNow); halo1.material.opacity=(.5+beat*.3+sh*.4)*(1-.9*coreHold); halo2.material.color.copy(cNow); halo2.material.opacity=.14*(1-.6*coreHold);
  halo1.position.z=-.25*coreHold; halo2.position.z=-.3*coreHold; beam.material.opacity=.05*(1-.6*coreHold);
  coreLight.color.copy(cNow); coreLight.intensity=1.2+beat*1.1+sh*5;
  corePool.material.color.copy(cNow); corePool.material.opacity=.2+beat*.12+sh*.3;
  beam.material.color.copy(cNow).lerp(white,.6); lattice.rotation.y+=dt*(RM?0:.15+sh*2.5+coreReading*6);
  boothSpot.color.copy(white).lerp(cNow,.15);

  /* hangers */
  SWAY.uT.value=t; const camV=tmp2.copy(cam.pos).sub(lastCam).length()/Math.max(dt,1e-3); lastCam.copy(cam.pos);
  SWAY.uAmp.value=RM?0:.0035+Math.min(.006,camV*.004);
  if(!pdrag&&hero){ if(spinGoal!==null){ spin+=(spinGoal-spin)*(1-Math.exp(-dt*5)); if(Math.abs(spinGoal-spin)<.002){spin=spinGoal;spinGoal=null;} } else { spin+=spinVel*dt; spinVel*=Math.exp(-dt*2.4); } }
  items.concat(booth.items,coreDisplay.items).forEach(it=>{
    const sp=RM?6:1.6; it.t+=Math.sign(it.tt-it.t)*Math.min(Math.abs(it.tt-it.t),dt*sp);
    const e=ease(it.t); it.hov+=((it===hoverItem?1:0)-it.hov)*(1-Math.exp(-dt*10));
    if(it.t<=0&&it.tt===0){ if(it.lod!==LO) setLod(it,LO); if(it.stackK>1) it.root.visible=false; }
    if(it.display.kind==='core'&&it!==hero&&it.t<.35&&it.tt===0) it.root.visible=false;
    const hn=V(Math.sin(it.restYaw),0,Math.cos(it.restYaw));
    tmp2.copy(it.rest).addScaledVector(it.display.kind==='rail'?V(it.display.side,0,0):it.display.normal||hn,it.hov*.06);
    it.root.position.lerpVectors(tmp2,it.heroPos,e); if(it.display.kind!=='core') it.root.position.y+=Math.sin(Math.PI*e)*.14;
    if(it.display.kind==='core'&&it===hero) it.root.position.y+=RM?0:Math.sin(t*1.3)*.02;
    if(it===hero&&it.display.kind==='core'&&!pdrag&&spinGoal===null&&Math.abs(spinVel)<.05&&!zoom) spin+=dt*(RM?0:.35);
    const hy=it===hero?it.heroYaw+spin:(it.leaveYaw!==undefined?it.leaveYaw:it.heroYaw);
    const ry=it.restYaw+it.hov*.25*(it.display.kind==='rail'?it.display.side:1);
    it.root.rotation.y=ry+angD(hy,ry)*e;
    if(it.t===0) it.leaveYaw=undefined;
    if(mode==='walk'&&camV>.35&&!RM&&it.root.visible&&it.display.kind!=='core'){ const d=it.root.position.distanceTo(cam.pos); if(d<1.3){ const k2=(1.3-d)*camV*dt; it.vz+=k2*1.6; it.vx+=(Math.random()-.5)*k2*1.2; } }
    it.vx=Math.max(-3,Math.min(3,it.vx)); it.vz=Math.max(-3,Math.min(3,it.vz));
    for(let n=Math.ceil(dt/.016),h=dt/n,q=0;q<n;q++){ it.vx+=(-26*it.sx-2.4*it.vx)*h; it.sx+=it.vx*h; it.vz+=(-26*it.sz-2.4*it.vz)*h; it.sz+=it.vz*h; }
    it.sx=Math.max(-1.2,Math.min(1.2,it.sx)); it.sz=Math.max(-1.2,Math.min(1.2,it.sz));
    it.root.rotation.x=it.sx*.1+(RM?0:Math.sin(t*.8+it.phase)*.004); it.root.rotation.z=it.sz*.08;
  });
  ghosts.forEach(g=>{ g.spin.rotation.y=(RM?0:t*.35)+g.phase; });
  updateExtras(dt,t);
  /* depth of field follows whatever you're holding */
  { let fg=0;
    if(hero&&(mode==='focus'||mode==='fitting')&&hero.t>.35){ fg=1;
      const P=zoom?hero.tee.localToWorld(tmp.copy(zoom.local)):hero.root.localToWorld(tmp.set(0,-TEE_DROP,0));
      POST.focusZ+=(Math.max(.2,P.sub(camera.position).dot(F))-POST.focusZ)*(1-Math.exp(-dt*14)); }
    POST.focus+=(fg*(zoom?.8:1)-POST.focus)*(1-Math.exp(-dt*3)); }
  renderFrame(t); postGovernor(dt);
  placeHotspots();
  requestAnimationFrame(tick);
}
window.__psb={snap(){ cam.pos.copy(cam.posG); cam.yaw=cam.yawG; cam.pitch=cam.pitchG; },openVault,openBoothDJ,Music,TOD,V,cam,aimAt,focusPiece,goStation,openCore,summon,backToFloor,enterFitting,POST,PIECES,get mode(){return mode},get hero(){return hero},renderer,scene,camera};
requestAnimationFrame(tick);
})();
